/**
 * Frame Configurator — Theme-native Konfigurator
 * Phase 0 POC: VariantIndex build, SVG preview, PP/size/price, ATC
 *
 * Dependencies: frame-preview-svg.js (must load before this)
 */
(function () {
  'use strict';

  /* ===================================================================
   * TRACKING
   *
   * Duenne Bruecke zu assets/framelin-tracking.js. Fehlt das Asset oder wirft
   * es, passiert nichts — der Konfigurator ist der wichtigste Teil des Shops
   * und darf an einem Tracking-Fehler nicht haengen bleiben.
   * =================================================================== */

  function track(event, params) {
    try {
      if (window.framelinTrack) window.framelinTrack(event, params);
    } catch (e) { /* absichtlich still */ }
  }

  function trackChanged(event, params) {
    try {
      if (window.framelinTrack) window.framelinTrack.changed(event, params);
    } catch (e) { /* absichtlich still */ }
  }

  function trackDebounced(event, params) {
    try {
      if (window.framelinTrack) window.framelinTrack.debounced(event, params);
    } catch (e) { /* absichtlich still */ }
  }

  /* ===================================================================
   * CONSTANTS — ported from custom-frame.tsx
   * =================================================================== */

  var CM_SIZE_THRESHOLDS = [
    48, 56, 64, 72, 80, 88, 96, 104, 112, 120,
    128, 136, 144, 152, 160, 168, 176, 184, 192, 200,
    208, 216, 224, 232, 240, 248, 256, 264, 272, 280,
    288, 296, 304, 312, 320, 328, 336, 344, 352, 360,
    368, 376, 384, 392, 400
  ];

  var PRESET_PASSPARTOUT_DIMENSIONS = {
    thin:     { top: 3.5, bottom: 4,   leftRight: 3.5 },
    standard: { top: 5.5, bottom: 6,   leftRight: 5.5 },
    wide:     { top: 8.5, bottom: 9,   leftRight: 8.5 }
  };

  var SHARED_MAT_COLOR_OPTIONS = [
    { color: 'naturweiss', displayName: 'Naturwei\u00DF', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Naturweiss_MSK-Naturweiss.png?v=1754908103' },
    { color: 'hellweiss', displayName: 'Hellwei\u00DF', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hellweiss_MSK-Hellweiss.png?v=1754908062' },
    { color: 'creme', displayName: 'Creme', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Creme_MSK-Creme.png?v=1754908112' },
    { color: 'schwarz', displayName: 'Schwarz', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Schwarz_MSK-Schwarz.png?v=1754908109' },
    { color: 'hellgrau', displayName: 'Hellgrau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hell-Grau_8159.png?v=1754908118' },
    { color: 'dunkelgrau', displayName: 'Dunkelgrau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Grau_8010.png?v=1754908119' },
    { color: 'beige', displayName: 'Beige', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Beige_8009.png?v=1754908118' },
    { color: 'braun', displayName: 'Braun', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Braun_8023.png?v=1754908118' },
    { color: 'dunkelbraun', displayName: 'Dunkelbraun', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Braun_8007.png?v=1754908118' },
    { color: 'babyblau', displayName: 'Babyblau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Baby-Blau_8051.png?v=1754908031' },
    { color: 'blau', displayName: 'Blau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Blau_8054.png?v=1754908118' },
    { color: 'dunkelblau', displayName: 'Dunkelblau', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Blau_8686.png?v=1754908118' },
    { color: 'hellgruen', displayName: 'Hellgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Hell-Gruen_8017.png?v=1754908118' },
    { color: 'beigegruen', displayName: 'Beigegr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Beige_Gruen_8030.png?v=1754908118' },
    { color: 'olivgruen', displayName: 'Olivgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Oliv-Gruen_8034.png?v=1754908118' },
    { color: 'dunkelgruen', displayName: 'Dunkelgr\u00FCn', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Dunkel-Gruen_8018.png?v=1754908119' },
    { color: 'rosa', displayName: 'Rosa', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Rosa_8064.png?v=1754908118' },
    { color: 'pink', displayName: 'Pink', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Pink_8028.png?v=1754908118' },
    { color: 'rot', displayName: 'Rot', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Rot_8699.png?v=1754908118' },
    { color: 'kirsch', displayName: 'Kirsch', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Kirsch-Rot_8151.png?v=1754908118' },
    { color: 'wein', displayName: 'Wein', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Wein-Rot_8016.png?v=1754908118' },
    { color: 'gelb', displayName: 'Gelb', imageUrl: 'https://cdn.shopify.com/s/files/1/0886/5421/7558/files/Gelb_8695.png?v=1754903609' }
  ];

  var CART_SVG_STORAGE_KEY = 'framelin-cart-svg-render-data-v1';
  var CART_SVG_STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  /* ===================================================================
   * TYPE CARD ORDERING
   * =================================================================== */

  /** Canonical display order for frame type cards (normalized, lowercase, no parens). */
  var TYPE_CARD_ORDER = [
    'digitaler upload',
    'digitale leinwand',
    'papierarbeit',
    'leinwand nicht aufgespannt',
    'leinwand aufgespannt'
  ];

  var PAPER_TYPE_KEYS = ['digitaler upload', 'papierarbeit'];
  var CANVAS_TYPE_KEYS = ['digitale leinwand', 'leinwand nicht aufgespannt', 'leinwand aufgespannt'];

  function classifyProductTypes(typeValues) {
    var hasPaper = false, hasCanvas = false;
    for (var i = 0; i < typeValues.length; i++) {
      var nk = normalizeTypeKey(typeValues[i]);
      if (PAPER_TYPE_KEYS.indexOf(nk) !== -1) hasPaper = true;
      if (CANVAS_TYPE_KEYS.indexOf(nk) !== -1) hasCanvas = true;
    }
    if (hasPaper && hasCanvas) return 'full';
    if (hasPaper) return 'paper-only';
    if (hasCanvas) return 'canvas-only';
    return 'unknown';
  }

  /** Normalize a type value for ordering: lowercase, strip parens, collapse whitespace. */
  function normalizeTypeKey(raw) {
    return (raw || '').toLowerCase().replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
  }

  /** Sort type values array according to TYPE_CARD_ORDER. Unknown types go last. */
  function sortTypeValues(arr) {
    return arr.slice().sort(function (a, b) {
      var ia = TYPE_CARD_ORDER.indexOf(normalizeTypeKey(a));
      var ib = TYPE_CARD_ORDER.indexOf(normalizeTypeKey(b));
      if (ia === -1) ia = 999;
      if (ib === -1) ib = 999;
      return ia - ib;
    });
  }

  /* ===================================================================
   * UTILITIES
   * =================================================================== */

  function getUmfangSizeLabel(umfang) {
    for (var i = 0; i < CM_SIZE_THRESHOLDS.length; i++) {
      if (umfang <= CM_SIZE_THRESHOLDS[i]) return 'bis ' + CM_SIZE_THRESHOLDS[i] + ' cm';
    }
    return 'bis ' + CM_SIZE_THRESHOLDS[CM_SIZE_THRESHOLDS.length - 1] + ' cm';
  }

  /**
   * Normalize a PP type value to canonical form.
   * Canonical: 'ohne', 'einfach', 'freigestellt', 'hintergrundkarton', 'schwebend'
   */
  function normalizePPType(raw) {
    var val = (raw || '').toLowerCase().trim();
    if (val === 'standard' || val === 'normal' || val === 'aufgelegt') return 'einfach';
    if (val === 'innenliegend' || val === 'innenligend' || val === 'inner') return 'freigestellt';
    if (val === 'without' || val === 'none' || val === 'kein' || val === 'keine') return 'ohne';
    if (val === 'hintergrund' || val === 'hintergrundkarton' || val === 'backing') return 'hintergrundkarton';
    if (val === 'floating' || val === 'schwebend') return 'schwebend';
    if (val === '' || val === 'ohne') return 'ohne';
    return val; // 'einfach', 'freigestellt', 'hintergrundkarton', 'schwebend' pass through
  }

  /**
   * Normalize a size key to canonical "bis X cm" format.
   * Handles variations like "bis 144cm", "Bis 144 cm", " bis  144  cm ".
   */
  function normalizeSizeKey(raw) {
    var val = (raw || '').toLowerCase().trim();
    var match = val.match(/^bis\s+(\d+)\s*cm$/);
    if (match) {
      return 'bis ' + match[1] + ' cm';
    }
    return val;
  }

  /**
   * Build VariantIndex from Liquid-provided variant array.
   * Prefers variant.options array (from Liquid), falls back to title parsing.
   * Variant title format: "Typ / Gr\u00f6\u00dfe / Passepartout"
   * Variant options format: ["Leonardo", "bis 144 cm", "Ohne"]
   * Returns: { frameType: { sizeLabel: { ppType: { id, price } } } }
   * If no frame type option exists, uses '_default' as key.
   */
  function buildVariantIndex(variants) {
    var index = {};
    var parsed = 0;
    var skipped = 0;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var typeValue = '_default';
      var sizeValue = '';
      var ppValue = '';

      // Strategy 1: Use options array (most reliable — from Liquid variant.options)
      if (v.options && Array.isArray(v.options) && v.options.length >= 2) {
        if (v.options.length >= 3) {
          // 3 options: [Typ, Gr\u00f6\u00dfe, Passepartout]
          typeValue = (v.options[0] || '').trim();
          sizeValue = (v.options[1] || '').toLowerCase().trim();
          ppValue = (v.options[2] || '').toLowerCase().trim();
        } else if (v.options.length === 2) {
          // 2 options: [Gr\u00f6\u00dfe, Passepartout]
          sizeValue = (v.options[0] || '').toLowerCase().trim();
          ppValue = (v.options[1] || '').toLowerCase().trim();
        }
      }

      // Strategy 2: Fallback to title parsing
      if (!sizeValue) {
        var title = (v.title || '').toLowerCase();
        var parts = title.split('/').map(function (s) { return s.trim(); });

        if (parts.length >= 3) {
          typeValue = parts[0];
          sizeValue = parts[1];
          ppValue = parts[2];
        } else if (parts.length === 2) {
          sizeValue = parts[0];
          ppValue = parts[1];
        }
      }

      if (!sizeValue) {
        console.warn('[FrameConfigurator] Skipped variant (no size):', v.title, '| options:', JSON.stringify(v.options));
        skipped++;
        continue;
      }

      // Normalize keys at index-build time
      sizeValue = normalizeSizeKey(sizeValue);
      ppValue = normalizePPType(ppValue);

      if (!index[typeValue]) {
        index[typeValue] = {};
      }
      if (!index[typeValue][sizeValue]) {
        index[typeValue][sizeValue] = {};
      }
      index[typeValue][sizeValue][ppValue] = {
        id: v.id,
        price: v.price / 100 // Liquid price is in cents
      };
      parsed++;
    }

    var typeKeys = Object.keys(index);
    console.log('[FrameConfigurator] VariantIndex built:', parsed, 'variants parsed,', skipped, 'skipped. Types:', typeKeys.join(', '));
    return index;
  }

  /**
   * Fetch ALL variants for a product via Shopify Storefront API (GraphQL).
   * Uses cursor-based pagination to bypass the 250-variant Liquid/REST limit.
   * Returns a Promise resolving to an array in the same format as Liquid variants:
   * { id: Number, price: Number (cents), options: [String, String, ...] }
   */
  function fetchAllVariantsViaStorefrontAPI(productId, token, apiVersion) {
    if (!token) return Promise.reject(new Error('No Storefront API token'));

    var gid = String(productId);
    if (gid.indexOf('gid://') !== 0) gid = 'gid://shopify/Product/' + gid;

    var shopDomain = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    var endpoint = 'https://' + shopDomain + '/api/' + (apiVersion || '2024-10') + '/graphql.json';
    var allVariants = [];

    function fetchPage(cursor) {
      var afterClause = cursor ? ', after: "' + cursor + '"' : '';
      var query = '{ product(id: "' + gid + '") {'
        + ' variants(first: 250' + afterClause + ') {'
        + '  edges { cursor node { id price { amount } selectedOptions { name value } } }'
        + '  pageInfo { hasNextPage }'
        + ' }'
        + '} }';

      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query })
      })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.errors) {
          console.error('[FrameConfigurator] Storefront API errors:', json.errors);
          throw new Error(json.errors[0].message);
        }
        if (!json.data || !json.data.product) {
          throw new Error('Product not found in Storefront API');
        }
        var variants = json.data.product.variants;
        var edges = variants.edges;

        for (var i = 0; i < edges.length; i++) {
          var node = edges[i].node;
          var numericId = parseInt(node.id.split('/').pop(), 10);
          var options = [];
          for (var j = 0; j < node.selectedOptions.length; j++) {
            options.push(node.selectedOptions[j].value);
          }
          var priceInCents = Math.round(parseFloat(node.price.amount) * 100);
          allVariants.push({ id: numericId, price: priceInCents, options: options });
        }

        if (variants.pageInfo.hasNextPage && edges.length > 0) {
          return fetchPage(edges[edges.length - 1].cursor);
        }
        return allVariants;
      });
    }

    return fetchPage(null);
  }

  function getSizeCategory(imageWidth, imageHeight, matWidth, frameWidthMM, ppType, individualSizes) {
    var isNoPP = ppType === 'ohne' || matWidth === 'ohne';
    var matTopCM = 0, matBottomCM = 0, matLeftRightCM = 0;

    if (!isNoPP) {
      if (matWidth === 'individual' && individualSizes) {
        matTopCM = individualSizes.top || 0;
        matBottomCM = individualSizes.bottom || 0;
        matLeftRightCM = individualSizes.leftRight || 0;
      } else {
        var preset = PRESET_PASSPARTOUT_DIMENSIONS[matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
        matTopCM = preset.top;
        matBottomCM = preset.bottom;
        matLeftRightCM = preset.leftRight;
      }
    }

    var falzWidth = isNoPP ? imageWidth : imageWidth + 2 * matLeftRightCM;
    var falzHeight = isNoPP ? imageHeight : imageHeight + matTopCM + matBottomCM;
    var falzmass = 2 * (falzWidth + falzHeight);

    return getUmfangSizeLabel(falzmass);
  }

  function lookupVariant(variantIndex, frameType, sizeCategory, ppType) {
    var typeMap = variantIndex[frameType];
    if (!typeMap) return null;

    var sizeKey = normalizeSizeKey(sizeCategory);
    var ppKey = normalizePPType(ppType);

    var sizeMap = typeMap[sizeKey];
    if (!sizeMap) return null;

    if (sizeMap[ppKey]) return sizeMap[ppKey];

    // Fallback: ohne
    if (sizeMap['ohne']) return sizeMap['ohne'];
    return null;
  }

  /**
   * Analyse why a variant is unavailable and return a helpful customer-facing hint.
   * Returns null when no hint is needed (variant exists or type is lazy-loading).
   */
  function getVariantHint(vIndex, frameType, sizeCategory, ppType,
                          imgW, imgH, frameBreiteMM) {
    var typeMap = vIndex[frameType];
    if (!typeMap) return null; // Lazy loading → "Lade Preise…" handles this

    var sizeKey = normalizeSizeKey(sizeCategory);
    var ppKey = normalizePPType(ppType);
    var sizeMap = typeMap[sizeKey];

    // Size exists but neither PP type nor "ohne" available → rare edge case
    if (sizeMap && !sizeMap[ppKey] && !sizeMap['ohne']) {
      return 'Diese Kombination ist leider nicht verf\u00fcgbar.';
    }

    // Size doesn't exist → find max available size for this type
    if (!sizeMap) {
      var maxSizeNum = 0;
      var allSizeKeys = Object.keys(typeMap);
      for (var i = 0; i < allSizeKeys.length; i++) {
        var m = allSizeKeys[i].match(/(\d+)/);
        if (m) {
          var n = parseInt(m[1], 10);
          if (n > maxSizeNum) maxSizeNum = n;
        }
      }

      // If PP is active: check whether "ohne" would fit → suggest reducing PP
      if (ppKey !== 'ohne') {
        var cW = Math.max(10, Math.min(110, imgW));
        var cH = Math.max(10, Math.min(110, imgH));
        var sizeCatOhne = getSizeCategory(cW, cH, 'ohne', frameBreiteMM, 'ohne', null);
        var sizeKeyOhne = normalizeSizeKey(sizeCatOhne);
        if (typeMap[sizeKeyOhne]) {
          return 'In dieser Gr\u00f6\u00dfe mit Passepartout leider nicht verf\u00fcgbar (max. '
            + maxSizeNum + ' cm Umfang). W\u00e4hle ein schmaleres Passepartout oder \u201eOhne\u201c.';
        }
      }

      // Even without PP it's too large
      return 'Leider nicht in dieser Gr\u00f6\u00dfe verf\u00fcgbar. Maximal bis '
        + maxSizeNum + ' cm Umfang verf\u00fcgbar. Bitte w\u00e4hle kleinere Ma\u00dfe.';
    }

    return null; // Variant exists, no hint needed
  }

  /* Delivery prefix – declared at IIFE scope so getDeliveryEstimate() can access it.
     Updated inside init() once cart-settings JSON is available. */
  var _deliveryPrefix = 'Lieferung ca.';

  function formatPriceFromEuros(euros) {
    return euros.toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function addBusinessDays(fromDate, days) {
    var d = new Date(fromDate);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatDateRange(startDate, endDate) {
    var months = ['Januar','Februar','M\u00E4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    if (startDate.getMonth() === endDate.getMonth()) {
      return startDate.getDate() + '. \u2013 ' + endDate.getDate() + '. ' + months[endDate.getMonth()];
    }
    return startDate.getDate() + '. ' + months[startDate.getMonth()] + ' \u2013 ' + endDate.getDate() + '. ' + months[endDate.getMonth()];
  }

  function formatSingleDate(d) {
    var months = ['Januar','Februar','M\u00E4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    return d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function getDeliveryEstimate(isSendIn) {
    var deliveryConfig = { min: 7, max: 10 };
    try {
      // Prefer configurator settings section, fallback to inline config
      var cfgEl = document.getElementById('fc-configurator-settings');
      if (cfgEl) {
        var cfg = JSON.parse(cfgEl.textContent);
        if (cfg.delivery) deliveryConfig = cfg.delivery;
      } else {
        var el = document.getElementById('frame-delivery-config');
        if (el) deliveryConfig = JSON.parse(el.textContent);
      }
    } catch (e) {}
    var now = new Date();
    var minDays = deliveryConfig.min || 7;
    var maxDays = deliveryConfig.max || 10;

    if (isSendIn) {
      // Send-in: customer sends art within 3 business days, then we need 7-10 Werktage after receiving
      var sendByDate = addBusinessDays(now, 3);
      var deliveryStart = addBusinessDays(sendByDate, minDays);
      var deliveryEnd = addBusinessDays(sendByDate, maxDays);
      return {
        headline: (_deliveryPrefix || 'Lieferung ca.') + ' ' + formatDateRange(deliveryStart, deliveryEnd),
        sendin: 'Sende uns dein Bild bis ' + formatSingleDate(sendByDate) + ' \u2013 wir rahmen es in ' + minDays + '\u2013' + maxDays + ' Werktagen'
      };
    }

    // Digital types: straightforward delivery estimate
    var start = addBusinessDays(now, minDays);
    var end = addBusinessDays(now, maxDays);
    return {
      headline: (_deliveryPrefix || 'Lieferung ca.') + ' ' + formatDateRange(start, end),
      sendin: null
    };
  }

  function formatMatNum(n) {
    return String(n).replace('.', ',');
  }

  function formatMatSizes(top, leftRight, bottom) {
    if (top === bottom && top === leftRight) {
      return formatMatNum(top) + ' cm';
    }
    return 'Oben ' + formatMatNum(top) + ' cm \u00B7 Seiten ' + formatMatNum(leftRight) + ' cm \u00B7 Unten ' + formatMatNum(bottom) + ' cm';
  }

  function getMatPresetDescription(key) {
    var preset = PRESET_PASSPARTOUT_DIMENSIONS[key];
    if (!preset) return '';
    return formatMatSizes(preset.top, preset.leftRight, preset.bottom);
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function persistCartSvgRenderData(lineItemKey, data) {
    try {
      var raw = localStorage.getItem(CART_SVG_STORAGE_KEY);
      var store = raw ? JSON.parse(raw) : {};
      var now = Date.now();
      Object.keys(store).forEach(function (key) {
        if (now - (store[key].updatedAt || 0) > CART_SVG_STORAGE_TTL_MS) delete store[key];
      });
      store[lineItemKey] = { updatedAt: now, data: data };
      localStorage.setItem(CART_SVG_STORAGE_KEY, JSON.stringify(store));
    } catch (e) {
      try {
        sessionStorage.setItem(CART_SVG_STORAGE_KEY, JSON.stringify({
          [lineItemKey]: { updatedAt: Date.now(), data: data }
        }));
      } catch (_) { /* ignore */ }
    }
  }

  /* ===================================================================
   * MAIN CONFIGURATOR
   * =================================================================== */

  function init() {
    var dataEl = document.getElementById('frame-product-data');
    if (!dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[FrameConfigurator] Failed to parse product data:', e);
      return;
    }

    console.log('[FrameConfigurator] Product data loaded:', productData.title, '| Variants:', productData.variants.length, '| FrameLR:', productData.frameImageLR ? 'SET' : 'EMPTY', '| FrameTB:', productData.frameImageTB ? 'SET' : 'EMPTY');

    // Merge admin-configured type card label overrides
    var typeCardSettingsEl = document.getElementById('frame-type-card-settings');
    if (typeCardSettingsEl) {
      try {
        var overrides = JSON.parse(typeCardSettingsEl.textContent);
        for (var key in overrides) {
          if (overrides.hasOwnProperty(key)) {
            var ov = overrides[key];
            if (ov.title || ov.desc) {
              if (!TYPE_CARD_META[key]) TYPE_CARD_META[key] = {};
              if (ov.title) TYPE_CARD_META[key].title = ov.title;
              if (ov.desc) TYPE_CARD_META[key].desc = ov.desc;
            }
          }
        }
      } catch (e) {
        console.warn('[FrameConfigurator] Failed to parse type card settings:', e);
      }
    }

    // Parse Storefront API config for >250 variant fallback
    var storefrontConfigEl = document.getElementById('frame-storefront-config');
    var storefrontConfig = { token: '', apiVersion: '2024-10' };
    if (storefrontConfigEl) {
      try { storefrontConfig = JSON.parse(storefrontConfigEl.textContent); } catch (e) { /* ignore */ }
    }

    // Parse cross-link config for paper↔canvas product linking
    var crossLinkConfigEl = document.getElementById('frame-cross-link-config');
    var crossLinkConfig = { canvasProductHandle: '', paperProductHandle: '' };
    if (crossLinkConfigEl) {
      try { crossLinkConfig = JSON.parse(crossLinkConfigEl.textContent); } catch (e) { /* ignore */ }
    }

    var variantIndex = buildVariantIndex(productData.variants);

    // Parse product list for product switcher (pre-rendered by Liquid from collection)
    var productsListEl = document.getElementById('frame-products-list');
    var productsList = [];
    if (productsListEl) {
      try {
        productsList = JSON.parse(productsListEl.textContent);
      } catch (e) {
        console.warn('[FrameConfigurator] Failed to parse products list:', e);
      }
    }

    // Build variant indexes for all products in the switcher list
    var allProductVariantIndexes = {};
    for (var pi = 0; pi < productsList.length; pi++) {
      var prod = productsList[pi];
      if (prod.variants && prod.variants.length > 0) {
        allProductVariantIndexes[prod.handle] = buildVariantIndex(prod.variants);
      }
    }

    /**
     * Lazy-fetch products beyond Shopify Liquid's 50-product cap on collection.products.
     * Reads frame-collection-meta to know the true total, then fetches missing products
     * via the public collection products.json endpoint and merges them in.
     * Metafield-derived fields (frameImageLR/TB, frameBreiteMM/HoeheMM, farbBeschreibung)
     * are not exposed by that endpoint, so we fall back to defaults — variant lookup,
     * featured image and color tags still work, which is what the switcher needs.
     */
    function lazyLoadMissingFrameProducts() {
      var metaEl = document.getElementById('frame-collection-meta');
      if (!metaEl) return;
      var meta;
      try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }
      if (!meta || !meta.handle || !meta.totalCount) return;
      if (meta.totalCount <= productsList.length) return;

      var existingHandles = {};
      for (var i = 0; i < productsList.length; i++) existingHandles[productsList[i].handle] = true;

      fetch('/collections/' + encodeURIComponent(meta.handle) + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var added = 0;
          var products = (data && data.products) || [];
          for (var j = 0; j < products.length; j++) {
            var p = products[j];
            if (existingHandles[p.handle]) continue;

            var convertedVariants = [];
            var variants = p.variants || [];
            for (var k = 0; k < variants.length; k++) {
              var v = variants[k];
              convertedVariants.push({
                id: v.id,
                price: Math.round(parseFloat(v.price || '0') * 100),
                options: [v.option1 || '', v.option2 || '', v.option3 || '']
              });
            }

            var convertedOptions = [];
            var opts = p.options || [];
            for (var oi = 0; oi < opts.length; oi++) {
              var opt = opts[oi];
              convertedOptions.push({
                name: opt.name || '',
                position: opt.position || (oi + 1),
                values: opt.values || []
              });
            }

            var convertedImages = [];
            var imgs = p.images || [];
            for (var ii = 0; ii < imgs.length; ii++) {
              var img = imgs[ii];
              convertedImages.push({
                url: img.src || '',
                alt: img.alt || p.title,
                width: img.width || 0,
                height: img.height || 0
              });
            }

            var featured = '';
            if (p.images && p.images.length) featured = p.images[0].src || '';

            var entry = {
              handle: p.handle,
              title: p.title || '',
              vendor: p.vendor || '',
              description: p.body_html ? p.body_html.replace(/<[^>]*>/g, '').slice(0, 300) : '',
              productId: String(p.id || ''),
              url: '/products/' + p.handle,
              priceMin: convertedVariants.length ? convertedVariants[0].price : 0,
              featuredImage: featured,
              frameImageLR: '',
              frameImageTB: '',
              frameBreiteMM: 24,
              frameHoeheMM: 15,
              farbBeschreibung: '',
              tags: p.tags || [],
              images: convertedImages,
              options: convertedOptions,
              variants: convertedVariants,
              variantsCount: convertedVariants.length
            };

            productsList.push(entry);
            allProductVariantIndexes[entry.handle] = buildVariantIndex(convertedVariants);
            existingHandles[entry.handle] = true;
            added++;
          }

          if (added > 0) {
            console.log('[FrameConfigurator] Lazy-loaded', added, 'additional frame products from collection.');
            if (typeof renderProductSwitcher === 'function') renderProductSwitcher();

            // Now fetch metafields (frame image + dimensions) via Storefront API GraphQL.
            // /products.json doesn't include metafields, so without this the new frames
            // render with default 24×15 mm and no preview image.
            var addedHandles = [];
            for (var ai = 0; ai < productsList.length; ai++) {
              var pp = productsList[ai];
              if (!pp.frameImageLR && pp.frameBreiteMM === 24 && pp.frameHoeheMM === 15) {
                addedHandles.push(pp.handle);
              }
            }
            if (addedHandles.length && storefrontConfig.token) {
              fetchFrameMetafields(addedHandles, storefrontConfig.token, storefrontConfig.apiVersion)
                .then(function (metas) {
                  var changed = 0;
                  for (var bi = 0; bi < productsList.length; bi++) {
                    var bp = productsList[bi];
                    var meta = metas[bp.handle];
                    if (!meta) continue;
                    if (meta.frameImageLR) bp.frameImageLR = meta.frameImageLR;
                    if (meta.frameImageTB) bp.frameImageTB = meta.frameImageTB;
                    if (meta.frameBreiteMM) bp.frameBreiteMM = meta.frameBreiteMM;
                    if (meta.frameHoeheMM) bp.frameHoeheMM = meta.frameHoeheMM;
                    if (meta.farbBeschreibung) bp.farbBeschreibung = meta.farbBeschreibung;
                    changed++;
                  }
                  if (changed > 0) {
                    console.log('[FrameConfigurator] Hydrated metafields for', changed, 'lazy-loaded products.');
                    if (typeof renderProductSwitcher === 'function') renderProductSwitcher();
                  }
                })
                .catch(function (e) { console.warn('[FrameConfigurator] Failed to hydrate metafields:', e); });
            }
          }
        })
        .catch(function (err) {
          console.warn('[FrameConfigurator] Failed to lazy-load additional frame products:', err);
        });
    }

    /**
     * Batch-fetch frame metafields (bild_url, frame_url_tb, breite, hohe, farb_beschreibung)
     * for many product handles in a single GraphQL request using aliases.
     * Returns a Promise resolving to { handle: { frameImageLR, frameImageTB, frameBreiteMM, frameHoeheMM, farbBeschreibung } }.
     */
    function fetchFrameMetafields(handles, token, apiVersion) {
      if (!token || !handles || !handles.length) return Promise.resolve({});
      var shopDomain = (window.Shopify && window.Shopify.shop) || window.location.hostname;
      var endpoint = 'https://' + shopDomain + '/api/' + (apiVersion || '2024-10') + '/graphql.json';

      var parts = [];
      for (var i = 0; i < handles.length; i++) {
        var safe = String(handles[i]).replace(/"/g, '\\"');
        parts.push(
          'p' + i + ': product(handle: "' + safe + '") {'
          + ' bildUrl: metafield(namespace: "custom", key: "bild_url") { value }'
          + ' frameUrlTb: metafield(namespace: "custom", key: "frame_url_tb") { value }'
          + ' breite: metafield(namespace: "custom", key: "breite") { value }'
          + ' hohe: metafield(namespace: "custom", key: "hohe") { value }'
          + ' farbBeschreibung: metafield(namespace: "custom", key: "farb_beschreibung") { value }'
          + '}'
        );
      }
      var query = '{ ' + parts.join(' ') + ' }';

      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query: query })
      })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var out = {};
        if (!json || !json.data) return out;
        for (var k = 0; k < handles.length; k++) {
          var p = json.data['p' + k];
          if (!p) continue;
          var lr = p.bildUrl && p.bildUrl.value ? p.bildUrl.value : '';
          var tb = p.frameUrlTb && p.frameUrlTb.value ? p.frameUrlTb.value : '';
          out[handles[k]] = {
            frameImageLR: lr,
            frameImageTB: tb || lr,
            frameBreiteMM: p.breite && p.breite.value ? parseInt(p.breite.value, 10) : 0,
            frameHoeheMM: p.hohe && p.hohe.value ? parseInt(p.hohe.value, 10) : 0,
            farbBeschreibung: p.farbBeschreibung && p.farbBeschreibung.value ? p.farbBeschreibung.value : ''
          };
        }
        return out;
      });
    }

    lazyLoadMissingFrameProducts();

    // --- Truncation detection + lazy variant loading ---
    // Shopify Liquid & REST APIs return max 250 variants. options_with_values always
    // lists ALL types, even when variants are truncated. By comparing defined types
    // vs types present in the variantIndex we detect truncation reliably.
    var _fetchingVariants = {}; // in-flight Storefront API fetches: { handle: Promise }

    /**
     * Check whether a product's variant data is truncated (>250 variants).
     * Compares type values from options_with_values (always complete) against
     * the types actually present in the given variantIndex.
     */
    function isProductTruncated(optionsArray, vIndex) {
      var typeOpt = null;
      if (optionsArray && Array.isArray(optionsArray)) {
        for (var i = 0; i < optionsArray.length; i++) {
          var n = (optionsArray[i].name || '').toLowerCase();
          if (n === 'typ' || n === 'type' || n === 'rahmentyp') {
            typeOpt = optionsArray[i];
            break;
          }
        }
      }
      if (!typeOpt || !typeOpt.values) return false;
      for (var j = 0; j < typeOpt.values.length; j++) {
        if (typeOpt.values[j] !== '_default' && !vIndex[typeOpt.values[j]]) {
          return true; // at least one defined type has no variant data
        }
      }
      return false;
    }

    /**
     * Lazy-load all variants for a product via Storefront API.
     * Uses a per-handle cache and in-flight dedup to avoid duplicate requests.
     * @param {string} handle - Product handle
     * @param {number|string} productId - Shopify product ID
     * @param {Function} callback - Called with the rebuilt variantIndex
     */
    function lazyFetchVariants(handle, productId, callback) {
      // Already fully loaded → use cache
      if (allProductVariantIndexes[handle + '__full']) {
        callback(allProductVariantIndexes[handle]);
        return;
      }
      // Already fetching → piggyback on existing request
      if (_fetchingVariants[handle]) {
        _fetchingVariants[handle].then(function () {
          callback(allProductVariantIndexes[handle]);
        });
        return;
      }
      // Start new fetch
      console.log('[FrameConfigurator] Lazy-loading variants for:', handle);
      _fetchingVariants[handle] = fetchAllVariantsViaStorefrontAPI(productId, storefrontConfig.token, storefrontConfig.apiVersion)
        .then(function (fullVariants) {
          console.log('[FrameConfigurator] Storefront API returned', fullVariants.length, 'variants for', handle);
          allProductVariantIndexes[handle] = buildVariantIndex(fullVariants);
          allProductVariantIndexes[handle + '__full'] = true;
          delete _fetchingVariants[handle];
          callback(allProductVariantIndexes[handle]);
        })
        .catch(function (err) {
          console.error('[FrameConfigurator] Lazy-fetch failed for', handle + ':', err.message);
          delete _fetchingVariants[handle];
        });
    }

    // Determine frame type options from product data
    var frameTypeOption = null;
    var frameTypeValues = [];
    if (productData.options && Array.isArray(productData.options)) {
      for (var oi = 0; oi < productData.options.length; oi++) {
        var optName = (productData.options[oi].name || '').toLowerCase();
        if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
          frameTypeOption = productData.options[oi];
          frameTypeValues = frameTypeOption.values || [];
          break;
        }
      }
    }

    // Detect truncation: types in options_with_values vs types in variantIndex
    var allTypeValues = frameTypeValues.slice();
    var productIsTruncated = isProductTruncated(productData.options, variantIndex);

    if (productIsTruncated && storefrontConfig.token) {
      // Truncated product WITH Storefront API token → show ALL type cards.
      // Missing types will be lazy-loaded via Storefront API on type-card click.
      frameTypeValues = sortTypeValues(allTypeValues);
      console.log('[FrameConfigurator] Truncated product detected. Showing all', frameTypeValues.length,
        'types. Missing types will lazy-load on click.');
    } else {
      // Normal product or no API token → filter to types with actual variant data
      frameTypeValues = sortTypeValues(frameTypeValues.filter(function (tv) {
        return tv === '_default' || variantIndex[tv];
      }));
      var removedTypes = allTypeValues.filter(function (tv) { return frameTypeValues.indexOf(tv) === -1; });
      if (removedTypes.length > 0) {
        console.warn('[FrameConfigurator] Filtered out types with no variants:', removedTypes.join(', '));
        if (!storefrontConfig.token) {
          console.warn('[FrameConfigurator] No Storefront API token configured. Some types may be missing.');
        }
      }
    }

    // For truncated products, pick initial type from types that have loaded variant data
    var initialType = frameTypeValues.length > 0 ? frameTypeValues[0] : '_default';
    if (productIsTruncated) {
      for (var iType = 0; iType < frameTypeValues.length; iType++) {
        if (variantIndex[frameTypeValues[iType]]) {
          initialType = frameTypeValues[iType];
          break;
        }
      }
    }

    // State
    var state = {
      frameType: initialType,
      ppType: 'ohne',
      matWidth: 'standard',
      matColor: 'naturweiss',
      imageWidth: 30,
      imageHeight: 40,
      individualSizes: { top: 5.5, bottom: 6, leftRight: 5.5 },
      suspension: 'zacken',
      currentVariant: null,
      currentPrice: null,
      imageUrl: '',
      imageAspectRatio: null,
      localBlobUrl: null,
      isPlaceholder: false
    };

    // Full-size PP colors (available up to max dimensions)
    var FULL_SIZE_MAT_COLORS = ['naturweiss', 'hellweiss', 'creme', 'schwarz'];

    // Type card display labels (conversion-optimized descriptions)
    var TYPE_CARD_META = {
      'Digitaler Upload': {
        title: 'Papierdruck (Digitaler Upload)',
        desc: 'Wir drucken dein Bild auf Papier und rahmen es.'
      },
      'Digitale Leinwand': {
        title: 'Leinwanddruck (Digitaler Upload)',
        desc: 'Wir drucken dein Bild auf Leinwand und rahmen es'
      },
      'Leinwand aufgespannt': {
        title: 'Aufgespannte Leinwand',
        desc: 'Du sendest uns deine Aufgespannte Leinwand und wir rahmen Sie'
      },
      'Leinwand (aufgespannt)': {
        title: 'Aufgespannte Leinwand',
        desc: 'Du sendest uns deine Aufgespannte Leinwand und wir rahmen Sie'
      },
      'Leinwand nicht aufgespannt': {
        title: 'Leinwand (nicht aufgespannt)',
        desc: 'Du sendest uns deine nicht aufgespannte Leinwand zu und wir rahmen sie'
      },
      'Leinwand (nicht aufgespannt)': {
        title: 'Leinwand (nicht aufgespannt)',
        desc: 'Du sendest uns deine nicht aufgespannte Leinwand zu und wir rahmen sie'
      },
      'Papierarbeit': {
        title: 'Papierarbeit',
        desc: 'Du sendest uns deine Papierarbeit und wir rahmen Sie ein'
      },
      'Objektrahmung': {
        title: 'Objekt einsenden',
        desc: 'Du sendest dein Objekt an uns (nur bis 1,5 cm Tiefe)'
      }
    };

    // Suspension descriptions
    var SUSPENSION_INFO = {
      zacken: 'Ein Zacken in der Mitte der oberen Leiste. Nur bis 50cm Breite verf\u00fcgbar.',
      seil: 'Sehr leicht zum Aufh\u00e4ngen und einfach auszurichten. Das Bild kann oben leicht von der Wand abkippen. Erst ab 30cm Breite verf\u00fcgbar.',
      wallbuddies: 'Zwei-Punkt-Aufh\u00e4ngung in den oberen Ecken. Sehr stabil, aber etwas aufw\u00e4ndiger beim Aufh\u00e4ngen. Erst ab 30cm Breite verf\u00fcgbar.'
    };

    // DOM refs
    var typeGroup = document.getElementById('fc-step-type');
    var typeCardsContainer = document.getElementById('fc-type-cards');
    var crossLinkEl = document.getElementById('fc-cross-link');
    var crossLinkTrigger = document.getElementById('fc-cross-link-trigger');
    var crossLinkText = document.getElementById('fc-cross-link-text');
    var crossLinkCards = document.getElementById('fc-cross-link-cards');
    var productSwitcherGroup = document.getElementById('fc-product-switcher-group');
    var productCardsEl = document.getElementById('fc-product-cards');
    var previewContainer = document.getElementById('fc-preview-container');
    var ppTypeOptions = document.getElementById('fc-pp-type-options');
    var ppWidthGroup = document.getElementById('fc-pp-width-group');
    var ppWidthOptions = document.getElementById('fc-pp-width-options');
    var ppWidthHint = document.getElementById('fc-pp-width-hint');
    var ppColorGroup = document.getElementById('fc-pp-color-group');
    var ppColorGrid = document.getElementById('fc-pp-color-grid');
    var ppColorHint = document.getElementById('fc-pp-color-hint');
    var individualInputs = document.getElementById('fc-individual-inputs');
    var widthInput = document.getElementById('fc-width');
    var heightInput = document.getElementById('fc-height');
    var sizeSliderWrap = document.getElementById('fc-size-slider');
    var sizeSliderInput = document.getElementById('fc-size-slider-input');
    var sizeCategoryEl = document.getElementById('fc-size-category');
    var priceEl = document.getElementById('fc-price');
    var overallSizeEl = document.getElementById('fc-overall-size');
    var summaryDetailEl = document.getElementById('fc-summary-detail');
    var deliveryEl = document.getElementById('fc-delivery');
    var deliveryHeadlineEl = document.getElementById('fc-delivery-headline');
    var deliverySendinEl = document.getElementById('fc-delivery-sendin');
    var atcButton = document.getElementById('fc-add-to-cart');
    var atcError = document.getElementById('fc-atc-error');
    var variantHintEl = document.getElementById('fc-variant-hint');
    var dimensionsHint = document.getElementById('fc-dimensions-hint');
    var dimensionsError = document.getElementById('fc-dimensions-error');

    // Upload DOM refs
    var uploadInput = document.getElementById('fc-upload-input');
    var uploadDropzone = document.getElementById('fc-upload-dropzone');
    var uploadPrompt = document.getElementById('fc-upload-prompt');
    var uploadProgress = document.getElementById('fc-upload-progress');
    var uploadProgressBar = document.getElementById('fc-upload-progress-bar');
    var uploadProgressText = document.getElementById('fc-upload-progress-text');
    var uploadThumbWrap = document.getElementById('fc-upload-thumb-wrap');
    var uploadThumb = document.getElementById('fc-upload-thumb');
    var uploadChangeBtn = document.getElementById('fc-upload-change');
    var uploadRotateBtn = document.getElementById('fc-upload-rotate');
    var uploadCropBtn = document.getElementById('fc-upload-crop');
    var uploadRemoveBtn = document.getElementById('fc-upload-remove');
    var uploadBtn = document.getElementById('fc-upload-btn');
    var suspensionOptions = document.getElementById('fc-suspension-options');
    var suspensionHint = document.getElementById('fc-suspension-hint');
    var viewToggle = document.getElementById('fc-product-view-toggle');

    /* --- MOBILE SPLIT-SCREEN ELEMENTS --- */
    var mobilePreview = document.getElementById('fc-mobile-preview');
    var mobilePreviewImage = document.getElementById('fc-mobile-preview-image');
    var mobilePreviewSlider = document.getElementById('fc-mobile-preview-slider');
    var mobilePreviewDots = document.getElementById('fc-mobile-preview-dots');
    var mobilePreviewPrev = document.getElementById('fc-mobile-preview-prev');
    var mobilePreviewNext = document.getElementById('fc-mobile-preview-next');
    var mobileInfoTitle = document.getElementById('fc-mobile-info-title');
    var mobileInfoPrice = document.getElementById('fc-mobile-info-price');
    var isMobileQuery = window.matchMedia('(max-width: 749px)');

    /* --- CART SETTINGS (read JSON for delivery prefix etc.) --- */
    var _cartSettings = null;
    try {
      var cartSettingsEl = document.getElementById('fc-cart-settings');
      if (cartSettingsEl) _cartSettings = JSON.parse(cartSettingsEl.textContent);
    } catch (e) { console.warn('[FrameConfigurator] Cart settings parse error:', e); }

    /* --- APPLY SECTION OVERRIDES (update hardcoded HTML with admin-editable values) --- */
    function applyCartSettings() {
      if (!_cartSettings) return;
      var cs = _cartSettings;

      // Heading
      var headingEl = document.getElementById('fc-summary-heading');
      if (headingEl && cs.heading) headingEl.textContent = cs.heading;

      // Badges from section blocks (replace hardcoded badges)
      var cartSource = document.getElementById('fc-cart-source');
      if (cartSource) {
        var srcBadges = cartSource.querySelector('.fc-summary__badges');
        var tgtBadges = document.getElementById('fc-summary-badges');
        if (srcBadges && tgtBadges && srcBadges.children.length > 0) {
          tgtBadges.innerHTML = srcBadges.innerHTML;
        }
        // Hide section wrapper (content already applied)
        var cartSection = cartSource.closest('.section-frame-cart-settings');
        if (cartSection) cartSection.style.display = 'none';
      }

      // Inclusions line
      var inclusionsEl = document.getElementById('fc-summary-inclusions');
      if (inclusionsEl && cs.inclusions !== undefined) {
        if (cs.inclusions) {
          inclusionsEl.textContent = cs.inclusions;
          inclusionsEl.style.display = '';
        } else {
          inclusionsEl.style.display = 'none';
        }
      }

      // CTA button text
      var atcTextEl = document.getElementById('fc-atc-text');
      if (atcTextEl && cs.button_text) atcTextEl.textContent = cs.button_text;
    }

    function applyTrustIcons() {
      // If the section rendered trust icons, use those to replace hardcoded ones
      var trustSource = document.getElementById('fc-trust-source');
      var trustTarget = document.getElementById('fc-trust-icons');
      if (trustSource && trustTarget && trustSource.children.length > 0) {
        trustTarget.innerHTML = trustSource.innerHTML;
        trustTarget.style.gridTemplateColumns = trustSource.style.gridTemplateColumns;
        // Hide section wrapper
        var trustSection = trustSource.closest('.section-frame-trust-icons');
        if (trustSection) trustSection.style.display = 'none';
      }
    }

    /* --- CONFIGURATOR SETTINGS (from admin-editable section) --- */
    var _cfgSettings = null;
    try {
      var cfgEl = document.getElementById('fc-configurator-settings');
      if (cfgEl) _cfgSettings = JSON.parse(cfgEl.textContent);
    } catch (e) { console.warn('[FrameConfigurator] Configurator settings parse error:', e); }

    function applyConfiguratorSettings() {
      if (!_cfgSettings) return;
      var s = _cfgSettings;

      /* — Step titles (accordion headers) — */
      if (s.steps) {
        var stepMap = {
          'upload': s.steps.upload_title,
          'size': s.steps.size_title,
          'frame': s.steps.frame_title,
          'passepartout': s.steps.pp_title,
          'suspension': s.steps.suspension_title
        };
        var steps = document.querySelectorAll('.fc-step[data-step-id]');
        for (var si = 0; si < steps.length; si++) {
          var sid = steps[si].getAttribute('data-step-id');
          if (stepMap[sid]) {
            var titleEl = steps[si].querySelector('.fc-step__title');
            if (titleEl) titleEl.textContent = stepMap[sid];
          }
        }
        // Upload default subtitle
        if (s.steps.upload_no_image) {
          var uploadSub = document.getElementById('fc-step-upload-subtitle');
          if (uploadSub && uploadSub.textContent.indexOf('ausgewählt') !== -1) {
            uploadSub.textContent = s.steps.upload_no_image;
          }
        }
      }

      /* — Mobile tabs — */
      if (s.mobile_tabs) {
        var tabMap = {
          'upload': s.mobile_tabs.upload,
          'size': s.mobile_tabs.size,
          'frame': s.mobile_tabs.frame,
          'passepartout': s.mobile_tabs.pp,
          'suspension': s.mobile_tabs.suspension
        };
        var tabs = document.querySelectorAll('.fc-mobile-tabs__btn[data-tab-target]');
        for (var ti = 0; ti < tabs.length; ti++) {
          var target = tabs[ti].getAttribute('data-tab-target');
          if (tabMap[target]) {
            var label = tabs[ti].querySelector('.fc-mobile-tabs__label');
            if (label) label.textContent = tabMap[target];
          }
        }
      }

      /* — Upload step texts — */
      if (s.upload) {
        var uploadBtn = document.getElementById('fc-upload-btn');
        if (uploadBtn && s.upload.btn_text) {
          var svgHtml = uploadBtn.querySelector('svg') ? uploadBtn.querySelector('svg').outerHTML + ' ' : '';
          uploadBtn.innerHTML = svgHtml + s.upload.btn_text;
        }
        var storageHint = document.querySelector('.fc-upload__storage-hint');
        if (storageHint && s.upload.hint) storageHint.textContent = s.upload.hint;

        var bildartLabel = document.querySelector('.fc-bildart__label');
        if (bildartLabel && s.upload.bildart_label) bildartLabel.textContent = s.upload.bildart_label;
        var bildartChange = document.getElementById('fc-bildart-change');
        if (bildartChange && s.upload.bildart_change) bildartChange.textContent = s.upload.bildart_change;

        var rotateBtn = document.getElementById('fc-upload-rotate');
        if (rotateBtn && s.upload.rotate_text) {
          var rSvg = rotateBtn.querySelector('svg') ? rotateBtn.querySelector('svg').outerHTML + '\n                    ' : '';
          rotateBtn.innerHTML = rSvg + s.upload.rotate_text;
        }
        var cropBtn = document.getElementById('fc-upload-crop');
        if (cropBtn && s.upload.crop_text) {
          var cSvg = cropBtn.querySelector('svg') ? cropBtn.querySelector('svg').outerHTML + '\n                    ' : '';
          cropBtn.innerHTML = cSvg + s.upload.crop_text;
        }
        var changeBtn = document.getElementById('fc-upload-change');
        if (changeBtn && s.upload.new_image_text) {
          var chSvg = changeBtn.querySelector('svg') ? changeBtn.querySelector('svg').outerHTML + '\n                    ' : '';
          changeBtn.innerHTML = chSvg + s.upload.new_image_text;
        }
      }

      /* — Size step — */
      if (s.size) {
        var widthLabel = document.querySelector('label[for="fc-width"], label:has(#fc-width)');
        if (!widthLabel) {
          var widthInput = document.getElementById('fc-width');
          if (widthInput) widthLabel = widthInput.closest('label');
        }
        if (widthLabel && s.size.label_width) {
          widthLabel.childNodes[0].textContent = s.size.label_width + '\n                ';
        }
        var heightLabel = document.querySelector('label[for="fc-height"], label:has(#fc-height)');
        if (!heightLabel) {
          var heightInput = document.getElementById('fc-height');
          if (heightInput) heightLabel = heightInput.closest('label');
        }
        if (heightLabel && s.size.label_height) {
          heightLabel.childNodes[0].textContent = s.size.label_height + '\n                ';
        }
      }

      /* — Frame step: Undecided area — */
      if (s.frame) {
        var undecidedHeading = document.querySelector('.fc-undecided__heading');
        if (undecidedHeading && s.frame.undecided_heading) undecidedHeading.textContent = s.frame.undecided_heading;

        var sampleCard = document.querySelector('.fc-undecided__card:not(.fc-undecided__card--highlight)');
        if (sampleCard) {
          if (s.frame.sample_link) sampleCard.href = s.frame.sample_link;
          var sampleStrong = sampleCard.querySelector('strong');
          if (sampleStrong && s.frame.sample_title) sampleStrong.textContent = s.frame.sample_title;
          var sampleSpan = sampleCard.querySelector('span');
          if (sampleSpan && s.frame.sample_desc) sampleSpan.textContent = s.frame.sample_desc;
        }
        var designerCard = document.querySelector('.fc-undecided__card--highlight');
        if (designerCard) {
          if (s.frame.designer_link) designerCard.href = s.frame.designer_link;
          var dStrong = designerCard.querySelector('strong');
          if (dStrong && s.frame.designer_title) dStrong.textContent = s.frame.designer_title;
          var dSpans = designerCard.querySelectorAll('span:not(.fc-undecided__badge)');
          if (dSpans.length && s.frame.designer_desc) dSpans[dSpans.length - 1].textContent = s.frame.designer_desc;
          var dBadge = designerCard.querySelector('.fc-undecided__badge');
          if (dBadge && s.frame.designer_badge) dBadge.textContent = s.frame.designer_badge;
        }
      }

      /* — Passepartout texts — */
      if (s.passepartout) {
        var pp = s.passepartout;
        // PP type buttons
        var ppTypeMap = { 'ohne': pp.type_ohne, 'einfach': pp.type_standard, 'freigestellt': pp.type_freigestellt };
        var ppBtns = document.querySelectorAll('#fc-pp-type-options .fc-option-btn[data-pp-type]');
        for (var pi = 0; pi < ppBtns.length; pi++) {
          var ppType = ppBtns[pi].getAttribute('data-pp-type');
          if (ppTypeMap[ppType]) {
            var badge = ppBtns[pi].querySelector('.fc-option-btn__badge');
            var badgeHtml = badge ? badge.outerHTML : '';
            ppBtns[pi].innerHTML = badgeHtml + ppTypeMap[ppType];
          }
        }
        // PP popular badge
        if (pp.popular_badge) {
          var badges = document.querySelectorAll('.fc-option-btn__badge');
          for (var bi = 0; bi < badges.length; bi++) badges[bi].textContent = pp.popular_badge;
        }
        // PP width buttons
        var ppWidthMap = { 'thin': pp.width_schmal, 'standard': pp.width_standard, 'wide': pp.width_breit, 'individual': pp.width_individual };
        var ppWBtns = document.querySelectorAll('#fc-pp-width-options .fc-option-btn[data-pp-width]');
        for (var wi = 0; wi < ppWBtns.length; wi++) {
          var ppW = ppWBtns[wi].getAttribute('data-pp-width');
          if (ppWidthMap[ppW]) {
            var wBadge = ppWBtns[wi].querySelector('.fc-option-btn__badge');
            var wBadgeHtml = wBadge ? wBadge.outerHTML : '';
            ppWBtns[wi].innerHTML = wBadgeHtml + ppWidthMap[ppW];
          }
        }
        // Individual mat labels
        if (pp.label_top) { var matTopLabel = document.querySelector('label:has(#fc-mat-top)'); if (matTopLabel) matTopLabel.childNodes[0].textContent = pp.label_top + '\n                  '; }
        if (pp.label_bottom) { var matBotLabel = document.querySelector('label:has(#fc-mat-bottom)'); if (matBotLabel) matBotLabel.childNodes[0].textContent = pp.label_bottom + '\n                  '; }
        if (pp.label_sides) { var matSideLabel = document.querySelector('label:has(#fc-mat-sides)'); if (matSideLabel) matSideLabel.childNodes[0].textContent = pp.label_sides + '\n                  '; }
        // Color toggle
        var colorToggle = document.getElementById('fc-pp-color-toggle');
        if (colorToggle && pp.color_show_all) colorToggle.textContent = pp.color_show_all;
        // Color filter label
        var colorFilter = document.querySelector('.fc-pp-color-filter');
        if (colorFilter && pp.color_filter) colorFilter.textContent = '– ' + pp.color_filter;
        // Info panel
        var infoTitle = document.querySelector('.fc-info-panel__title');
        if (infoTitle && pp.info_title) infoTitle.textContent = pp.info_title;
        var infoItems = document.querySelectorAll('.fc-info-panel__item');
        if (infoItems.length >= 3) {
          var infoData = [
            { title: pp.info_ohne_title, text: pp.info_ohne_text },
            { title: pp.info_einfach_title, text: pp.info_einfach_text },
            { title: pp.info_freigestellt_title, text: pp.info_freigestellt_text }
          ];
          for (var ii = 0; ii < 3; ii++) {
            var iTitle = infoItems[ii].querySelector('.fc-info-panel__item-title');
            var iText = infoItems[ii].querySelector('.fc-info-panel__item-text');
            if (iTitle && infoData[ii].title) iTitle.textContent = infoData[ii].title;
            if (iText && infoData[ii].text) iText.textContent = infoData[ii].text;
          }
        }
      }

      /* — Suspension buttons — */
      if (s.suspension) {
        var susMap = { 'zacken': s.suspension.zacken, 'seil': s.suspension.seil, 'wallbuddies': s.suspension.wallbuddies };
        var susBtns = document.querySelectorAll('#fc-suspension-options .fc-option-btn[data-suspension]');
        for (var sui = 0; sui < susBtns.length; sui++) {
          var susKey = susBtns[sui].getAttribute('data-suspension');
          if (susMap[susKey]) susBtns[sui].textContent = susMap[susKey];
        }
        // Also update subtitle default
        var susSub = document.getElementById('fc-step-suspension-subtitle');
        if (susSub && s.suspension.zacken && susSub.textContent === 'Zacken') {
          susSub.textContent = s.suspension.zacken;
        }
      }
    }

    // Apply section overrides (only replaces content if sections exist, keeps hardcoded fallback)
    applyCartSettings();
    applyTrustIcons();
    applyConfiguratorSettings();

    // Update IIFE-scoped delivery prefix with value from cart settings
    _deliveryPrefix = (_cartSettings && _cartSettings.delivery_prefix) || 'Lieferung ca.';

    /* --- ACCORDION LOGIC --- */
    var openStepId = 'size';
    var visitedSteps = {};

    function toggleStep(stepId) {
      // Mark previously open step as visited
      if (openStepId && openStepId !== stepId) {
        visitedSteps[openStepId] = true;
      }
      openStepId = (openStepId === stepId) ? null : stepId;
      var steps = document.querySelectorAll('.fc-step[data-step-id]');
      for (var si = 0; si < steps.length; si++) {
        var step = steps[si];
        var id = step.dataset.stepId;
        var isOpen = id === openStepId;
        step.classList.toggle('fc-step--open', isOpen);
        step.classList.toggle('fc-step--current', isOpen);
        step.classList.toggle('fc-step--visited', !isOpen && visitedSteps[id]);
        var header = step.querySelector('.fc-step__header');
        if (header) header.setAttribute('aria-expanded', String(isOpen));
        var content = step.querySelector('.fc-step__content');
        if (content) {
          if (isOpen) {
            // Start with scrollHeight for animation, then switch to none so content can grow
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.opacity = '1';
            // IIFE to capture correct content reference (var has function scope)
            (function (el) {
              setTimeout(function () { el.style.maxHeight = 'none'; }, 350);
            })(content);
          } else {
            // Snap from 'none' to scrollHeight so browser can transition to 0
            content.style.maxHeight = content.scrollHeight + 'px';
            content.offsetHeight; // Force reflow
            content.style.maxHeight = '0';
            content.style.opacity = '0';
          }
        }
      }
      // Update scroll arrows when frame step opens (after animation and after maxHeight: none)
      if (stepId === 'frame') {
        setTimeout(updateScrollArrows, 100);
        setTimeout(updateScrollArrows, 400);
      }
      // Update mobile step indicator
      updateStepSubtitles();
      // Sync mobile tab bar highlight (no-op if tabs don't exist yet)
      if (typeof syncMobileTabs === 'function') syncMobileTabs();
    }

    function updateStepSubtitles() {
      // Size subtitle
      var sizeSubEl = document.getElementById('fc-step-size-subtitle');
      if (sizeSubEl) sizeSubEl.textContent = needsSizeEntry() ? 'Ma\u00dfe eingeben' : state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm';

      // Frame subtitle
      var frameSubEl = document.getElementById('fc-step-frame-subtitle');
      if (frameSubEl) frameSubEl.textContent = productData.title || '';

      // PP subtitle
      var ppSubEl = document.getElementById('fc-step-pp-subtitle');
      if (ppSubEl) {
        var ppLabelMap = { 'ohne': 'Ohne', 'einfach': 'Einfach', 'freigestellt': 'Freigestellt', 'hintergrundkarton': 'Hintergrundkarton', 'schwebend': 'Schwebend' };
        var ppLabel = ppLabelMap[state.ppType] || state.ppType;
        ppSubEl.textContent = ppLabel + (state.ppType !== 'ohne' ? ' / ' + state.matColor : '');
      }

      // Suspension subtitle
      var susSubEl = document.getElementById('fc-step-suspension-subtitle');
      if (susSubEl) {
        var susLabel = state.suspension === 'wallbuddies' ? 'Wall Buddies' : (state.suspension.charAt(0).toUpperCase() + state.suspension.slice(1));
        susSubEl.textContent = susLabel;
      }

      // Mirror all subtitle values into the mobile tab bar
      if (typeof updateMobileTabValues === 'function') updateMobileTabValues();
    }

    /**
     * Populate the mobile tab bar's per-tab subtitle (current value) and the
     * completion state (checkmark). Called from updateStepSubtitles + upload flow.
     * The subtitle text mirrors what the desktop accordion subtitles show, so the
     * user sees their current selection without having to open each tab.
     */
    function updateMobileTabValues() {
      var tabBar = document.getElementById('fc-mobile-tabs');
      if (!tabBar) return;

      var tabs = tabBar.querySelectorAll('[data-tab-target]');
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        var key = tab.getAttribute('data-tab-target');
        var valueEl = tab.querySelector('[data-tab-value]');
        if (!valueEl) continue;

        var text = '\u2014';
        var complete = false;

        if (key === 'upload') {
          // Bei hochgeladenem (oder Platzhalter-)Bild: nur ein Haken
          var hasImage = !!(state.imageUrl || state.localBlobUrl);
          if (hasImage) {
            text = '\u2713'; // ✓
            complete = true;
          } else {
            text = '\u2014';
          }
        } else if (key === 'type') {
          // Nur "Leinwand" oder "Papier" — abgeleitet aus state.frameType
          if (state.frameType) {
            text = (state.frameType.indexOf('Leinwand') !== -1) ? 'Leinwand' : 'Papier';
            complete = true;
          } else {
            text = '\u2014';
          }
        } else if (key === 'size') {
          if (needsSizeEntry()) {
            text = '\u2014';
            complete = false;
          } else {
            text = state.imageWidth + '\u00D7' + state.imageHeight + ' cm';
            complete = !!(state.imageWidth && state.imageHeight);
          }
        } else if (key === 'frame') {
          text = (productData && productData.title) || '';
          complete = !!text;
        } else if (key === 'passepartout') {
          // Nur der gewählte Typ, ohne Farbe
          if (state.ppType === 'ohne') {
            text = 'Ohne';
          } else if (state.ppType === 'einfach') {
            text = 'Einfach';
          } else {
            text = 'Freigestellt';
          }
          complete = true;
        } else if (key === 'suspension') {
          text = state.suspension === 'wallbuddies'
            ? 'Wall Buddies'
            : (state.suspension.charAt(0).toUpperCase() + state.suspension.slice(1));
          complete = !!state.suspension;
        }

        valueEl.textContent = text;
        tab.classList.toggle('fc-mobile-tabs__btn--complete', complete);
      }
    }

    // Initialize accordion - step headers get click handlers here.
    // The actual open step is set later in initialization (after URL params + renderTypeCards).
    (function initAccordion() {
      toggleStep('size');
      // Bind click handlers on step headers
      var headers = document.querySelectorAll('.fc-step__header');
      for (var hi = 0; hi < headers.length; hi++) {
        headers[hi].addEventListener('click', function () {
          var step = this.closest('.fc-step[data-step-id]');
          if (step) toggleStep(step.dataset.stepId);
        });
      }
    })();

    /* --- Mobile Tab Bar (Tylko-Style) ---
     * Replaces the accordion headers on mobile with a horizontal scrollable tab bar.
     * Tabs are backed by the same toggleStep() mechanism — they just trigger the
     * same state change that a step header click would. Inactive tabs close their
     * corresponding steps automatically via toggleStep()'s single-open logic.
     */
    var mobileTabs = document.getElementById('fc-mobile-tabs');
    if (mobileTabs) {
      mobileTabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab-target]');
        if (!btn) return;
        var targetStepId = btn.getAttribute('data-tab-target');
        var stepEl = document.querySelector('[data-step-id="' + targetStepId + '"]');
        if (!stepEl) return;
        // Tabs don't toggle-close — if already open, just ensure active state
        if (!stepEl.classList.contains('fc-step--open')) {
          toggleStep(targetStepId);
        } else {
          syncMobileTabs();
        }
      });
    }

    function syncMobileTabs() {
      if (!mobileTabs) return;
      var openStep = document.querySelector('.fc-step.fc-step--open');
      var openId = openStep ? openStep.getAttribute('data-step-id') : null;
      var tabs = mobileTabs.querySelectorAll('[data-tab-target]');
      for (var ti = 0; ti < tabs.length; ti++) {
        var t = tabs[ti];
        var active = t.getAttribute('data-tab-target') === openId;
        t.classList.toggle('fc-mobile-tabs__btn--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    // Hide mobile tabs whose corresponding step is display:none (e.g. Typ on single-type,
    // Passepartout on canvas-only products). Called after init + after state updates.
    function syncMobileTabsVisibility() {
      if (!mobileTabs) return;
      var mapping = {
        'upload': 'fc-step-upload',
        'type': 'fc-step-type',
        'size': 'fc-step-size',
        'frame': 'fc-step-frame',
        'passepartout': 'fc-step-pp',
        'suspension': 'fc-step-suspension'
      };
      var keys = Object.keys(mapping);
      for (var mi = 0; mi < keys.length; mi++) {
        var tabKey = keys[mi];
        var stepEl = document.getElementById(mapping[tabKey]);
        var tabBtn = mobileTabs.querySelector('[data-tab-target="' + tabKey + '"]');
        if (!tabBtn) continue;
        var hidden = stepEl && stepEl.style.display === 'none';
        tabBtn.style.display = hidden ? 'none' : '';
      }
    }

    // Renumber visible steps dynamically (Bild=1, Typ=2 or hidden, Größe=2/3, etc.)
    function renumberSteps() {
      var steps = document.querySelectorAll('.fc-step[data-step-id]');
      var n = 1;
      for (var si2 = 0; si2 < steps.length; si2++) {
        if (steps[si2].style.display === 'none') continue;
        var numEl = steps[si2].querySelector('.fc-step__number');
        if (numEl) numEl.textContent = n;
        n++;
      }
    }

    // Update upload step status (check icon + subtitle text)
    function updateUploadStepStatus() {
      var uploadStep = document.getElementById('fc-step-upload');
      var hasImage = !!(state.imageUrl || state.localBlobUrl);
      if (uploadStep) {
        uploadStep.classList.toggle('fc-step--complete', hasImage);
      }
      var subtitleEl = document.getElementById('fc-step-upload-subtitle');
      if (subtitleEl) {
        if (hasImage) {
          subtitleEl.textContent = state.isPlaceholder ? 'Testbild ausgew\u00e4hlt' : 'Bild hochgeladen';
        } else if (typeof isUploadRequired === 'function' && isUploadRequired()) {
          subtitleEl.textContent = 'Ben\u00f6tigt';
        } else {
          subtitleEl.textContent = 'Noch kein Bild ausgew\u00e4hlt';
        }
      }
      // Sync the mobile tab bar's "Bild" tab value + completion checkmark
      if (typeof updateMobileTabValues === 'function') updateMobileTabValues();
    }

    // Initial sync — active tab + visibility based on current step states
    syncMobileTabsVisibility();
    renumberSteps();
    syncMobileTabs();
    updateUploadStepStatus();
    var uploadError = document.getElementById('fc-upload-error');
    var uploadGroup = document.getElementById('fc-upload-group');
    var uploadGroupLabel = uploadGroup ? uploadGroup.querySelector('.fc-group__label') : null;

    // Helper: Check if current frame type requires image upload
    function isUploadRequired() {
      var ft = (state.frameType || '').toLowerCase();
      return ft === 'digitaler upload' || ft === 'digitale leinwand';
    }

    // Helper: Check if current frame type supports auto aspect-ratio
    function isAutoAspectType() {
      var ft = (state.frameType || '').toLowerCase();
      return ft === 'digitaler upload' || ft === 'digitale leinwand';
    }

    // Calculate max width for slider given aspect ratio (respects 90×110 constraint)
    function getSliderMaxWidth(ratio) {
      if (!ratio) return 110;
      // H = W / ratio — need W ≤ 110, H ≤ 110, NOT(W > 90 AND H > 90)
      var maxFromH = Math.floor(110 * ratio);       // H ≤ 110
      var maxFromBoth;
      if (ratio >= 1) {
        // Landscape: if W > 90 then H must ≤ 90 → W ≤ 90 * ratio
        maxFromBoth = Math.floor(90 * ratio);
      } else {
        // Portrait: if H > 90 (i.e. W > 90*ratio) then W must ≤ 90
        maxFromBoth = 90;
      }
      return Math.min(110, maxFromH, maxFromBoth);
    }

    // Sync slider max + value after aspect ratio or type change
    function syncSizeSlider() {
      if (!sizeSliderWrap || !sizeSliderInput) return;
      if (!isAutoAspectType()) {
        sizeSliderWrap.style.display = 'none';
        return;
      }
      sizeSliderWrap.style.display = '';
      var maxW = getSliderMaxWidth(state.imageAspectRatio);
      sizeSliderInput.max = maxW;
      if (state.imageWidth > maxW) {
        state.imageWidth = maxW;
        if (widthInput) widthInput.value = maxW;
        // Recalc height
        if (state.imageAspectRatio) {
          var autoH = Math.round(maxW / state.imageAspectRatio);
          autoH = Math.max(10, Math.min(110, autoH));
          state.imageHeight = autoH;
          if (heightInput) heightInput.value = autoH;
        }
      }
      sizeSliderInput.value = state.imageWidth;
      // Update max label
      var maxLabel = sizeSliderWrap.querySelector('.fc-size-slider__labels');
      if (maxLabel) maxLabel.lastElementChild.textContent = maxW + ' cm';
    }

    /**
     * Reorder images for upload context: move first image to last.
     * When customer has uploaded an image, the 2nd product image is most relevant
     * (typically a detail/profile shot), so it should appear first.
     */
    function reorderImagesForUpload(images) {
      if (!images || images.length < 2 || !state.imageUrl) return images;
      return images.slice(1).concat([images[0]]);
    }

    /**
     * After reordering gallery slides, re-init dots + reset slider pages so navigation works.
     * Optionally scrolls to SVG preview if scrollToPreview is true.
     */
    function refreshGalleryAfterReorder(scrollToPreview) {
      setTimeout(function () {
        initGalleryDots();
        reBindGalleryThumbnails();
        var mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery && mediaGallery.elements && mediaGallery.elements.viewer) {
          var viewer = mediaGallery.elements.viewer;
          if (typeof viewer.resetPages === 'function') {
            try { viewer.resetPages(); } catch (e) { /* ignore */ }
          }
        }
        if (scrollToPreview) {
          _userClickedThumbnail = false;
          scrollGalleryToPreview();
        }
      }, 100);
    }

    /**
     * Reorder existing desktop gallery slides:
     * When user has configured (size/PP/upload): move SVG preview to front, first product image to last.
     * When restoring: move SVG back to end, restore first product image to front.
     */
    function reorderDesktopGallerySlides() {
      var slides = document.querySelectorAll('.fc-page-product-image');
      if (slides.length < 2) return;
      var parent = slides[0].parentElement;
      if (!parent) return;

      // Also reorder thumbnails
      var thumbs = document.querySelectorAll('.fc-page-product-thumb');

      // Find SVG preview slide and thumbnail
      var svgSlide = parent.querySelector('[data-media-id$="-fc-preview"]');
      var thumbParent = thumbs.length > 0 ? thumbs[0].parentElement : null;
      var svgThumb = thumbParent ? thumbParent.querySelector('[data-target$="-fc-preview"]') : null;

      if (_userHasConfigured) {
        // Move SVG preview to front
        if (svgSlide) parent.insertBefore(svgSlide, parent.firstElementChild);
        if (svgThumb && thumbParent) thumbParent.insertBefore(svgThumb, thumbParent.firstElementChild);
        // Move first product image to end
        parent.appendChild(slides[0]);
        if (thumbs.length > 1 && thumbParent) {
          thumbParent.appendChild(thumbs[0]);
        }
      } else {
        // Restore: move SVG back to end
        if (svgSlide) parent.appendChild(svgSlide);
        if (svgThumb && thumbParent) thumbParent.appendChild(svgThumb);
        // Move last product slide (originally first) back to front
        if (slides.length > 1) {
          parent.insertBefore(slides[slides.length - 1], parent.firstElementChild);
          if (thumbs.length > 1 && thumbParent) {
            thumbParent.insertBefore(thumbs[thumbs.length - 1], thumbParent.firstElementChild);
          }
        }
      }
    }

    /**
     * Reorder existing mobile gallery slides: move SVG to front + first product image to last
     * (or restore). Called after config change or upload/removal.
     */
    function reorderMobileGallerySlides() {
      if (!mobilePreviewSlider) return;
      var svgSlide = mobilePreviewSlider.querySelector('.fc-mobile-preview__slide--svg');
      // Always keep SVG slide first, regardless of configuration state
      if (svgSlide && mobilePreviewSlider.firstElementChild !== svgSlide) {
        mobilePreviewSlider.insertBefore(svgSlide, mobilePreviewSlider.firstElementChild);
      }
      // Scroll back to the SVG (first slide) so user sees it on init
      if (mobilePreviewSlider.scrollLeft !== 0) {
        mobilePreviewSlider.scrollTo({ left: 0, behavior: 'instant' });
      }
      updateMobilePreviewDots();
    }

    // IndexedDB helpers — persist image blob + Firebase URL for reload
    function saveImageToIDB(blob, firebaseUrl) {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onupgradeneeded = function (e) { e.target.result.createObjectStore('blobs'); };
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readwrite');
          var store = tx.objectStore('blobs');
          if (blob) store.put(blob, 'uploadedImage');
          if (firebaseUrl) store.put(firebaseUrl, 'firebaseUrl');
        };
      } catch (e) { /* IndexedDB not available */ }
    }
    function loadImageFromIDB(callback) {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onupgradeneeded = function (e) { e.target.result.createObjectStore('blobs'); };
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readonly');
          var store = tx.objectStore('blobs');
          var getBlob = store.get('uploadedImage');
          var getUrl = store.get('firebaseUrl');
          var result = { blob: null, firebaseUrl: null };
          getBlob.onsuccess = function () { result.blob = getBlob.result || null; };
          getUrl.onsuccess = function () { result.firebaseUrl = getUrl.result || null; };
          tx.oncomplete = function () { callback(result); };
          tx.onerror = function () { callback(result); };
        };
        req.onerror = function () { callback({ blob: null, firebaseUrl: null }); };
      } catch (e) { callback({ blob: null, firebaseUrl: null }); }
    }
    function clearImageFromIDB() {
      try {
        var req = indexedDB.open('fc-images', 1);
        req.onsuccess = function (e) {
          var db = e.target.result;
          var tx = db.transaction('blobs', 'readwrite');
          var store = tx.objectStore('blobs');
          store.delete('uploadedImage');
          store.delete('firebaseUrl');
        };
      } catch (e) { /* ignore */ }
    }

    // Upload state (Firebase Client SDK — direct browser-to-Firebase, no server/proxy needed)

    // Verify critical DOM elements
    if (!ppTypeOptions || !ppWidthOptions || !ppColorGrid || !previewContainer) {
      console.error('[FrameConfigurator] Missing critical DOM elements:', {
        ppTypeOptions: !!ppTypeOptions,
        ppWidthOptions: !!ppWidthOptions,
        ppColorGrid: !!ppColorGrid,
        previewContainer: !!previewContainer
      });
      return;
    }

    /* --- UI HELPERS (defined before use) --- */

    function setActiveButton(container, activeBtn) {
      container.querySelectorAll('.fc-option-btn').forEach(function (b) { b.classList.remove('fc-option-btn--active'); });
      activeBtn.classList.add('fc-option-btn--active');
    }

    function setActiveSwatch(container, swatch) {
      container.querySelectorAll('.fc-swatch').forEach(function (s) { s.classList.remove('fc-swatch--active'); });
      swatch.classList.add('fc-swatch--active');
    }

    function togglePPOptions() {
      // Width/Color für alle PP-Typen außer 'ohne' zeigen.
      // Schwebend ist ein normales PP mit zusätzlichem Schatten — Width/Color voll konfigurierbar.
      var show = state.ppType !== 'ohne';
      ppWidthGroup.classList.toggle('fc-group--hidden', !show);
      ppColorGroup.classList.toggle('fc-group--hidden', !show);
      // After showing/hiding PP sub-groups, update the step content maxHeight
      // so the accordion can grow/shrink to fit the new content.
      var ppContent = document.querySelector('#fc-step-pp .fc-step__content');
      if (ppContent && document.querySelector('#fc-step-pp').classList.contains('fc-step--open')) {
        ppContent.style.maxHeight = 'none';
      }
    }

    /**
     * Sync the Passepartout UI (buttons + state) to the current frameType.
     * Objektrahmung enforces ppType='hintergrundkarton' and hides the standard
     * PP choices; any other frameType reverts to the standard 3-button set.
     * Papierarbeit / Digitaler Upload zeigt zusätzlich den Schwebend-Button.
     */
    function syncPPForFrameType() {
      var typeKey = normalizeTypeKey(state.frameType || '');
      var isObjekt = typeKey === 'objektrahmung';
      var allowsSchwebend = (typeKey === 'papierarbeit' || typeKey === 'digitaler upload');

      var standardBtns = document.querySelectorAll('#fc-pp-type-options .fc-pp-standard-btn');
      var objektBtns = document.querySelectorAll('#fc-pp-type-options .fc-pp-objekt-btn');
      var schwebendBtns = document.querySelectorAll('#fc-pp-type-options .fc-pp-schwebend-btn');
      for (var i = 0; i < standardBtns.length; i++) standardBtns[i].style.display = isObjekt ? 'none' : '';
      for (var j = 0; j < objektBtns.length; j++) objektBtns[j].style.display = isObjekt ? '' : 'none';
      for (var k = 0; k < schwebendBtns.length; k++) schwebendBtns[k].style.display = (!isObjekt && allowsSchwebend) ? '' : 'none';

      if (isObjekt) {
        state.ppType = 'hintergrundkarton';
        setActiveButton(ppTypeOptions, objektBtns[0] || null);
      } else if (state.ppType === 'hintergrundkarton') {
        state.ppType = 'ohne';
        var ohneBtn = document.querySelector('#fc-pp-type-options [data-pp-type="ohne"]');
        if (ohneBtn) setActiveButton(ppTypeOptions, ohneBtn);
      } else if (state.ppType === 'schwebend' && !allowsSchwebend) {
        // Schwebend ist beim neuen Typ nicht zulässig → zurück auf 'ohne'
        state.ppType = 'ohne';
        var ohneBtn2 = document.querySelector('#fc-pp-type-options [data-pp-type="ohne"]');
        if (ohneBtn2) setActiveButton(ppTypeOptions, ohneBtn2);
      }
      togglePPOptions();
    }

    /**
     * Check if a frameType has any PP variants (einfach/freigestellt) in the variant index.
     * Returns false for frame types that only have 'ohne' PP (e.g. Leinwand).
     */
    function frameTypeHasPP(frameType) {
      var typeMap = variantIndex[frameType];
      if (!typeMap) return false;
      var sizeKeys = Object.keys(typeMap);
      for (var i = 0; i < sizeKeys.length; i++) {
        var sizeMap = typeMap[sizeKeys[i]];
        var ppKeys = Object.keys(sizeMap);
        for (var j = 0; j < ppKeys.length; j++) {
          if (ppKeys[j] !== 'ohne') return true;
        }
      }
      return false;
    }

    /**
     * Check if the given frameType is any form of Leinwand (canvas).
     * Leinwand has no passepartout and no UV-acrylic glass inclusion.
     */
    function isLeinwandType(frameType) {
      var nk = normalizeTypeKey(frameType || '');
      return nk.indexOf('leinwand') !== -1;
    }

    /**
     * Hide the entire PP step when the current frameType has no PP variants
     * (e.g. Leinwand). Also updates step numbering (Aufhängung becomes 3 instead of 4).
     */
    function updatePPStepVisibility() {
      var ppStep = document.getElementById('fc-step-pp');
      var suspensionStep = document.getElementById('fc-step-suspension');
      if (!ppStep || !suspensionStep) return;

      // Leinwand never shows PP, regardless of variant data.
      var isLeinwand = isLeinwandType(state.frameType);
      var hasPP = !isLeinwand && frameTypeHasPP(state.frameType);

      // Show/hide PP step
      ppStep.style.display = hasPP ? '' : 'none';

      // Hide "Inkl. UV-Acrylglas · Staubdicht versiegelt" for Leinwand (keine Acrylglas-Abdeckung bei Leinwand).
      var inclusionsEl = document.getElementById('fc-summary-inclusions');
      if (inclusionsEl) inclusionsEl.style.display = isLeinwand ? 'none' : '';

      // Sync mobile tab visibility (PP tab hidden when not available)
      if (typeof syncMobileTabsVisibility === 'function') syncMobileTabsVisibility();
      // Dynamically renumber visible steps (Bild=1, Typ=2, Größe=3, ...)
      if (typeof renumberSteps === 'function') renumberSteps();

      // Force ppType to 'ohne' when PP not available
      if (!hasPP && state.ppType !== 'ohne') {
        state.ppType = 'ohne';
        syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
        togglePPOptions();
      }
    }

    function toggleIndividualInputs() {
      individualInputs.classList.toggle('fc-group--hidden', state.matWidth !== 'individual');
      // Update PP step maxHeight after content change. Force it on the next
      // frame as well so any ongoing accordion-open transition (which sets a
      // fixed pixel max-height for ~350ms) does not clip the newly shown
      // individual inputs.
      var ppStep = document.querySelector('#fc-step-pp');
      var ppContent = ppStep ? ppStep.querySelector('.fc-step__content') : null;
      if (ppContent && ppStep && ppStep.classList.contains('fc-step--open')) {
        ppContent.style.maxHeight = 'none';
        requestAnimationFrame(function () { ppContent.style.maxHeight = 'none'; });
      }
    }

    function syncButtonState(container, attrName, value) {
      container.querySelectorAll('.fc-option-btn').forEach(function (btn) {
        btn.classList.toggle('fc-option-btn--active', btn.getAttribute(attrName) === value);
      });
    }

    /* --- MAT COLOR SWATCHES --- */

    function renderMatColorSwatches() {
      var html = '';
      SHARED_MAT_COLOR_OPTIONS.forEach(function (opt) {
        var active = opt.color === state.matColor ? ' fc-swatch--active' : '';
        html += '<button type="button" class="fc-swatch' + active + '"' +
          ' data-mat-color="' + opt.color + '"' +
          ' data-mat-display-name="' + opt.displayName + '"' +
          ' title="' + opt.displayName + '"' +
          ' aria-label="Passepartout-Farbe: ' + opt.displayName + '">' +
          (opt.imageUrl
            ? '<img src="' + opt.imageUrl + '" alt="' + opt.displayName + '" loading="lazy" width="36" height="36">'
            : '<span class="fc-swatch__fallback"></span>') +
          '</button>';
      });
      ppColorGrid.innerHTML = html;
      // Update "show all" toggle with total count
      var toggleBtn = document.getElementById('fc-pp-color-toggle');
      if (toggleBtn && ppColorGrid.classList.contains('fc-color-grid--collapsed')) {
        toggleBtn.innerHTML = '\u2192 Alle ' + SHARED_MAT_COLOR_OPTIONS.length + ' Farben anzeigen';
      }
    }

    /* --- PRODUCT SWITCHER --- */

    /**
     * Return only products that have a variant matching the current
     * size category + PP type combination.
     */
    /**
     * Get all products that have at least one variant of the current frameType.
     * Each product gets a .available flag indicating whether a variant exists
     * for the current size + PP combination.
     */
    function getFilteredProducts() {
      var sizeCategory = getSizeCategory(
        state.imageWidth, state.imageHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );
      var sizeKey = normalizeSizeKey(sizeCategory);
      var ppKey = normalizePPType(state.ppType);

      var filtered = [];
      for (var i = 0; i < productsList.length; i++) {
        var p = productsList[i];
        var idx = allProductVariantIndexes[p.handle];
        if (!idx) continue;

        // Check if product has the current frameType — either in variant index
        // or in options metadata (variants may not be loaded due to Shopify 250-variant limit)
        var hasFrameTypeInIndex = Boolean(idx[state.frameType]);
        var hasFrameTypeInOptions = false;
        if (!hasFrameTypeInIndex && p.options && Array.isArray(p.options)) {
          for (var oi = 0; oi < p.options.length; oi++) {
            var optName = (p.options[oi].name || '').toLowerCase();
            if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
              var vals = p.options[oi].values || [];
              hasFrameTypeInOptions = vals.indexOf(state.frameType) !== -1;
              break;
            }
          }
        }
        if (!hasFrameTypeInIndex && !hasFrameTypeInOptions) continue;

        // Check if product has a matching variant for current size + PP
        var typeMap = hasFrameTypeInIndex ? idx[state.frameType] : null;
        var sizeMap = typeMap ? typeMap[sizeKey] : null;
        var hasVariant = Boolean(sizeMap && (sizeMap[ppKey] || sizeMap['ohne']));

        // If frame type exists in options but variants aren't loaded yet,
        // show as available (optimistic) — lazy loading will fetch on click
        if (!hasFrameTypeInIndex && hasFrameTypeInOptions) {
          hasVariant = true;
        }

        var entry = {};
        for (var key in p) { if (p.hasOwnProperty(key)) entry[key] = p[key]; }
        entry._available = hasVariant;
        filtered.push(entry);
      }
      return filtered;
    }

    /** Extract unique color categories from product tags (format: "Farbe: Schwarz") */
    function extractColorCategories(products) {
      var colorSet = {};
      for (var i = 0; i < products.length; i++) {
        var tags = products[i].tags || [];
        for (var j = 0; j < tags.length; j++) {
          var tag = tags[j];
          if (tag.indexOf('Farbe:') === 0 || tag.indexOf('farbe:') === 0) {
            var color = tag.split(':')[1].trim();
            if (color) colorSet[color] = true;
          }
        }
      }
      return Object.keys(colorSet).sort();
    }

    /** Get color tags for a single product */
    function getProductColors(product) {
      var colors = [];
      var tags = product.tags || [];
      for (var j = 0; j < tags.length; j++) {
        var tag = tags[j];
        if (tag.indexOf('Farbe:') === 0 || tag.indexOf('farbe:') === 0) {
          var color = tag.split(':')[1].trim();
          if (color) colors.push(color);
        }
      }
      return colors;
    }

    /** Update the info box to show a specific product's details */
    function updateFrameInfoBox(product) {
      var infoBox = document.getElementById('fc-frame-info');
      if (!infoBox) return;
      var colorEl = document.getElementById('fc-frame-info-color');
      var hoeheEl = infoBox.querySelector('.fc-frame-info__hoehe');
      var breiteEl = infoBox.querySelector('.fc-frame-info__breite');
      if (colorEl) colorEl.textContent = product.farbBeschreibung || '';
      if (hoeheEl) hoeheEl.textContent = (product.frameHoeheMM || 15) + ' mm';
      if (breiteEl) breiteEl.textContent = (product.frameBreiteMM || 24) + ' mm';
    }

    /** Get a short one-line description from the product (first sentence or first 80 chars) */
    function getShortDescription(product) {
      var raw = product.description || '';
      // Strip HTML tags
      var text = raw.replace(/<[^>]*>/g, '').trim();
      if (!text) return '';
      // First sentence or up to 80 chars
      var dot = text.indexOf('.');
      if (dot > 0 && dot < 80) return text.substring(0, dot + 1);
      if (text.length > 80) return text.substring(0, 77) + '\u2026';
      return text;
    }

    /** Scroll active swatch into view within the horizontal scroll container */
    function scrollActiveSwatchIntoView() {
      var container = document.getElementById('fc-frame-swatches');
      if (!container) return;
      var active = container.querySelector('.fc-frame-swatch--active');
      if (!active) return;
      var containerRect = container.getBoundingClientRect();
      var swatchRect = active.getBoundingClientRect();
      // If swatch is outside visible area, scroll it into center
      if (swatchRect.left < containerRect.left || swatchRect.right > containerRect.right) {
        var scrollTarget = active.offsetLeft - container.offsetWidth / 2 + active.offsetWidth / 2;
        container.scrollTo({ left: scrollTarget, behavior: 'instant' });
      }
    }

    var _activeFilterTab = 'Alle';

    function renderProductSwitcher() {
      if (!productSwitcherGroup || !productCardsEl) {
        if (productSwitcherGroup) productSwitcherGroup.style.display = 'none';
        return;
      }

      var filtered = getFilteredProducts();

      if (filtered.length < 2) {
        productSwitcherGroup.style.display = 'none';
        return;
      }

      productSwitcherGroup.style.display = '';

      // Pre-compute short descriptions
      for (var i = 0; i < filtered.length; i++) {
        if (typeof filtered[i]._shortDesc === 'undefined') {
          filtered[i]._shortDesc = getShortDescription(filtered[i]);
        }
      }

      // Find active product for info box
      var activeProduct = null;
      for (var i = 0; i < filtered.length; i++) {
        if (filtered[i].handle === productData.handle) { activeProduct = filtered[i]; break; }
      }
      if (!activeProduct) activeProduct = filtered[0];

      // 1. Filter tabs (from tags "Farbe: ...")
      var html = '';
      var categories = extractColorCategories(filtered);
      if (categories.length > 1) {
        html += '<div class="fc-frame-tabs" id="fc-frame-tabs">';
        html += '<button type="button" class="fc-frame-tab' + (_activeFilterTab === 'Alle' ? ' fc-frame-tab--active' : '') + '" data-filter="Alle">Alle</button>';
        for (var c = 0; c < categories.length; c++) {
          html += '<button type="button" class="fc-frame-tab' + (_activeFilterTab === categories[c] ? ' fc-frame-tab--active' : '') + '" data-filter="' + categories[c] + '">' + categories[c] + '</button>';
        }
        html += '</div>';
      }

      // 3. Swatch row with scroll fade
      html += '<div class="fc-frame-swatches-wrap">';
      html += '<div class="fc-frame-swatches" id="fc-frame-swatches">';
      for (var i = 0; i < filtered.length; i++) {
        var p = filtered[i];
        var isActive = p.handle === productData.handle;
        var isAvailable = p._available !== false;
        // Skip unavailable frames entirely (do not render greyed-out) — but always keep the active one visible
        if (!isAvailable && !isActive) continue;
        var imgSrc = (p.images && p.images.length > 1 ? p.images[1].url : p.featuredImage) || '';
        var productColors = getProductColors(p);
        var colorDataAttr = productColors.length ? productColors.join(',') : '';
        var shortDesc = p._shortDesc || '';

        var classes = 'fc-frame-swatch';
        if (isActive) classes += ' fc-frame-swatch--active';
        if (!isAvailable && !isActive) classes += ' fc-frame-swatch--disabled';
        // Apply filter visibility
        if (_activeFilterTab !== 'Alle' && productColors.indexOf(_activeFilterTab) === -1) {
          classes += ' fc-frame-swatch--hidden';
        }

        var breiteMM = p.frameBreiteMM || 24;
        var hoeheMM = p.frameHoeheMM || 15;

        html += '<button type="button" class="' + classes + '"'
          + ' data-handle="' + p.handle + '"'
          + ' data-title="' + (p.title || '').replace(/"/g, '&quot;') + '"'
          + ' data-breite="' + breiteMM + '"'
          + ' data-hoehe="' + hoeheMM + '"'
          + ' data-desc="' + shortDesc.replace(/"/g, '&quot;') + '"'
          + ' data-colors="' + colorDataAttr + '"'
          + ' title="' + (p.title || '') + '"'
          + (!isAvailable && !isActive ? ' disabled' : '')
          + '>'
          + '<div class="fc-frame-swatch__img-wrap">'
          + (imgSrc ? '<img src="' + imgSrc + '" alt="' + (p.title || '') + '" loading="lazy">' : '')
          + '</div>'
          + '</button>';
      }
      html += '</div>';
      html += '</div>'; // .fc-frame-swatches-wrap

      productCardsEl.innerHTML = html;

      // Update frame info box with active product's dimensions
      updateFrameInfoBox(activeProduct || productData);

      // Scroll active swatch into view after render
      requestAnimationFrame(scrollActiveSwatchIntoView);

      // Update scroll fade indicators
      var swatchContainer = document.getElementById('fc-frame-swatches');
      if (swatchContainer) {
        var updateFade = function () {
          var wrap = swatchContainer.parentElement;
          if (!wrap) return;
          var atStart = swatchContainer.scrollLeft <= 2;
          var atEnd = swatchContainer.scrollLeft >= swatchContainer.scrollWidth - swatchContainer.clientWidth - 2;
          wrap.classList.toggle('fc-frame-swatches-wrap--fade-left', !atStart);
          wrap.classList.toggle('fc-frame-swatches-wrap--fade-right', !atEnd);
        };
        swatchContainer.addEventListener('scroll', debounce(updateFade, 50));
        requestAnimationFrame(updateFade);

        // Desktop: convert vertical mouse wheel to horizontal scroll
        swatchContainer.addEventListener('wheel', function (e) {
          // Only intercept if container actually overflows horizontally
          if (swatchContainer.scrollWidth <= swatchContainer.clientWidth) return;
          // Only convert vertical scroll (deltaY) — don't interfere with horizontal trackpad
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && e.deltaY !== 0) {
            e.preventDefault();
            swatchContainer.scrollLeft += e.deltaY;
          }
        }, { passive: false });

        // Desktop: drag-to-scroll (mouse only, not touch)
        var _dragState = { active: false, startX: 0, scrollLeft: 0 };
        swatchContainer.addEventListener('mousedown', function (e) {
          // Only left button, skip if clicking a swatch button
          if (e.button !== 0) return;
          if (swatchContainer.scrollWidth <= swatchContainer.clientWidth) return;
          _dragState.active = true;
          _dragState.startX = e.pageX;
          _dragState.scrollLeft = swatchContainer.scrollLeft;
          swatchContainer.classList.add('fc-frame-swatches--grabbing');
          e.preventDefault();
        });
        document.addEventListener('mousemove', function (e) {
          if (!_dragState.active) return;
          var dx = e.pageX - _dragState.startX;
          swatchContainer.scrollLeft = _dragState.scrollLeft - dx;
        });
        document.addEventListener('mouseup', function () {
          if (!_dragState.active) return;
          _dragState.active = false;
          swatchContainer.classList.remove('fc-frame-swatches--grabbing');
        });
      }
    }

    /* --- TYPE DROPDOWN --- */

    function hasCrossLink() {
      var cat = classifyProductTypes(frameTypeValues);
      if (cat === 'paper-only' && crossLinkConfig.canvasProductHandle) return true;
      if (cat === 'canvas-only' && crossLinkConfig.paperProductHandle) return true;
      return false;
    }

    function renderTypeCards() {
      // Type step is permanently hidden — the type wizard replaces it.
      // We still render cards internally so state.frameType stays in sync.
      if (typeGroup) typeGroup.style.display = 'none';
      if (typeof syncMobileTabsVisibility === 'function') syncMobileTabsVisibility();
      if (typeof renumberSteps === 'function') renumberSteps();
      if (!typeCardsContainer || (frameTypeValues.length < 2 && !hasCrossLink())) {
        return;
      }
      var html = '';
      for (var i = 0; i < frameTypeValues.length; i++) {
        var val = frameTypeValues[i];
        var meta = TYPE_CARD_META[val] || { title: val, desc: '' };
        var isSelected = val === state.frameType;
        html += '<div class="fc-type-card' + (isSelected ? ' fc-type-card--selected' : '') + '"'
          + ' role="radio"'
          + ' aria-checked="' + (isSelected ? 'true' : 'false') + '"'
          + ' tabindex="' + (isSelected ? '0' : '-1') + '"'
          + ' data-type-value="' + val + '">'
          + '<div class="fc-type-card__radio"></div>'
          + '<div class="fc-type-card__text">'
          + '<span class="fc-type-card__title">' + meta.title + '</span>'
          + (meta.desc ? '<span class="fc-type-card__desc">' + meta.desc + '</span>' : '')
          + '</div>'
          + '</div>';
      }
      typeCardsContainer.innerHTML = html;

      // Update accordion subtitle with current selection
      var typeSubtitle = document.getElementById('fc-step-type-subtitle');
      if (typeSubtitle) {
        var currentMeta = TYPE_CARD_META[state.frameType] || { title: state.frameType };
        typeSubtitle.textContent = currentMeta.title;
      }

      renderCrossLink();
    }

    function renderCrossLink() {
      if (!crossLinkEl) return;
      var productCategory = classifyProductTypes(frameTypeValues);

      if (productCategory === 'full' || productCategory === 'unknown') {
        crossLinkEl.style.display = 'none';
        return;
      }

      var targetHandle, promptText, altTypes;
      if (productCategory === 'paper-only') {
        targetHandle = crossLinkConfig.canvasProductHandle || '';
        promptText = 'M\u00F6chtest du eine Leinwand rahmen lassen?';
        altTypes = ['Digitale Leinwand', 'Leinwand nicht aufgespannt', 'Leinwand aufgespannt'];
      } else if (productCategory === 'canvas-only') {
        targetHandle = crossLinkConfig.paperProductHandle || '';
        promptText = 'M\u00F6chtest du ein Papier einrahmen?';
        altTypes = ['Digitaler Upload', 'Papierarbeit'];
      } else {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Auto-detect target from productsList if no section setting configured
      if (!targetHandle) {
        var neededCategory = (productCategory === 'paper-only') ? 'canvas' : 'paper';
        var neededKeys = (neededCategory === 'canvas') ? CANVAS_TYPE_KEYS : PAPER_TYPE_KEYS;
        for (var p = 0; p < productsList.length; p++) {
          var pl = productsList[p];
          if (pl.handle === productData.handle) continue;
          var plOpts = pl.options || [];
          for (var oi = 0; oi < plOpts.length; oi++) {
            var oName = (plOpts[oi].name || '').toLowerCase();
            if (oName === 'typ' || oName === 'type' || oName === 'rahmentyp') {
              var plVals = plOpts[oi].values || [];
              for (var vi = 0; vi < plVals.length; vi++) {
                if (neededKeys.indexOf(normalizeTypeKey(plVals[vi])) !== -1) {
                  targetHandle = pl.handle;
                  break;
                }
              }
              break;
            }
          }
          if (targetHandle) break;
        }
      }

      if (!targetHandle) {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Verify target exists in productsList
      var targetExists = false;
      for (var p2 = 0; p2 < productsList.length; p2++) {
        if (productsList[p2].handle === targetHandle) { targetExists = true; break; }
      }
      if (!targetExists) {
        crossLinkEl.style.display = 'none';
        return;
      }

      // Filter altTypes to only those available on target product
      var targetProduct = null;
      for (var tp = 0; tp < productsList.length; tp++) {
        if (productsList[tp].handle === targetHandle) { targetProduct = productsList[tp]; break; }
      }
      if (targetProduct) {
        var targetTypeValues = [];
        var tpOpts = targetProduct.options || [];
        for (var toi = 0; toi < tpOpts.length; toi++) {
          var toName = (tpOpts[toi].name || '').toLowerCase();
          if (toName === 'typ' || toName === 'type' || toName === 'rahmentyp') {
            targetTypeValues = tpOpts[toi].values || [];
            break;
          }
        }
        var targetNormalized = targetTypeValues.map(function (v) { return normalizeTypeKey(v); });
        altTypes = altTypes.filter(function (at) {
          return targetNormalized.indexOf(normalizeTypeKey(at)) !== -1;
        });
      }
      if (altTypes.length === 0) {
        crossLinkEl.style.display = 'none';
        return;
      }

      crossLinkEl.style.display = '';
      crossLinkText.textContent = promptText;

      // Render alternative type cards
      var html = '';
      for (var j = 0; j < altTypes.length; j++) {
        var val = altTypes[j];
        var meta = TYPE_CARD_META[val] || { title: val, desc: '' };
        html += '<div class="fc-type-card fc-type-card--cross"'
          + ' role="radio" aria-checked="false" tabindex="-1"'
          + ' data-cross-type="' + val + '"'
          + ' data-cross-handle="' + targetHandle + '">'
          + '<div class="fc-type-card__radio"></div>'
          + '<div class="fc-type-card__text">'
          + '<span class="fc-type-card__title">' + meta.title + '</span>'
          + (meta.desc ? '<span class="fc-type-card__desc">' + meta.desc + '</span>' : '')
          + '</div>'
          + '</div>';
      }
      crossLinkCards.innerHTML = html;
      // Reset expanded state
      crossLinkCards.style.display = 'none';
      if (crossLinkTrigger) crossLinkTrigger.classList.remove('fc-cross-link__trigger--open');
    }

    /* --- SVG PREVIEW --- */

    function renderPreview() {
      if (typeof window.generateFramePreviewSvg !== 'function') {
        console.log('[FrameConfigurator] Waiting for generateFramePreviewSvg...');
        setTimeout(renderPreview, 150);
        return;
      }

      try {
        var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

        var matType = 'none';
        if (state.ppType === 'einfach') matType = 'standard';
        if (state.ppType === 'freigestellt') matType = 'inner';
        if (state.ppType === 'hintergrundkarton') matType = 'backing';
        if (state.ppType === 'schwebend') matType = 'standard';

        var individualSizesForPreview = null;
        if (state.matWidth === 'individual') {
          individualSizesForPreview = {
            top: state.individualSizes.top,
            bottom: state.individualSizes.bottom,
            left: state.individualSizes.leftRight,
            right: state.individualSizes.leftRight
          };
        }

        var frameSpec = {
          imageUrl: state.imageUrl || '',
          frameConfig: {
            productId: productData.productId,
            frameImageLR: productData.frameImageLR || '',
            frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
            frameWidth: productData.frameBreiteMM || 24
          },
          matConfig: {
            type: matType,
            width: state.matWidth,
            color: state.matColor,
            colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
            individualSizes: individualSizesForPreview,
            floating: state.ppType === 'schwebend'
          },
          dimensions: { width: state.imageWidth, height: state.imageHeight },
          rotation: 0
        };

        var svgMarkup = window.generateFramePreviewSvg(frameSpec);
        previewContainer.innerHTML = svgMarkup;

        var svgEl = previewContainer.querySelector('svg');
        if (svgEl) {
          svgEl.removeAttribute('width');
          svgEl.removeAttribute('height');
          svgEl.style.maxWidth = '92%';
          svgEl.style.maxHeight = '92%';
          svgEl.style.width = 'auto';
          svgEl.style.height = 'auto';
        }

        updateThumbnailPreview();
        updateMobilePreview();
      } catch (err) {
        console.warn('[FrameConfigurator] renderPreview error:', err);
      }
    }

    /* --- THUMBNAIL SYNC --- */

    function updateThumbnailPreview() {
      var thumbnailContainer = document.getElementById('fc-thumbnail-preview');
      if (!thumbnailContainer || !previewContainer) return;

      var mainSvg = previewContainer.querySelector('svg');
      if (!mainSvg) return;

      var clone = mainSvg.cloneNode(true);
      clone.style.width = '100%';
      clone.style.height = '100%';
      thumbnailContainer.innerHTML = '';
      thumbnailContainer.appendChild(clone);
    }

    /**
     * Sync the mobile split-screen preview with the current SVG.
     * WhiteWall-style: large canvas at top, SVG scales responsively.
     */
    function updateMobilePreview() {
      if (!mobilePreviewImage || !isMobileQuery.matches) return;

      var mainSvg = previewContainer.querySelector('svg');
      if (mainSvg) {
        var clone = mainSvg.cloneNode(true);
        // Remove explicit width/height attrs so viewBox controls aspect ratio.
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.style.width = '';
        clone.style.height = '';
        clone.style.maxWidth = '100%';
        clone.style.maxHeight = '100%';

        // Deduplicate pattern/clipPath IDs to avoid conflicts with main SVG.
        // Duplicate IDs cause fill="url(#...)" to reference the wrong (hidden) element.
        var suffix = '-mob';
        var idEls = clone.querySelectorAll('[id]');
        for (var i = 0; i < idEls.length; i++) {
          var oldId = idEls[i].id;
          idEls[i].id = oldId + suffix;
        }
        // Update all url(#...) references in fill, stroke, clip-path, mask attrs
        var refAttrs = ['fill', 'stroke', 'clip-path', 'mask'];
        var allEls = clone.querySelectorAll('*');
        for (var j = 0; j < allEls.length; j++) {
          for (var k = 0; k < refAttrs.length; k++) {
            var val = allEls[j].getAttribute(refAttrs[k]);
            if (val && val.indexOf('url(#') !== -1) {
              allEls[j].setAttribute(refAttrs[k], val.replace(/url\(#([^)]+)\)/g, 'url(#$1' + suffix + ')'));
            }
          }
        }

        mobilePreviewImage.innerHTML = '';
        mobilePreviewImage.appendChild(clone);
      }
    }

    /* --- MOBILE PREVIEW GALLERY (swipeable carousel: SVG + product images) --- */

    /**
     * Populate the mobile preview carousel with product images.
     * Slide 0 (SVG) is always present in the HTML.
     * Slides 1+ are product images, dynamically created here.
     */
    function populateMobileGallery(images) {
      if (!mobilePreviewSlider) return;

      // Remove existing product image slides + suspension slide (keep SVG slide)
      var oldSlides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide--image, .fc-mobile-preview__slide--suspension');
      for (var i = 0; i < oldSlides.length; i++) oldSlides[i].remove();

      var svgSlide = mobilePreviewSlider.querySelector('.fc-mobile-preview__slide--svg');
      var orderedImages = reorderImagesForUpload(images);
      if (orderedImages && orderedImages.length > 0) {
        for (var j = 0; j < orderedImages.length; j++) {
          var slide = document.createElement('div');
          slide.className = 'fc-mobile-preview__slide fc-mobile-preview__slide--image';
          var img = document.createElement('img');
          img.src = orderedImages[j].url;
          img.alt = orderedImages[j].alt || '';
          img.loading = 'lazy';
          slide.appendChild(img);
          if (_userHasConfigured) {
            // SVG first, product images after
            mobilePreviewSlider.appendChild(slide);
          } else {
            // Product images first, SVG last
            mobilePreviewSlider.insertBefore(slide, svgSlide);
          }
        }
      }

      // Append suspension slide (same behaviour as Desktop).
      // Only add if at least one suspension option button has a data-suspension-image.
      var hasSuspensionImg = !!document.querySelector('#fc-suspension-options [data-suspension-image]');
      if (hasSuspensionImg) {
        var susSlide = document.createElement('div');
        susSlide.className = 'fc-mobile-preview__slide fc-mobile-preview__slide--suspension';
        var susImg = document.createElement('img');
        susImg.id = 'fc-mobile-suspension-image';
        susImg.alt = 'Aufhängung';
        susImg.loading = 'lazy';
        var activeBtn = document.querySelector('#fc-suspension-options .fc-option-btn--active[data-suspension]');
        susImg.src = activeBtn ? (activeBtn.getAttribute('data-suspension-image') || '') : '';
        susSlide.appendChild(susImg);
        mobilePreviewSlider.appendChild(susSlide);
      }

      updateMobilePreviewDots();
    }

    /**
     * Rebuild the dot indicators for the mobile preview carousel.
     */
    function updateMobilePreviewDots() {
      if (!mobilePreviewDots || !mobilePreviewSlider) return;
      var slides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide');
      mobilePreviewDots.innerHTML = '';
      if (slides.length < 2) return;

      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fc-mobile-preview__dot' + (i === 0 ? ' fc-mobile-preview__dot--active' : '');
        dot.setAttribute('aria-label', 'Bild ' + (i + 1));
        dot.dataset.index = String(i);
        mobilePreviewDots.appendChild(dot);
      }
    }

    // Scroll handler — update active dot on swipe
    if (mobilePreviewSlider) {
      mobilePreviewSlider.addEventListener('scroll', debounce(function () {
        if (!mobilePreviewDots) return;
        var scrollLeft = mobilePreviewSlider.scrollLeft;
        var slideWidth = mobilePreviewSlider.offsetWidth;
        if (slideWidth === 0) return;
        var activeIndex = Math.round(scrollLeft / slideWidth);
        var dots = mobilePreviewDots.querySelectorAll('.fc-mobile-preview__dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('fc-mobile-preview__dot--active', i === activeIndex);
        }
      }, 50));
    }

    // Dot click handler — scroll to corresponding slide
    if (mobilePreviewDots) {
      mobilePreviewDots.addEventListener('click', function (e) {
        var dot = e.target.closest('.fc-mobile-preview__dot');
        if (!dot || !mobilePreviewSlider) return;
        var idx = parseInt(dot.dataset.index, 10);
        var slides = mobilePreviewSlider.querySelectorAll('.fc-mobile-preview__slide');
        if (slides[idx]) {
          mobilePreviewSlider.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
        }
      });
    }

    // Arrow click handlers — prev/next slide
    function scrollMobilePreviewBy(direction) {
      if (!mobilePreviewSlider) return;
      var slideWidth = mobilePreviewSlider.offsetWidth;
      mobilePreviewSlider.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
    }
    if (mobilePreviewPrev) {
      mobilePreviewPrev.addEventListener('click', function () { scrollMobilePreviewBy(-1); });
    }
    if (mobilePreviewNext) {
      mobilePreviewNext.addEventListener('click', function () { scrollMobilePreviewBy(1); });
    }

    /* --- GALLERY NAVIGATION --- */

    var _sectionId = '';
    (function findSectionId() {
      // Try product-info element first (standard product page)
      var sectionEl = document.querySelector('product-info[data-section]');
      if (sectionEl) { _sectionId = sectionEl.dataset.section; return; }
      // Fallback: extract section ID from media-gallery element (configurator page)
      var galleryEl = document.querySelector('media-gallery[id^="MediaGallery-"]');
      if (galleryEl) { _sectionId = galleryEl.id.replace('MediaGallery-', ''); return; }
      // Fallback: extract from configurator container data attribute
      var fcContainer = document.getElementById('frame-configurator');
      if (fcContainer && fcContainer.dataset.sectionId) { _sectionId = fcContainer.dataset.sectionId; }
    })();

    // Flag: true when user manually clicked a gallery thumbnail
    // Prevents auto-scroll to SVG preview from overriding user choice
    var _userClickedThumbnail = false;
    // Flag: false during init, true after first update — prevents auto-scroll on page load
    var _initialized = false;
    // Flag: true after user changes size, PP, or uploads an image — triggers SVG-first gallery
    var _userHasConfigured = false;
    /* Nur fuer size_entered: _userHasConfigured wird auch von einem Passepartout-Klick
       gesetzt und wuerde dann die unberuehrte Startgroesse als Eingabe melden. */
    var _sizeTouched = false;

    /* Einsende-Typen (alles ausser Digital): Der Kunde misst sein Werk selbst.
       Kein Preis, kein Warenkorb und keine Masse in der URL, bevor er Breite UND
       Hoehe selbst eingetragen hat. Die 30x40 im state bleiben nur fuer die
       Vorschau. Masse aus der URL zaehlen als eingetragen. */
    var _sizeEntered = { w: false, h: false };
    var _lastWasSendIn = null;

    function isSendInType() {
      return normalizeTypeKey(state.frameType).indexOf('digital') === -1;
    }

    function needsSizeEntry() {
      if (!_sizeEntered) return false; // vor der Initialisierung (Hoisting)
      return isSendInType() && !(_sizeEntered.w && _sizeEntered.h);
    }

    /* Leere Felder fuer Einsende-Typen, Werte zurueck fuer Digital. Ein Feld
       mit Fokus bleibt unangetastet, sonst springt die Eingabe. */
    function syncDimensionInputs() {
      [[widthInput, 'w', state.imageWidth], [heightInput, 'h', state.imageHeight]].forEach(function (f) {
        var input = f[0];
        if (!input || document.activeElement === input) return;
        if (isSendInType() && !_sizeEntered[f[1]]) {
          input.value = '';
        } else if (input.value === '') {
          input.value = f[2];
        }
      });
    }

    function scrollGalleryToPreview() {
      if (!_sectionId) return;
      if (_userClickedThumbnail) return; // User clicked a thumbnail — don't override

      var mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery || typeof mediaGallery.setActiveMedia !== 'function') return;

      var previewMediaId = _sectionId + '-fc-preview';
      var activeSlides = mediaGallery.querySelectorAll('.product__media-item.is-active');

      // Skip only if the preview is the sole active slide
      if (activeSlides.length === 1 && activeSlides[0].dataset.mediaId === previewMediaId) return;

      mediaGallery.setActiveMedia(previewMediaId, false, false);
    }

    /**
     * Re-bind click handlers for gallery thumbnails (after dynamic DOM updates).
     * Also resets slider pages so new slides are recognized.
     * Sets _userClickedThumbnail = true on click so auto-scroll is suppressed.
     */
    function reBindGalleryThumbnails() {
      var mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery || !mediaGallery.elements || !mediaGallery.elements.thumbnails) return;

      mediaGallery.elements.thumbnails.querySelectorAll('[data-target]').forEach(function (mediaToSwitch) {
        var btn = mediaToSwitch.querySelector('button');
        if (!btn || btn._fcBound) return; // Skip if already bound
        btn._fcBound = true;
        btn.addEventListener('click', function () {
          _userClickedThumbnail = true;
          mediaGallery.setActiveMedia(mediaToSwitch.dataset.target, false, true);
        });
      });

      // Tell both sliders to re-discover their slide items
      // Wrapped in try-catch because Dawn's resetPages() may access
      // elements that aren't fully initialized yet (null .style access)
      try {
        var viewer = mediaGallery.elements.viewer;
        if (viewer && typeof viewer.resetPages === 'function') {
          viewer.resetPages();
        }
        var thumbSlider = mediaGallery.elements.thumbnails;
        if (thumbSlider && typeof thumbSlider.resetPages === 'function') {
          thumbSlider.resetPages();
        }
      } catch (e) {
        // Dawn slider not fully initialized — safe to ignore
      }
    }

    /* --- GALLERY DOTS --- */

    var _galleryDotsScrollHandler = null;

    function initGalleryDots() {
      var slider = document.querySelector('.product__media-list');
      if (!slider) return;
      var slides = slider.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;

      // Remove existing dots (idempotent)
      var existingDots = document.querySelector('.fc-gallery-dots');
      if (existingDots) existingDots.remove();

      // Remove previous scroll handler
      if (_galleryDotsScrollHandler) {
        slider.removeEventListener('scroll', _galleryDotsScrollHandler);
      }

      // Create dots container
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'fc-gallery-dots';
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'fc-gallery-dot' + (i === 0 ? ' fc-gallery-dot--active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Bild ' + (i + 1));
        dot.dataset.index = i;
        dotsWrap.appendChild(dot);
      }

      // Insert dots after the slider (before thumbnail-slider)
      var mediaWrapper = slider.closest('.product__media-gallery');
      if (mediaWrapper) {
        var thumbSlider = mediaWrapper.querySelector('.thumbnail-slider');
        if (thumbSlider) {
          mediaWrapper.insertBefore(dotsWrap, thumbSlider);
        } else {
          mediaWrapper.appendChild(dotsWrap);
        }
      }

      // Move arrows below dots (desktop: Image → Dots → Arrows)
      var sliderButtons = document.querySelector('.product__media-wrapper .slider-buttons');
      if (sliderButtons && dotsWrap && dotsWrap.parentNode) {
        dotsWrap.parentNode.insertBefore(sliderButtons, dotsWrap.nextSibling);
      }

      // Click handler for dots — query slides fresh to avoid stale references after reorder
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.fc-gallery-dot');
        if (!dot) return;
        var idx = parseInt(dot.dataset.index, 10);
        var currentSlides = slider.querySelectorAll('.product__media-item');
        var targetSlide = currentSlides[idx];
        if (targetSlide) {
          slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
      });

      // Scroll handler — update active dot
      _galleryDotsScrollHandler = debounce(function () {
        var scrollLeft = slider.scrollLeft;
        var slideWidth = slider.offsetWidth;
        var activeIndex = Math.round(scrollLeft / slideWidth);
        var dots = dotsWrap.querySelectorAll('.fc-gallery-dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('fc-gallery-dot--active', i === activeIndex);
        }
      }, 50);
      slider.addEventListener('scroll', _galleryDotsScrollHandler);
    }

    /* --- PRODUCT SWITCHING --- */

    /**
     * Detect if we are on the standalone configurator page.
     * If so, we can switch products entirely client-side (instant).
     * If not (normal product page), navigate to the configurator page.
     */
    var fcModeEl = document.getElementById('frame-configurator');
    var fcMode = (fcModeEl && fcModeEl.dataset.fcMode) || 'configurator';
    var isConfiguratorPage = (fcMode === 'configurator');
    var isProductPage = (fcMode === 'product');

    /**
     * Build URL params string from current configurator state.
     */
    function buildStateParams(targetHandle, targetVariantId) {
      var params = new URLSearchParams();
      params.set('product', targetHandle);
      if (state.frameType && state.frameType !== '_default') params.set('frameType', state.frameType);
      params.set('ppType', state.ppType);
      params.set('matWidth', state.matWidth);
      params.set('matColor', state.matColor);
      if (!isSendInType() || _sizeEntered.w) params.set('width', state.imageWidth);
      if (!isSendInType() || _sizeEntered.h) params.set('height', state.imageHeight);
      /* masse=1: Masse stammen vom Kunden. Links ohne diesen Marker (Startseiten-
         Kacheln, Ads, Mails mit width/height) zeigen keinen Preis vorab. */
      if (isSendInType() && (_sizeEntered.w || _sizeEntered.h)) params.set('masse', '1');
      if (state.matWidth === 'individual') {
        params.set('matTop', state.individualSizes.top);
        params.set('matBottom', state.individualSizes.bottom);
        params.set('matSides', state.individualSizes.leftRight);
      }
      if (targetVariantId) params.set('variant', targetVariantId);
      return params;
    }

    /**
     * Update page-level DOM elements (title, vendor, description, images)
     * when switching products on the configurator page.
     */
    function updatePageInfo(target) {
      // Title
      var titleEl = document.getElementById('fc-page-title');
      if (titleEl) titleEl.textContent = target.title;
      // Mobile info bar title
      if (mobileInfoTitle) mobileInfoTitle.textContent = target.title;

      // Breadcrumb product name
      var breadcrumbEl = document.getElementById('fc-page-breadcrumb-product');
      if (breadcrumbEl) breadcrumbEl.textContent = target.title;

      // Vendor
      var vendorEl = document.getElementById('fc-page-vendor');
      if (vendorEl && target.vendor) {
        vendorEl.innerHTML = '<a href="/collections/vendors?q=' + encodeURIComponent(target.vendor) + '" class="link">' + target.vendor + '</a>';
      }

      // Description
      var descEl = document.getElementById('fc-page-description');
      if (descEl && target.description !== undefined) {
        descEl.innerHTML = target.description;
      }

      // Price — handled by update() which sets the correct config price on #fc-page-price

      // Page title
      document.title = target.title + ' – ' + (window.Shopify && window.Shopify.shop ? window.Shopify.shop.replace('.myshopify.com', '') : 'Shop');

      // Product images in gallery — remove old ones and insert new
      var oldImages = document.querySelectorAll('.fc-page-product-image');
      var oldThumbs = document.querySelectorAll('.fc-page-product-thumb');

      if (target.images && target.images.length > 0) {
        // Find the gallery <ul> and thumbnail <ul> from the first old element or by ID pattern
        var galleryUl = oldImages.length > 0
          ? oldImages[0].parentElement
          : document.querySelector('[id^="Slider-Gallery-"]');
        var thumbUl = oldThumbs.length > 0
          ? oldThumbs[0].parentElement
          : document.querySelector('[id^="Slider-Thumbnails-"]');

        // Determine section ID from gallery
        var sectionId = galleryUl ? (galleryUl.id || '').replace('Slider-Gallery-', '') : '';

        // Remove old product image slides
        for (var ri = 0; ri < oldImages.length; ri++) oldImages[ri].remove();
        for (var rt = 0; rt < oldThumbs.length; rt++) oldThumbs[rt].remove();

        // Insert new product image slides (reorder if image uploaded)
        var orderedImgs = reorderImagesForUpload(target.images);
        for (var i = 0; i < orderedImgs.length; i++) {
          var img = orderedImgs[i];
          var pos = i + 1;
          var ratio = img.height && img.width ? (img.height / img.width * 100) : 133;

          // Main gallery slide
          var li = document.createElement('li');
          li.id = 'Slide-' + sectionId + '-img-' + pos;
          li.className = 'product__media-item grid__item slider__slide fc-page-product-image';
          li.setAttribute('data-media-id', sectionId + '-img-' + pos);
          li.setAttribute('data-media-position', String(pos));
          li.innerHTML = '<div class="media media--adapt" style="padding-bottom:' + ratio + '%;">'
            + '<img src="' + img.url + '" alt="' + (img.alt || target.title) + '" loading="lazy" width="' + (img.width || '') + '" height="' + (img.height || '') + '">'
            + '</div>';
          if (galleryUl) galleryUl.appendChild(li);

          // Thumbnail slide
          var thumbLi = document.createElement('li');
          thumbLi.id = 'Slide-Thumbnails-' + sectionId + '-' + pos;
          thumbLi.className = 'thumbnail-list__item slider__slide media-wrapper media-wrapper--small fc-page-product-thumb';
          thumbLi.setAttribute('data-target', sectionId + '-img-' + pos);
          thumbLi.setAttribute('data-media-position', String(pos));
          thumbLi.innerHTML = '<button class="thumbnail media media--square" aria-controls="GalleryViewer-' + sectionId + '">'
            + '<img src="' + img.url + '" alt="' + (img.alt || target.title) + '" loading="lazy">'
            + '</button>';
          if (thumbUl) thumbUl.appendChild(thumbLi);
        }

        // Update slide counter
        if (galleryUl) {
          var counterWrap = galleryUl.closest('.slider-mobile-gutter');
          if (counterWrap) {
            var totalEl = counterWrap.querySelector('.slider-counter--total');
            if (totalEl) totalEl.textContent = String(target.images.length + 1);
          }
        }
      }

      // Re-bind gallery thumbnail click handlers for newly created elements
      reBindGalleryThumbnails();
    }

    /**
     * Switch to a different frame product.
     * On configurator page: instant client-side swap.
     * On product page: navigate to configurator page with state params.
     */
    function switchProduct(handle) {
      if (handle === productData.handle) return;

      // 1. Find target product in the pre-rendered list
      var targetProduct = null;
      for (var i = 0; i < productsList.length; i++) {
        if (productsList[i].handle === handle) {
          targetProduct = productsList[i];
          break;
        }
      }
      if (!targetProduct) {
        console.error('[FrameConfigurator] Product not found in list:', handle);
        return;
      }

      // 2. Look up the matching variant on the target product
      var targetIdx = allProductVariantIndexes[handle];
      var targetVariantId = null;
      if (targetIdx) {
        var sizeCategory = getSizeCategory(
          state.imageWidth, state.imageHeight,
          state.ppType === 'ohne' ? 'ohne' : state.matWidth,
          productData.frameBreiteMM, state.ppType, state.individualSizes
        );
        var variant = lookupVariant(targetIdx, state.frameType, sizeCategory, state.ppType);
        if (!variant) {
          var typeKeys = Object.keys(targetIdx);
          for (var t = 0; t < typeKeys.length; t++) {
            variant = lookupVariant(targetIdx, typeKeys[t], sizeCategory, state.ppType);
            if (variant) break;
          }
        }
        if (variant) targetVariantId = variant.id;
      }

      // 3. Save uploaded image URL to sessionStorage
      if (state.imageUrl && !state.imageUrl.startsWith('blob:')) {
        try { sessionStorage.setItem('fc-transfer-imageUrl', state.imageUrl); } catch (e) { /* ignore */ }
      }

      // --- CLIENT-SIDE SWITCH (shared by configurator page AND product page) ---
      if (isConfiguratorPage || isProductPage) {
        console.log('[FrameConfigurator] Client-side switch to:', handle, '(mode:', fcMode, ')');

        // Update productData with new product's data
        productData.frameImageLR = targetProduct.frameImageLR;
        productData.frameImageTB = targetProduct.frameImageTB || targetProduct.frameImageLR;
        productData.frameBreiteMM = targetProduct.frameBreiteMM;
        productData.frameHoeheMM = targetProduct.frameHoeheMM;
        productData.farbBeschreibung = targetProduct.farbBeschreibung;
        productData.title = targetProduct.title;
        productData.handle = handle;
        productData.productId = targetProduct.productId;
        productData.url = targetProduct.url;
        productData.priceMin = targetProduct.priceMin;
        productData.options = targetProduct.options;

        // Rebuild variant index for the new product
        variantIndex = allProductVariantIndexes[handle] || variantIndex;

        // Update frame type options from product options metadata
        var newTypeKeys = [];
        if (targetProduct.options && Array.isArray(targetProduct.options)) {
          for (var oi = 0; oi < targetProduct.options.length; oi++) {
            var optName = (targetProduct.options[oi].name || '').toLowerCase();
            if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
              newTypeKeys = targetProduct.options[oi].values || [];
              break;
            }
          }
        }
        // Fallback to variant index keys if no options metadata
        if (newTypeKeys.length === 0) {
          newTypeKeys = Object.keys(variantIndex);
        }
        // Detect truncation for switched product (lazy loading approach)
        var switchTruncated = isProductTruncated(targetProduct.options, variantIndex);
        productIsTruncated = switchTruncated;

        if (switchTruncated && storefrontConfig.token) {
          // Truncated: show ALL type cards, lazy-load missing types on click
          newTypeKeys = sortTypeValues(newTypeKeys);
          console.log('[FrameConfigurator] Switched to truncated product:', handle,
            '- showing all', newTypeKeys.length, 'types (lazy-load on click)');
        } else {
          // Normal: filter to types with actual variant data
          newTypeKeys = sortTypeValues(newTypeKeys.filter(function (tv) {
            return tv === '_default' || variantIndex[tv];
          }));
        }

        if (newTypeKeys.length > 0 && newTypeKeys[0] !== '_default') {
          frameTypeValues = newTypeKeys;
          allTypeValues = newTypeKeys.slice();
          // Check URL params for a requested frameType (may not have matched the
          // initial product but could be valid for this switched product)
          var urlParams = new URLSearchParams(window.location.search);
          var urlFrameType = urlParams.get('frameType');
          if (urlFrameType && frameTypeValues.indexOf(urlFrameType) !== -1) {
            state.frameType = urlFrameType;
          } else if (switchTruncated && frameTypeValues.indexOf(state.frameType) === -1) {
            // For truncated products, prefer a type that has loaded variant data
            var foundLoaded = false;
            for (var ltk = 0; ltk < frameTypeValues.length; ltk++) {
              if (variantIndex[frameTypeValues[ltk]]) {
                state.frameType = frameTypeValues[ltk];
                foundLoaded = true;
                break;
              }
            }
            if (!foundLoaded) state.frameType = frameTypeValues[0];
          } else if (frameTypeValues.indexOf(state.frameType) === -1) {
            state.frameType = frameTypeValues[0];
          }
          renderTypeCards();
        }

        // Objektrahmung-Sonderregel: PP muss auf Hintergrundkarton stehen.
        // Muss nach dem frameType-Setzen laufen, sonst bleibt der alte ppType hängen.
        syncPPForFrameType();

        // Re-render SVG preview + price immediately
        update();

        // Proactive variant loading: if product is truncated, immediately fetch ALL
        // variants via Storefront API so every clickable option has data ready.
        if (switchTruncated && storefrontConfig.token && !allProductVariantIndexes[handle + '__full']) {
          var fetchHandle = handle;
          priceEl.textContent = 'Lade Preise\u2026';
          if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
          atcButton.disabled = true;
          lazyFetchVariants(fetchHandle, targetProduct.productId, function (newIndex) {
            if (productData.handle !== fetchHandle) return;
            variantIndex = newIndex;
            productIsTruncated = false;
            update();
          });
        }

        // Update frame info box with new product's dimensions
        updateFrameInfoBox(targetProduct);

        // Update page-level info (title, images, description, etc.)
        updatePageInfo(targetProduct);

        // Update mobile preview gallery with new product images
        populateMobileGallery(targetProduct.images);
        if (mobilePreviewSlider) {
          mobilePreviewSlider.scrollTo({ left: 0, behavior: 'instant' });
        }

        // After product switch: if customer uploaded an image, stay on SVG preview;
        // otherwise scroll to first product image.
        _userClickedThumbnail = false;
        if (!state.imageUrl) {
          var firstImgSlide = document.querySelector('.fc-page-product-image');
          if (firstImgSlide) {
            var mediaGallery = document.querySelector('media-gallery');
            if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
              mediaGallery.setActiveMedia(firstImgSlide.dataset.mediaId, false, false);
            }
          }
        } else {
          scrollGalleryToPreview();
        }

        // Rebuild gallery dots (slide count may have changed)
        refreshGalleryAfterReorder();

        // Re-render product switcher to update active swatch
        renderProductSwitcher();

        // Update URL without reload (build params AFTER frameType is set correctly)
        var stateParams = buildStateParams(handle, targetVariantId);
        if (isProductPage) {
          // Product page: URL is /products/<handle>?params
          stateParams.delete('product');
          var newUrl = '/products/' + handle + '?' + stateParams.toString();
          window.history.pushState({ fcHandle: handle }, '', newUrl);
        } else {
          // Configurator page: URL stays on same path with ?product=handle
          var newUrl = window.location.pathname + '?' + stateParams.toString();
          window.history.pushState({ fcHandle: handle }, '', newUrl);
        }

        return;
      }

      // --- FALLBACK: navigate to configurator page ---
      var stateParams = buildStateParams(handle, targetVariantId);
      var configuratorUrl = '/pages/konfigurator?' + stateParams.toString();
      console.log('[FrameConfigurator] Navigating to configurator page:', configuratorUrl);
      window.location.href = configuratorUrl;
    }

    /* --- AVAILABILITY CHECKING --- */

    /**
     * Update availability indicators on PP type buttons, PP color swatches,
     * and suspension options. Called at the end of update().
     */
    function updateAvailability() {
      // Get current size category for availability check
      var sizeCategory = getSizeCategory(
        state.imageWidth, state.imageHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );
      var sizeKey = normalizeSizeKey(sizeCategory);
      var typeMap = variantIndex[state.frameType] || {};
      var sizeMap = typeMap[sizeKey] || {};

      // PP type buttons: mark unavailable only if no variant exists for that PP type
      // Must compute size category PER PP type, since PP changes the perimeter
      if (ppTypeOptions) {
        var currentHandle = productData.handle || '';
        var isHighFrame = /-high$/.test(currentHandle);
        var standardHandle = isHighFrame ? currentHandle.replace(/-high$/, '') : currentHandle;
        var highHandle = isHighFrame ? currentHandle : currentHandle + '-high';
        var hasStandardCounterpart = !!allProductVariantIndexes[standardHandle];
        var hasHighCounterpart = !!allProductVariantIndexes[highHandle];

        ppTypeOptions.querySelectorAll('[data-pp-type]').forEach(function (btn) {
          var ppKey = normalizePPType(btn.dataset.ppType);
          var matWidthForCheck = ppKey === 'ohne' ? 'ohne' : state.matWidth;
          var sizeCatForPP = getSizeCategory(
            state.imageWidth, state.imageHeight,
            matWidthForCheck,
            productData.frameBreiteMM, ppKey, state.individualSizes
          );
          var sizeKeyForPP = normalizeSizeKey(sizeCatForPP);
          var sizeMapForPP = typeMap[sizeKeyForPP] || {};
          var isAvailable = Boolean(sizeMapForPP[ppKey]);
          // Fallback: if 'ohne' exists at this size, variant lookup will find it
          if (!isAvailable && ppKey !== 'ohne') {
            isAvailable = Boolean(sizeMapForPP['ohne']);
          }
          // Cross-product Verfügbarkeit: Schwebend hat Pendant auf -high; andere
          // PP-Typen haben Pendant auf Standard-Rahmen. Klick wechselt das Produkt
          // (Schwebend: Mismatch-Dialog; andere: direkt zurück zu Standard-Rahmen).
          if (!isAvailable) {
            if (ppKey === 'schwebend' && hasHighCounterpart) {
              isAvailable = true;
            } else if (ppKey !== 'schwebend' && isHighFrame && hasStandardCounterpart) {
              isAvailable = true;
            }
          }
          btn.classList.toggle('fc-option-btn--unavailable', !isAvailable);
        });
      }

      // PP color restriction by outer dimensions
      // Only Naturweiß, Hellweiß, Creme, Schwarz available up to max size (110×90)
      // All others only up to Außenmaß 100×80 / 80×100
      if (ppColorGrid && state.ppType !== 'ohne') {
        var isNoPP = state.ppType === 'ohne';
        var matTopCM = 0, matBottomCM = 0, matLeftRightCM = 0;
        if (!isNoPP) {
          if (state.matWidth === 'individual' && state.individualSizes) {
            matTopCM = state.individualSizes.top || 0;
            matBottomCM = state.individualSizes.bottom || 0;
            matLeftRightCM = state.individualSizes.leftRight || 0;
          } else {
            var preset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
            matTopCM = preset.top;
            matBottomCM = preset.bottom;
            matLeftRightCM = preset.leftRight;
          }
        }
        var outerWidth = state.imageWidth + 2 * matLeftRightCM + 2 * (productData.frameBreiteMM / 10);
        var outerHeight = state.imageHeight + matTopCM + matBottomCM + 2 * (productData.frameHoeheMM / 10);
        // Over limit: outer dimensions exceed 100×80 or 80×100
        var isOverColorLimit = (outerWidth > 100 && outerHeight > 80) || (outerHeight > 100 && outerWidth > 80);

        var needsColorSwitch = false;
        ppColorGrid.querySelectorAll('[data-mat-color]').forEach(function (swatch) {
          var color = swatch.dataset.matColor;
          var isFullSize = FULL_SIZE_MAT_COLORS.indexOf(color) !== -1;
          var isDisabled = !isFullSize && isOverColorLimit;
          swatch.classList.toggle('fc-swatch--disabled', isDisabled);
          swatch.disabled = isDisabled;
          if (isDisabled && color === state.matColor) needsColorSwitch = true;
        });

        // Auto-switch to allowed color if current is disabled
        if (needsColorSwitch) {
          state.matColor = 'naturweiss';
          var fallback = ppColorGrid.querySelector('[data-mat-color="naturweiss"]');
          if (fallback) {
            setActiveSwatch(ppColorGrid, fallback);
            ppColorHint.textContent = fallback.dataset.matDisplayName || '';
          }
        }
      }

      // PP width preset availability: disable presets that would exceed outer limit
      // OR have no matching variant in the index for the resulting size category
      if (ppWidthOptions && state.ppType !== 'ohne') {
        var needsWidthSwitch = false;
        ppWidthOptions.querySelectorAll('[data-pp-width]').forEach(function (btn) {
          var widthKey = btn.dataset.ppWidth;
          if (widthKey === 'individual') {
            // Individual is always shown; constrained via dynamic input max
            btn.classList.remove('fc-option-btn--disabled');
            btn.disabled = false;
            return;
          }
          var wPreset = PRESET_PASSPARTOUT_DIMENSIONS[widthKey];
          if (!wPreset) return;

          // Check 1: outer dimensions fit within 110×90
          var wOuter = calculateOuterDimensions(
            state.imageWidth, state.imageHeight,
            wPreset.top, wPreset.bottom, wPreset.leftRight
          );
          var wFits = fitsOuterLimit(wOuter.width, wOuter.height);

          // Check 2: a variant exists for this width's size category + current PP type
          var hasVariant = false;
          if (wFits) {
            var wSizeCat = getSizeCategory(
              state.imageWidth, state.imageHeight,
              widthKey,
              productData.frameBreiteMM, state.ppType, null
            );
            var wSizeKey = normalizeSizeKey(wSizeCat);
            var wSizeMap = typeMap[wSizeKey] || {};
            var wPPKey = normalizePPType(state.ppType);
            hasVariant = Boolean(wSizeMap[wPPKey]) || Boolean(wSizeMap['ohne']);
          }

          var isAvailable = wFits && hasVariant;
          btn.classList.toggle('fc-option-btn--disabled', !isAvailable);
          btn.disabled = !isAvailable;
          if (!isAvailable && widthKey === state.matWidth) needsWidthSwitch = true;
        });

        // Auto-fallback to smaller PP width if current is disabled
        if (needsWidthSwitch) {
          var fallbackWidths = ['standard', 'thin'];
          var foundFallback = false;
          for (var fw = 0; fw < fallbackWidths.length; fw++) {
            var fbPreset = PRESET_PASSPARTOUT_DIMENSIONS[fallbackWidths[fw]];
            var fbOuter = calculateOuterDimensions(
              state.imageWidth, state.imageHeight,
              fbPreset.top, fbPreset.bottom, fbPreset.leftRight
            );
            if (!fitsOuterLimit(fbOuter.width, fbOuter.height)) continue;
            // Also check variant exists for this fallback width
            var fbSizeCat = getSizeCategory(
              state.imageWidth, state.imageHeight,
              fallbackWidths[fw],
              productData.frameBreiteMM, state.ppType, null
            );
            var fbSizeKey = normalizeSizeKey(fbSizeCat);
            var fbSizeMap = typeMap[fbSizeKey] || {};
            var fbPPKey = normalizePPType(state.ppType);
            if (Boolean(fbSizeMap[fbPPKey]) || Boolean(fbSizeMap['ohne'])) {
              state.matWidth = fallbackWidths[fw];
              syncButtonState(ppWidthOptions, 'data-pp-width', state.matWidth);
              toggleIndividualInputs();
              foundFallback = true;
              break;
            }
          }
          // If no preset fits, switch to ohne
          if (!foundFallback) {
            state.ppType = 'ohne';
            syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
            togglePPOptions();
          }
        }
      }

      // Clamp individual PP sizes based on available space
      if (state.ppType !== 'ohne' && state.matWidth === 'individual') {
        clampIndividualSizes();
      }

      // Suspension availability
      updateSuspensionAvailability();
    }

    /**
     * Clamp individual PP size inputs to ensure outer dimensions stay within 110×90 limit.
     */
    function clampIndividualSizes() {
      var frameWidthCM = productData.frameBreiteMM / 10;
      var frameHeightCM = (productData.frameHoeheMM || productData.frameBreiteMM) / 10;

      // Max left/right so outerWidth <= 110
      var maxLR = Math.floor(((110 - state.imageWidth - 2 * frameWidthCM) / 2) * 10) / 10;
      maxLR = Math.min(25, Math.max(2, maxLR));

      // Max vertical total so outerHeight <= 110
      var maxVerticalTotal = 110 - state.imageHeight - 2 * frameHeightCM;
      var maxTop = Math.min(25, Math.max(2, Math.floor((maxVerticalTotal - 2) * 10) / 10));
      var maxBottom = Math.min(25, Math.max(2, Math.floor((maxVerticalTotal - 2) * 10) / 10));

      // Update input max attributes
      var matTopInput = document.getElementById('fc-mat-top');
      var matBottomInput = document.getElementById('fc-mat-bottom');
      var matSidesInput = document.getElementById('fc-mat-sides');
      if (matSidesInput) matSidesInput.max = maxLR;
      if (matTopInput) matTopInput.max = maxTop;
      if (matBottomInput) matBottomInput.max = maxBottom;

      // Clamp current values if they exceed new max
      if (state.individualSizes.leftRight > maxLR) {
        state.individualSizes.leftRight = maxLR;
        if (matSidesInput) matSidesInput.value = maxLR;
      }
      if (state.individualSizes.top > maxTop) {
        state.individualSizes.top = maxTop;
        if (matTopInput) matTopInput.value = maxTop;
      }
      if (state.individualSizes.bottom > maxBottom) {
        state.individualSizes.bottom = maxBottom;
        if (matBottomInput) matBottomInput.value = maxBottom;
      }
    }

    /**
     * Update suspension option availability based on total frame width.
     * Zacken: only up to 50cm total width.
     * Seil / Wall Buddies: only from 30cm total width.
     * Auto-switch: Zacken → Seil when >50cm.
     */
    function updateSuspensionAvailability() {
      if (!suspensionOptions) return;

      // Calculate total width: imageWidth + 2× frame width + 2× PP side width
      var isNoPP = state.ppType === 'ohne';
      var matSideCM = 0;
      if (!isNoPP) {
        if (state.matWidth === 'individual' && state.individualSizes) {
          matSideCM = state.individualSizes.leftRight || 0;
        } else {
          var preset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth] || PRESET_PASSPARTOUT_DIMENSIONS.standard;
          matSideCM = preset.leftRight;
        }
      }
      var totalWidth = state.imageWidth + 2 * matSideCM + 2 * (productData.frameBreiteMM / 10);

      var zackenOk = totalWidth <= 50;
      var seilOk = totalWidth >= 30;
      var wallbuddiesOk = totalWidth >= 30;

      suspensionOptions.querySelectorAll('[data-suspension]').forEach(function (btn) {
        var type = btn.dataset.suspension;
        var ok = type === 'zacken' ? zackenOk : (type === 'seil' ? seilOk : wallbuddiesOk);
        btn.classList.toggle('fc-option-btn--disabled', !ok);
        btn.disabled = !ok;
      });

      // Auto-switch: if current is Zacken and width >50cm → switch to Seil
      if (state.suspension === 'zacken' && !zackenOk) {
        state.suspension = seilOk ? 'seil' : 'wallbuddies';
        syncButtonState(suspensionOptions, 'data-suspension', state.suspension);
      }
      // If current is Seil or WallBuddies and width <30cm → switch to Zacken
      if ((state.suspension === 'seil' || state.suspension === 'wallbuddies') && !seilOk) {
        state.suspension = 'zacken';
        syncButtonState(suspensionOptions, 'data-suspension', state.suspension);
      }

      // Update hint text
      if (suspensionHint) {
        suspensionHint.textContent = SUSPENSION_INFO[state.suspension] || '';
      }
    }

    /* --- IMAGE UPLOAD (via App Proxy) --- */

    /**
     * Upload UI helpers
     */
    function showUploadProgress(pct) {
      if (!uploadProgress) return;
      uploadPrompt.style.display = 'none';
      uploadThumbWrap.style.display = 'none';
      uploadProgress.style.display = '';
      uploadProgressBar.style.width = Math.round(pct) + '%';
      uploadProgressText.textContent = Math.round(pct) + '%';
    }

    function showUploadPreview(url) {
      if (!uploadThumbWrap) return;
      uploadPrompt.style.display = 'none';
      uploadProgress.style.display = 'none';
      uploadThumbWrap.style.display = '';
      uploadThumb.src = url;
      // Always show rotate/crop/change buttons (Shopify CDN supports CORS for placeholders)
      if (uploadRotateBtn) uploadRotateBtn.style.display = '';
      if (uploadCropBtn) uploadCropBtn.style.display = '';
    }

    function showUploadError(msg) {
      if (!uploadError) return;
      uploadError.textContent = msg;
      uploadError.style.display = '';
      setTimeout(function () { uploadError.style.display = 'none'; }, 6000);
    }

    function resetUploadUI() {
      if (!uploadPrompt) return;
      uploadPrompt.style.display = '';
      uploadProgress.style.display = 'none';
      uploadThumbWrap.style.display = 'none';
      uploadThumb.src = '';
      uploadProgressBar.style.width = '0%';
      uploadProgressText.textContent = '0%';
      uploadError.style.display = 'none';
      if (uploadInput) uploadInput.value = '';
      // Reset aspect ratio lock
      state.imageAspectRatio = null;
      clearImageFromIDB();
      // Clean up blob URL
      if (state.localBlobUrl) {
        URL.revokeObjectURL(state.localBlobUrl);
        state.localBlobUrl = null;
      }
    }

    /* --- Upload Popup helpers (Bottom-Sheet on Rahmen-Produktseite) --- */
    // The popup DOM is rendered by sections/frame-upload-popup.liquid — only present on
    // templates where the section is included (currently: product.rahmen.json).

    function getUploadPopup() {
      return document.querySelector('[data-fcup-popup]');
    }

    function openUploadPopup() {
      var popup = getUploadPopup();
      if (!popup) return;
      // Safety: never open when state already has an image
      if (state.imageUrl || state.localBlobUrl) return;
      showPopupUploadContent();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    /** Opens the popup showing the type wizard (regardless of image state) */
    function openWizardPopup() {
      var popup = getUploadPopup();
      if (!popup) return;
      showPopupWizard();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    /**
     * While the type wizard is visible, the popup must not be dismissable —
     * the user has to pick a type first (no X, no ESC, no outside-click).
     */
    function isUploadPopupLocked() {
      var wiz = document.querySelector('[data-fcup-wizard]');
      var wizVisible = wiz && wiz.style.display !== 'none' && wiz.offsetParent !== null;
      return !!wizVisible;
    }

    /* Einsende-Typen: Nach der Bildwahl direkt zu Breite/Hoehe — Schritt
       "Bildgroesse" aufklappen, hinscrollen, Breite fokussieren (Fokus nur mit
       Maus, auf Touch wuerde sofort die Tastatur aufspringen). */
    function goToSizeFields() {
      if (!needsSizeEntry()) return;
      if (openStepId !== 'size') toggleStep('size');
      var sizeStep = document.getElementById('fc-step-size');
      setTimeout(function () {
        if (sizeStep) sizeStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (canHover && widthInput) {
          try { widthInput.focus({ preventScroll: true }); } catch (e) { widthInput.focus(); }
        }
      }, 380); // nach der Aufklapp-Animation (350 ms)
    }

    function closeUploadPopup(autoSelectIfEmpty) {
      var popup = getUploadPopup();
      if (!popup) return;
      if (isUploadPopupLocked()) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (state.imageUrl || state.localBlobUrl) goToSizeFields();
      if (autoSelectIfEmpty && !state.imageUrl && !state.localBlobUrl) {
        // Find the first placeholder card that actually has a URL (skip empty fallback cards)
        var cards = popup.querySelectorAll('[data-fcup-placeholder]');
        var firstValid = null;
        for (var i = 0; i < cards.length; i++) {
          var u = cards[i].getAttribute('data-placeholder-url');
          if (u) { firstValid = cards[i]; break; }
        }
        if (firstValid) {
          var url = firstValid.getAttribute('data-placeholder-url');
          var ratio = parseFloat(firstValid.getAttribute('data-placeholder-ratio')) || null;
          selectPlaceholder(url, ratio);
        }
      }
    }

    function selectPlaceholder(url, aspectRatio) {
      if (!url) {
        // Empty placeholder card (no image configured yet) — just close the popup
        closeUploadPopup(false);
        return;
      }
      // If aspect ratio is missing (e.g. CDN-URL from text field), load the image
      // first to get naturalWidth/Height, then apply. Keeps Auto-Aspect working.
      if (!aspectRatio) {
        var probeImg = new Image();
        probeImg.crossOrigin = 'anonymous';
        probeImg.onload = function () {
          var ar = null;
          if (probeImg.naturalWidth && probeImg.naturalHeight) {
            ar = probeImg.naturalWidth / probeImg.naturalHeight;
          }
          _applyPlaceholder(url, ar);
        };
        probeImg.onerror = function () {
          _applyPlaceholder(url, null);
        };
        probeImg.src = url;
        return;
      }
      _applyPlaceholder(url, aspectRatio);
    }

    function _applyPlaceholder(url, aspectRatio) {
      state.imageUrl = url;
      state.isPlaceholder = true;
      if (aspectRatio) {
        state.imageAspectRatio = aspectRatio;
        syncSizeSlider();
        if (isAutoAspectType()) {
          var maxW = getSliderMaxWidth(aspectRatio);
          if (state.imageWidth > maxW) state.imageWidth = maxW;
          if (widthInput) widthInput.value = state.imageWidth;
          var autoH = Math.round(state.imageWidth / aspectRatio);
          autoH = Math.max(10, Math.min(110, autoH));
          state.imageHeight = autoH;
          if (heightInput) heightInput.value = autoH;
        }
      }
      // MUST be set BEFORE reorder calls — controls gallery ordering logic
      _userHasConfigured = true;
      showUploadPreview(url);
      reorderDesktopGallerySlides();
      reorderMobileGallerySlides();
      refreshGalleryAfterReorder(true);
      try { sessionStorage.setItem('fc-placeholder-url', url); } catch (e) { /* ignore */ }
      try { if (aspectRatio) sessionStorage.setItem('fc-placeholder-ratio', String(aspectRatio)); } catch (e) { /* ignore */ }
      update();
      if (typeof updateUploadStepStatus === 'function') updateUploadStepStatus();
      closeUploadPopup(false);
    }

    function bindUploadPopup() {
      var popup = getUploadPopup();
      if (!popup) return;
      var uploadBtnInPopup = popup.querySelector('[data-fcup-upload]');
      if (uploadBtnInPopup && uploadInput) {
        uploadBtnInPopup.addEventListener('click', function () {
          // Trigger hidden file input — uploadFile() will close the popup on success
          uploadInput.click();
        });
      }
      var closeBtn = popup.querySelector('[data-fcup-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { closeUploadPopup(true); });
      }
      popup.addEventListener('click', function (e) {
        if (e.target === popup) closeUploadPopup(true);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) {
          closeUploadPopup(true);
        }
      });
      var cards = popup.querySelectorAll('[data-fcup-placeholder]');
      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          card.addEventListener('click', function () {
            var url = card.getAttribute('data-placeholder-url');
            var ratio = parseFloat(card.getAttribute('data-placeholder-ratio')) || null;
            selectPlaceholder(url, ratio);
          });
        })(cards[i]);
      }
    }

    var _popupEvaluated = false;

    /**
     * Crop overlay — simple drag-to-select crop tool
     */
    function openCropOverlay(imageSrc) {
      var overlay = document.getElementById('fc-crop-overlay');
      var cropImg = document.getElementById('fc-crop-image');
      var selection = document.getElementById('fc-crop-selection');
      var cancelBtn = document.getElementById('fc-crop-cancel');
      var confirmBtn = document.getElementById('fc-crop-confirm');
      var imageWrap = document.getElementById('fc-crop-image-wrap');
      if (!overlay || !cropImg || !selection || !cancelBtn || !confirmBtn || !imageWrap) return;

      // Set crossOrigin only for HTTP URLs, not blobs
      if (imageSrc && imageSrc.indexOf('blob:') !== 0) {
        cropImg.crossOrigin = 'anonymous';
      } else {
        cropImg.removeAttribute('crossOrigin');
      }

      overlay.style.display = '';

      var cropState = { sx: 0, sy: 0, sw: 0, sh: 0, dragging: false, resizing: false, startX: 0, startY: 0 };

      function cleanup() {
        overlay.style.display = 'none';
        imageWrap.removeEventListener('mousedown', onStart);
        imageWrap.removeEventListener('touchstart', onStart);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchend', onEnd);
        cancelBtn.onclick = null;
        confirmBtn.onclick = null;
      }

      cropImg.onerror = function () {
        showUploadError('Bild konnte nicht geladen werden.');
        cleanup();
      };

      cropImg.onload = function () {
        var imgRect = cropImg.getBoundingClientRect();
        var iw = imgRect.width;
        var ih = imgRect.height;
        cropState.sx = Math.round(iw * 0.1);
        cropState.sy = Math.round(ih * 0.1);
        cropState.sw = Math.round(iw * 0.8);
        cropState.sh = Math.round(ih * 0.8);
        updateSelection();
      };

      cropImg.src = imageSrc;

      // Calculate image offset within the flex container (image may not fill entire wrap)
      function getImageOffset() {
        var imgRect = cropImg.getBoundingClientRect();
        var wrapRect = imageWrap.getBoundingClientRect();
        return { x: imgRect.left - wrapRect.left, y: imgRect.top - wrapRect.top };
      }

      function updateSelection() {
        var offset = getImageOffset();
        selection.style.left = (cropState.sx + offset.x) + 'px';
        selection.style.top = (cropState.sy + offset.y) + 'px';
        selection.style.width = cropState.sw + 'px';
        selection.style.height = cropState.sh + 'px';
      }

      function getRelativePos(e) {
        var r = cropImg.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var clientY = e.touches ? e.touches[0].clientY : e.clientY;
        return { x: clientX - r.left, y: clientY - r.top };
      }

      function onStart(e) {
        e.preventDefault();
        var pos = getRelativePos(e);
        var edgeThreshold = 18;
        var nearRight = Math.abs(pos.x - (cropState.sx + cropState.sw)) < edgeThreshold;
        var nearBottom = Math.abs(pos.y - (cropState.sy + cropState.sh)) < edgeThreshold;
        var nearLeft = Math.abs(pos.x - cropState.sx) < edgeThreshold;
        var nearTop = Math.abs(pos.y - cropState.sy) < edgeThreshold;

        if ((nearRight || nearLeft) && (nearTop || nearBottom)) {
          cropState.resizing = true;
          cropState.resizeCorner = (nearTop ? 't' : 'b') + (nearLeft ? 'l' : 'r');
        } else if (pos.x >= cropState.sx && pos.x <= cropState.sx + cropState.sw &&
                   pos.y >= cropState.sy && pos.y <= cropState.sy + cropState.sh) {
          cropState.dragging = true;
        }
        cropState.startX = pos.x;
        cropState.startY = pos.y;
        cropState.origSx = cropState.sx;
        cropState.origSy = cropState.sy;
        cropState.origSw = cropState.sw;
        cropState.origSh = cropState.sh;
      }

      function onMove(e) {
        if (!cropState.dragging && !cropState.resizing) return;
        e.preventDefault();
        var pos = getRelativePos(e);
        var dx = pos.x - cropState.startX;
        var dy = pos.y - cropState.startY;
        var imgRect = cropImg.getBoundingClientRect();
        var maxW = imgRect.width;
        var maxH = imgRect.height;

        if (cropState.dragging) {
          cropState.sx = Math.max(0, Math.min(maxW - cropState.sw, cropState.origSx + dx));
          cropState.sy = Math.max(0, Math.min(maxH - cropState.sh, cropState.origSy + dy));
        } else if (cropState.resizing) {
          var corner = cropState.resizeCorner;
          if (corner.indexOf('r') !== -1) {
            cropState.sw = Math.max(40, Math.min(maxW - cropState.sx, cropState.origSw + dx));
          }
          if (corner.indexOf('l') !== -1) {
            var newSx = Math.max(0, cropState.origSx + dx);
            cropState.sw = cropState.origSw + (cropState.origSx - newSx);
            if (cropState.sw >= 40) cropState.sx = newSx;
          }
          if (corner.indexOf('b') !== -1) {
            cropState.sh = Math.max(40, Math.min(maxH - cropState.sy, cropState.origSh + dy));
          }
          if (corner.indexOf('t') !== -1) {
            var newSy = Math.max(0, cropState.origSy + dy);
            cropState.sh = cropState.origSh + (cropState.origSy - newSy);
            if (cropState.sh >= 40) cropState.sy = newSy;
          }
        }
        updateSelection();
      }

      function onEnd() {
        cropState.dragging = false;
        cropState.resizing = false;
      }

      // Bind events
      imageWrap.addEventListener('mousedown', onStart);
      imageWrap.addEventListener('touchstart', onStart, { passive: false });
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchend', onEnd);

      cancelBtn.onclick = function () { cleanup(); };

      confirmBtn.onclick = function () {
        // Calculate crop in original image coordinates
        var imgRect = cropImg.getBoundingClientRect();
        var scaleX = cropImg.naturalWidth / imgRect.width;
        var scaleY = cropImg.naturalHeight / imgRect.height;
        var cx = Math.round(cropState.sx * scaleX);
        var cy = Math.round(cropState.sy * scaleY);
        var cw = Math.round(cropState.sw * scaleX);
        var ch = Math.round(cropState.sh * scaleY);

        // Canvas crop — use the already-loaded cropImg directly (no CORS issues)
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        try {
          ctx.drawImage(cropImg, cx, cy, cw, ch, 0, 0, cw, ch);
          canvas.toBlob(function (blob) {
            if (!blob) { showUploadError('Zuschneiden fehlgeschlagen.'); cleanup(); return; }
            var croppedFile = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
            cleanup();
            uploadFile(croppedFile);
          }, 'image/jpeg', 0.92);
        } catch (err) {
          showUploadError('Zuschneiden fehlgeschlagen.');
          cleanup();
        }
      };
    }

    /**
     * Firebase upload via REST API with Auth + App Check tokens.
     * App Check (reCAPTCHA v3) is REQUIRED by Firebase Storage rules.
     * Same approach as useImageUpload.ts in designer-studio.
     */
    var firebaseInitPromise = null;
    var cachedFirebaseApp = null;
    var cachedAppCheck = null;
    var cachedBucket = null;

    function initFirebase() {
      if (firebaseInitPromise) return firebaseInitPromise;

      firebaseInitPromise = Promise.resolve()
        .then(function () {
          // Read Firebase config from inline JSON in Liquid template (no network request needed)
          var configEl = document.getElementById('frame-firebase-config');
          if (!configEl) throw new Error('Firebase config element #frame-firebase-config not found');

          var config = JSON.parse(configEl.textContent);
          if (!config.firebase || !config.firebase.apiKey) {
            throw new Error('Invalid Firebase config in #frame-firebase-config');
          }

          cachedBucket = config.firebase.storageBucket;
          var recaptchaSiteKey = config.recaptcha && config.recaptcha.siteKey;

          // Initialize Firebase app (compat SDK)
          if (!firebase.apps.length) {
            cachedFirebaseApp = firebase.initializeApp(config.firebase);
          } else {
            cachedFirebaseApp = firebase.apps[0];
          }

          // Initialize App Check with reCAPTCHA v3 (REQUIRED before Storage upload)
          if (recaptchaSiteKey && !cachedAppCheck) {
            console.log('[FrameConfigurator] Initializing App Check with reCAPTCHA v3...');
            cachedAppCheck = firebase.appCheck(cachedFirebaseApp);
            cachedAppCheck.activate(
              new firebase.appCheck.ReCaptchaV3Provider(recaptchaSiteKey),
              true // isTokenAutoRefreshEnabled
            );
          } else if (!recaptchaSiteKey) {
            console.warn('[FrameConfigurator] No reCAPTCHA site key — App Check will not be initialized');
          }

          // Sign in anonymously
          console.log('[FrameConfigurator] Signing in anonymously...');
          return firebase.auth(cachedFirebaseApp).signInAnonymously();
        })
        .then(function (userCredential) {
          console.log('[FrameConfigurator] Auth ready, uid:', userCredential.user.uid);
          // Get both Auth token and App Check token
          var authTokenPromise = userCredential.user.getIdToken(true);
          var appCheckTokenPromise = cachedAppCheck
            ? cachedAppCheck.getToken(false).then(function (result) { return result.token; })
            : Promise.resolve(null);

          return Promise.all([authTokenPromise, appCheckTokenPromise]);
        })
        .then(function (tokens) {
          console.log('[FrameConfigurator] Tokens ready — auth:', tokens[0].length, 'appCheck:', tokens[1] ? tokens[1].length : 'none');
          return { authToken: tokens[0], appCheckToken: tokens[1], bucket: cachedBucket };
        })
        .catch(function (err) {
          firebaseInitPromise = null;
          throw err;
        });

      return firebaseInitPromise;
    }

    /**
     * Get fresh tokens for upload
     */
    function getFreshTokens() {
      var user = cachedFirebaseApp && firebase.auth(cachedFirebaseApp).currentUser;
      if (user) {
        var authP = user.getIdToken(false);
        var appCheckP = cachedAppCheck
          ? cachedAppCheck.getToken(false).then(function (r) { return r.token; })
          : Promise.resolve(null);
        return Promise.all([authP, appCheckP]).then(function (t) {
          return { authToken: t[0], appCheckToken: t[1], bucket: cachedBucket };
        });
      }
      firebaseInitPromise = null;
      return initFirebase();
    }

    /**
     * Handle file upload: validate → local preview → Firebase REST upload → update SVG
     */
    function uploadFile(file) {
      if (!file) return;

      // Validation
      var MAX_SIZE = 25 * 1024 * 1024; // 25 MB
      var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showUploadError('Nur JPG, PNG oder WebP Dateien erlaubt.');
        return;
      }
      if (file.size > MAX_SIZE) {
        showUploadError('Datei zu gro\u00DF (max. 25 MB).');
        return;
      }

      // Revoke previous blob URL to prevent memory leaks
      if (state.localBlobUrl) {
        URL.revokeObjectURL(state.localBlobUrl);
      }

      // Instant local preview via blob URL — keep blob URL for rotate/crop (CORS-safe)
      var localUrl = URL.createObjectURL(file);
      state.localBlobUrl = localUrl;
      state.imageUrl = localUrl;
      state.isPlaceholder = false;
      try { sessionStorage.removeItem('fc-placeholder-url'); } catch (e) { /* ignore */ }
      try { sessionStorage.removeItem('fc-placeholder-ratio'); } catch (e) { /* ignore */ }
      closeUploadPopup(false);
      if (typeof updateUploadStepStatus === 'function') updateUploadStepStatus();
      _userHasConfigured = true;
      saveImageToIDB(file);
      renderPreview();
      scrollGalleryToPreview();
      // Reorder gallery: show 2nd product image first when customer has uploaded
      reorderDesktopGallerySlides();
      reorderMobileGallerySlides();
      refreshGalleryAfterReorder();
      showUploadProgress(0);

      // Read image aspect ratio for auto-dimension calculation
      var arImg = new Image();
      arImg.onload = function () {
        if (arImg.naturalWidth && arImg.naturalHeight) {
          state.imageAspectRatio = arImg.naturalWidth / arImg.naturalHeight;
          syncSizeSlider();
          // Auto-set height from current width (clamped to slider max)
          if (isAutoAspectType()) {
            var maxW = getSliderMaxWidth(state.imageAspectRatio);
            if (state.imageWidth > maxW) state.imageWidth = maxW;
            if (widthInput) widthInput.value = state.imageWidth;
            var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
            autoH = Math.max(10, Math.min(110, autoH));
            state.imageHeight = autoH;
            if (heightInput) { heightInput.value = autoH; }
            debouncedUpdate();
          }
        }
      };
      arImg.src = localUrl;

      var timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      var randomId = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      var ext = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
      var filename = 'processed-' + timestamp + '-' + randomId + '.' + ext;
      var storagePath = 'uploads/' + filename;

      console.log('[FrameConfigurator] Starting Firebase upload for', filename);

      initFirebase()
        .then(function () {
          // Always get fresh tokens right before upload
          return getFreshTokens();
        })
        .then(function (result) {
          var authToken = result.authToken;
          var appCheckToken = result.appCheckToken;
          var bucket = result.bucket;

          // Upload via Firebase Storage REST API with explicit tokens
          var uploadUrl = 'https://firebasestorage.googleapis.com/v0/b/' +
            encodeURIComponent(bucket) + '/o?uploadType=media&name=' +
            encodeURIComponent(storagePath);

          console.log('[FrameConfigurator] Uploading with Auth + AppCheck tokens...');

          return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', uploadUrl);
            xhr.setRequestHeader('Authorization', 'Bearer ' + authToken);
            xhr.setRequestHeader('Content-Type', file.type);
            // App Check token header — required by Firebase Storage
            if (appCheckToken) {
              xhr.setRequestHeader('X-Firebase-AppCheck', appCheckToken);
            }

            xhr.upload.onprogress = function (ev) {
              if (ev.lengthComputable) {
                showUploadProgress((ev.loaded / ev.total) * 100);
              }
            };

            xhr.onload = function () {
              if (xhr.status === 200) {
                try {
                  var data = JSON.parse(xhr.responseText);
                  // Build the download URL from the response
                  var downloadUrl = 'https://firebasestorage.googleapis.com/v0/b/' +
                    encodeURIComponent(bucket) + '/o/' +
                    encodeURIComponent(data.name) +
                    '?alt=media&token=' + (data.downloadTokens || '');
                  resolve(downloadUrl);
                } catch (e) {
                  reject(new Error('Failed to parse upload response'));
                }
              } else {
                console.error('[FrameConfigurator] Upload response:', xhr.status, xhr.responseText);
                reject(new Error('Upload failed (status ' + xhr.status + ')'));
              }
            };

            xhr.onerror = function () {
              reject(new Error('Network error during upload'));
            };

            // Send the raw file bytes
            xhr.send(file);
          });
        })
        .then(function (downloadUrl) {
          console.log('[FrameConfigurator] Upload complete:', downloadUrl);
          state.imageUrl = downloadUrl;
          // DO NOT revoke localUrl — kept as state.localBlobUrl for rotate/crop (CORS-safe)
          // Persist Firebase URL in IndexedDB (blob already saved during upload start)
          saveImageToIDB(null, downloadUrl);
          showUploadPreview(downloadUrl);
          renderPreview();
        })
        .catch(function (err) {
          console.error('[FrameConfigurator] Upload error:', err.message || err);
          showUploadError('Upload fehlgeschlagen. Bild wird nur lokal angezeigt.');
          showUploadPreview(localUrl);
        });
    }

    /* --- DIMENSION VALIDATION --- */

    function validateDimensions() {
      var errors = [];
      var w = state.imageWidth;
      var h = state.imageHeight;

      if (w < 10) errors.push('Mindestbreite: 10 cm');
      if (h < 10) errors.push('Mindesthoehe: 10 cm');
      if (w > 110) errors.push('Maximale Breite: 110 cm');
      if (h > 110) errors.push('Maximale H\u00f6he: 110 cm');
      if (w > 90 && h > 90 && w <= 110 && h <= 110) {
        errors.push('Eine Seite darf maximal 110 cm und die andere maximal 90 cm betragen (max. 90 \u00d7 110 bzw. 110 \u00d7 90)');
      }

      if (dimensionsError) {
        if (errors.length > 0) {
          dimensionsError.textContent = errors.join('. ') + '.';
          dimensionsError.style.display = '';
        } else {
          dimensionsError.textContent = '';
          dimensionsError.style.display = 'none';
        }
      }

      if (widthInput) widthInput.classList.toggle('fc-input--error', w > 110 || (w > 90 && h > 90));
      if (heightInput) heightInput.classList.toggle('fc-input--error', h > 110 || (w > 90 && h > 90));

      return errors.length === 0;
    }

    /* --- OUTER DIMENSION HELPERS --- */

    function calculateOuterDimensions(imgW, imgH, matTopCM, matBottomCM, matLeftRightCM) {
      var frameWidthCM = productData.frameBreiteMM / 10;
      var frameHeightCM = (productData.frameHoeheMM || productData.frameBreiteMM) / 10;
      return {
        width: imgW + 2 * matLeftRightCM + 2 * frameWidthCM,
        height: imgH + matTopCM + matBottomCM + 2 * frameHeightCM
      };
    }

    function fitsOuterLimit(outerW, outerH) {
      if (outerW > 110 || outerH > 110) return false;
      if (outerW > 90 && outerH > 90) return false;
      return true;
    }

    /* --- CORE UPDATE --- */

    function update() {
      // Validate dimensions — do NOT clamp silently
      var dimensionsValid = validateDimensions();

      // For internal calculations, use clamped values
      var calcWidth = Math.max(10, Math.min(110, state.imageWidth));
      var calcHeight = Math.max(10, Math.min(110, state.imageHeight));
      if (calcWidth > 90 && calcHeight > 90) {
        calcHeight = 90;
      }

      var sizeCategory = getSizeCategory(
        calcWidth, calcHeight,
        state.ppType === 'ohne' ? 'ohne' : state.matWidth,
        productData.frameBreiteMM, state.ppType, state.individualSizes
      );

      var variant = lookupVariant(variantIndex, state.frameType, sizeCategory, state.ppType);
      state.currentVariant = dimensionsValid ? variant : null;
      state.currentPrice = variant ? variant.price : null;

      /* size_entered haengt an _sizeTouched, damit nicht jeder Seitenaufruf die
         Startgroesse als Eingabe meldet. trackChanged unterdrueckt die
         Wiederholungen, die update() sonst bei jedem Typ- und PP-Wechsel liefert. */
      if (_sizeTouched) {
        trackChanged('size_entered', {
          breite_cm: state.imageWidth,
          hoehe_cm: state.imageHeight,
          groessenklasse: sizeCategory
        });
      }

      /* Wechsel Digital -> Einsenden: Masse aus dem Upload oder der digitalen
         Voreinstellung sind nicht die Masse des Originals, also neu abfragen. */
      var sendInNow = isSendInType();
      if (sendInNow && _lastWasSendIn === false) {
        _sizeEntered.w = false;
        _sizeEntered.h = false;
      }
      _lastWasSendIn = sendInNow;

      var sizePending = needsSizeEntry();
      if (sizePending) state.currentVariant = null;
      syncDimensionInputs();

      /* bestellbar trennt "Preis steht da" von "Preis ist kaufbar" — state.currentPrice
         wird auch bei ungueltigen Massen gesetzt. */
      if (!sizePending) trackChanged('price_shown', {
        preis: variant ? variant.price : null,
        groessenklasse: sizeCategory,
        rahmentyp: state.frameType,
        passepartout: state.ppType,
        leiste: productData.handle,
        variant_id: variant ? variant.id : null,
        bestellbar: !!(dimensionsValid && variant)
      });

      sizeCategoryEl.textContent = sizeCategory;
      priceEl.textContent = sizePending ? 'Ma\u00dfe eingeben' : (variant ? formatPriceFromEuros(variant.price) : '\u2013');
      priceEl.classList.toggle('fc-summary__price--pending', sizePending);

      // Show "Kostenloser Versand" in ATC button when price >= 150€
      var atcShipping = document.getElementById('fc-atc-shipping');
      if (atcShipping) {
        atcShipping.style.display = (!sizePending && variant && variant.price >= 150) ? '' : 'none';
      }

      var isSendIn = normalizeTypeKey(state.frameType).indexOf('digital') === -1;
      var deliveryInfo = getDeliveryEstimate(isSendIn);
      if (deliveryEl) deliveryEl.textContent = deliveryInfo.headline.replace((_deliveryPrefix || 'Lieferung ca.') + ' ', '');
      if (deliveryHeadlineEl) deliveryHeadlineEl.textContent = deliveryInfo.headline;
      if (deliverySendinEl) {
        if (deliveryInfo.sendin) {
          deliverySendinEl.textContent = deliveryInfo.sendin;
          deliverySendinEl.style.display = '';
        } else {
          deliverySendinEl.style.display = 'none';
        }
      }
      dimensionsHint.textContent = state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm';

      // Calculate and display overall frame size (Gesamtgröße)
      if (overallSizeEl) {
        if (dimensionsValid) {
          var oMatTop = 0, oMatBottom = 0, oMatLR = 0;
          if (state.ppType !== 'ohne') {
            if (state.matWidth === 'individual') {
              oMatTop = state.individualSizes.top || 0;
              oMatBottom = state.individualSizes.bottom || 0;
              oMatLR = state.individualSizes.leftRight || 0;
            } else {
              var oPreset = PRESET_PASSPARTOUT_DIMENSIONS[state.matWidth];
              if (oPreset) { oMatTop = oPreset.top; oMatBottom = oPreset.bottom; oMatLR = oPreset.leftRight; }
            }
          }
          var outer = calculateOuterDimensions(state.imageWidth, state.imageHeight, oMatTop, oMatBottom, oMatLR);
          overallSizeEl.textContent = Math.round(outer.width * 10) / 10 + ' \u00D7 ' + Math.round(outer.height * 10) / 10 + ' cm';
        } else {
          overallSizeEl.textContent = '\u2013';
        }
      }

      // Update summary detail line (size only — frame name already shown in title)
      if (summaryDetailEl) {
        var sizeText = overallSizeEl ? overallSizeEl.textContent : '';
        summaryDetailEl.textContent = sizePending ? 'Breite und H\u00f6he deines Werks' : (sizeText && sizeText !== '\u2013' ? sizeText : state.imageWidth + '\u00D7' + state.imageHeight + ' cm');
      }

      if (state.ppType !== 'ohne') {
        ppWidthHint.textContent = state.matWidth === 'individual'
          ? formatMatSizes(state.individualSizes.top, state.individualSizes.leftRight, state.individualSizes.bottom)
          : getMatPresetDescription(state.matWidth);
      } else {
        ppWidthHint.textContent = '';
      }

      var uploadMissing = isUploadRequired() && !state.imageUrl;
      atcButton.disabled = !dimensionsValid || !variant || uploadMissing || sizePending;

      // Update upload group missing state (red border on required-but-empty)
      if (uploadGroup) {
        if (state.imageUrl) {
          uploadGroup.classList.remove('fc-upload--missing');
        } else if (isUploadRequired()) {
          uploadGroup.classList.toggle('fc-upload--missing', uploadMissing);
        } else {
          uploadGroup.classList.remove('fc-upload--missing');
        }
      }
      // Sync upload step indicator (subtitle + check icon) on every update
      if (typeof updateUploadStepStatus === 'function') updateUploadStepStatus();

      // Sync mobile info bar price
      if (mobileInfoPrice) mobileInfoPrice.textContent = sizePending ? 'Ma\u00dfe eingeben' : (variant ? formatPriceFromEuros(variant.price) : '\u2013');

      if (!variant) {
        console.log('[FrameConfigurator] No variant found for:', state.frameType, '|', sizeCategory, '|', state.ppType);
      }

      // Variant availability hint — show helpful message when no variant found
      if (variantHintEl) {
        if (!variant && dimensionsValid) {
          var hint = getVariantHint(variantIndex, state.frameType, sizeCategory,
            state.ppType, state.imageWidth, state.imageHeight, productData.frameBreiteMM);
          if (hint) {
            variantHintEl.textContent = hint;
            variantHintEl.style.display = '';
          } else {
            variantHintEl.style.display = 'none';
          }
        } else {
          variantHintEl.style.display = 'none';
        }
      }

      // Update page-level price display (configurator page — show current price, not "ab")
      /* Startet per display:none im Liquid, damit vor dem JS kein Preis aufblitzt. */
      var pagePriceBox = document.querySelector('#fc-page-price .price');
      if (pagePriceBox) pagePriceBox.style.display = sizePending ? 'none' : '';
      var pagePriceSpan = document.querySelector('#fc-page-price .price-item--regular');
      if (pagePriceSpan) {
        pagePriceSpan.textContent = (!sizePending && state.currentPrice) ? formatPriceFromEuros(state.currentPrice) : '\u2013';
      }

      renderPreview();
      updateAvailability();
      updatePPStepVisibility();
      renderProductSwitcher();
      renderTypeCards();
      updateStepSubtitles();

      // Sync size slider visibility, max, and value
      syncSizeSlider();

      // Sync URL with current state so a page refresh restores the configuration
      if (_initialized) {
        var variantId = state.currentVariant ? state.currentVariant.id : null;
        var urlParams = buildStateParams(productData.handle, variantId);
        if (isProductPage) urlParams.delete('product');
        var newUrl = window.location.pathname + '?' + urlParams.toString();
        if (newUrl !== window.location.pathname + window.location.search) {
          window.history.replaceState({}, '', newUrl);
        }

        // Re-check favorite state: config changed → heart should reflect new configUrl
        if (typeof window.FramelinFavorites !== 'undefined') {
          var currentConfigUrl = buildConfigUrl();
          window.FramelinFavorites.isFavorited(currentConfigUrl)
            .then(function (favorited) {
              setFavoriteButtonState(favorited);
            })
            .catch(function () { /* ignore */ });
        }
      }
    }

    /* --- TYPE SWITCH HELPER (lazy variant loading) --- */

    /**
     * Handle a frame type switch. If the selected type has no variant data
     * (truncated product), show a loading state and lazy-fetch all variants
     * via Storefront API before updating.
     */
    function handleTypeSwitch(newType) {
      track('frametype_select', { von: state.frameType, nach: newType });
      state.frameType = newType;
      try { sessionStorage.setItem('fc-frameType', newType); } catch (e) { /* ignore */ }

      // Objektrahmung-Sonderregel: PP-UI und State anpassen
      syncPPForFrameType();

      // Leinwand hat nie PP — PP-Step sofort ausblenden und state.ppType='ohne' setzen,
      // bevor ein lazy-fetch startet (sonst zeigt die Preview das alte PP 200–500ms weiter).
      updatePPStepVisibility();
      // Preview sofort neu rendern, damit das Bild den neuen Typ widerspiegelt
      // (kein PP für Leinwand, keine Rahmen-Dicke-Änderung vorher).
      renderPreview();

      // Show/hide size slider based on type + update max
      syncSizeSlider();

      // Adjust dimensions from aspect ratio before update
      if (isAutoAspectType() && state.imageAspectRatio) {
        var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
        autoH = Math.max(10, Math.min(110, autoH));
        state.imageHeight = autoH;
        if (heightInput) { heightInput.value = autoH; }
      }

      // Lazy-load: if this type has no variant data AND we have a Storefront API token
      if (!variantIndex[newType] && storefrontConfig.token && !allProductVariantIndexes[productData.handle + '__full']) {
        var fetchHandle = productData.handle;

        // Show loading state
        priceEl.textContent = 'Lade Preise\u2026';
        if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
        atcButton.disabled = true;
        renderTypeCards(); // re-render to show new selection immediately

        lazyFetchVariants(fetchHandle, productData.productId, function (newIndex) {
          // Guard: only apply if user hasn't switched products
          if (productData.handle !== fetchHandle) return;
          variantIndex = newIndex;
          productIsTruncated = false; // all types now have data
          update();
        });
      } else {
        update();
      }
    }

    /* --- TYPE WIZARD --- */

    /* --- TYPE WIZARD (inside upload popup) --- */

    var typeWizard = document.getElementById('fc-type-wizard');
    var wizardStep1 = document.getElementById('fc-wizard-step-1');
    var wizardStepCanvas = document.getElementById('fc-wizard-step-canvas');
    var wizardStepDigital = document.getElementById('fc-wizard-step-digital');
    var wizardStepMismatch = document.getElementById('fc-wizard-step-mismatch');
    var wizardStepMismatchPP = document.getElementById('fc-wizard-step-mismatch-pp');
    var wizardWrapper = document.querySelector('[data-fcup-wizard]');
    var popupContent = document.querySelector('[data-fcup-content]');

    var WIZARD_DESCS = {
      'Leinwand aufgespannt': 'Aufgespannte Leinwand \u2014 wir rahmen deine Leinwand mit Schattenfuge oder direkt. Dein Keilrahmen bleibt erhalten.',
      'Leinwand nicht aufgespannt': 'Nicht aufgespannte Leinwand \u2014 wir spannen deine Leinwand auf und rahmen sie professionell ein.',
      'Digitaler Upload': 'Papierdruck \u2014 wir drucken dein Bild auf hochwertigem Papier und rahmen es.',
      'Digitale Leinwand': 'Leinwanddruck \u2014 wir drucken dein Bild auf Leinwand und rahmen es.'
    };

    var _wizardPendingType = null;
    var _wizardPendingHandle = null;
    var _wizardCompleted = false;

    // Bildart display helpers
    var BILDART_LABELS = {
      'Digitaler Upload': 'Digital Upload \u00B7 Papier',
      'Digitale Leinwand': 'Digital Upload \u00B7 Leinwand',
      'Leinwand aufgespannt': 'Leinwand \u00B7 aufgespannt',
      'Leinwand nicht aufgespannt': 'Leinwand \u00B7 nicht aufgespannt',
      'Papierarbeit': 'Papierkunst einsenden',
      'Objektrahmung': 'Objekt einsenden'
    };

    var bildartEl = document.getElementById('fc-bildart');
    var bildartValueEl = document.getElementById('fc-bildart-value');
    var bildartChangeBtn = document.getElementById('fc-bildart-change');

    function updateBildartDisplay() {
      if (!bildartEl || !bildartValueEl) return;
      if (!_wizardCompleted && !state.frameType) {
        bildartEl.style.display = 'none';
        return;
      }
      var label = BILDART_LABELS[state.frameType] || state.frameType;
      bildartValueEl.textContent = label;
      bildartEl.style.display = '';
    }

    if (bildartChangeBtn) {
      bildartChangeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openWizardPopup();
      });
    }

    /** Returns true when the wizard should be shown before upload */
    function wizardNeeded() {
      if (_wizardCompleted) return false;
      var params = new URLSearchParams(window.location.search);
      if (params.get('frameType')) return false; // pre-selected from collection
      // Check sessionStorage — type already chosen during this session
      try {
        var savedType = sessionStorage.getItem('fc-frameType');
        if (savedType) return false;
      } catch (e) { /* ignore */ }
      return frameTypeValues.length >= 2;
    }

    /** Show one wizard step, hide all others */
    function showWizardStep(stepEl) {
      [wizardStep1, wizardStepCanvas, wizardStepDigital, wizardStepMismatch, wizardStepMismatchPP].forEach(function (s) { if (s) s.style.display = 'none'; });
      if (stepEl) stepEl.style.display = '';
    }

    /** Toggle between wizard and upload content inside popup */
    function showPopupWizard() {
      if (wizardWrapper) wizardWrapper.style.display = '';
      if (popupContent) popupContent.style.display = 'none';
      showWizardStep(wizardStep1);
      // Lock popup for the entire wizard flow — user MUST pick a type (no X, no ESC, no outside-click)
      var popup = getUploadPopup();
      if (popup) popup.classList.add('fcup-popup--locked');
    }

    function showPopupUploadContent() {
      if (wizardWrapper) wizardWrapper.style.display = 'none';
      if (popupContent) popupContent.style.display = '';
      var popup = getUploadPopup();
      if (popup) popup.classList.remove('fcup-popup--locked');
    }

    // Find a compatible product for a given type
    function findCompatibleProduct(typeName) {
      var typeNorm = normalizeTypeKey(typeName);
      for (var p = 0; p < productsList.length; p++) {
        var pl = productsList[p];
        if (pl.handle === productData.handle) continue;
        var plOpts = pl.options || [];
        for (var oi = 0; oi < plOpts.length; oi++) {
          var oName = (plOpts[oi].name || '').toLowerCase();
          if (oName === 'typ' || oName === 'type' || oName === 'rahmentyp') {
            var plVals = plOpts[oi].values || [];
            for (var vi = 0; vi < plVals.length; vi++) {
              if (normalizeTypeKey(plVals[vi]) === typeNorm) return pl.handle;
            }
            break;
          }
        }
      }
      return null;
    }

    function completeWizard(typeName) {
      // Check if type is compatible with current product
      var typeNorm = normalizeTypeKey(typeName);
      var matched = null;
      for (var i = 0; i < frameTypeValues.length; i++) {
        if (normalizeTypeKey(frameTypeValues[i]) === typeNorm) { matched = frameTypeValues[i]; break; }
      }

      if (matched) {
        // Type fits current product
        state.frameType = matched;
        handleTypeSwitch(matched);
        _wizardCompleted = true;
        // Persist type for this session
        try { sessionStorage.setItem('fc-frameType', matched); } catch (e) { /* ignore */ }
        updateBildartDisplay();
        // Type matches → if image exists, close popup; otherwise switch to upload view
        if (state.imageUrl || state.localBlobUrl) {
          showPopupUploadContent();
          closeUploadPopup(false);
        } else {
          showPopupUploadContent();
        }
      } else {
        // Type doesn't fit → find compatible product and ask user
        var compatHandle = findCompatibleProduct(typeName);
        if (compatHandle) {
          _wizardPendingType = typeName;
          _wizardPendingHandle = compatHandle;
          var compatTitle = compatHandle;
          for (var j = 0; j < productsList.length; j++) {
            if (productsList[j].handle === compatHandle) { compatTitle = productsList[j].title; break; }
          }
          var descEl = document.getElementById('fc-wizard-mismatch-desc');
          if (descEl) descEl.textContent = 'Der Rahmen \u201E' + productData.title + '\u201C unterst\u00FCtzt diesen Typ nicht. Wir k\u00F6nnen dir \u201E' + compatTitle + '\u201C zeigen, der dazu passt.';
          showWizardStep(wizardStepMismatch);
        } else {
          // No compatible product found → go back
          showWizardStep(wizardStep1);
        }
      }
    }

    if (typeWizard) {
      // Step 1: Category click
      typeWizard.addEventListener('click', function (e) {
        var catBtn = e.target.closest('[data-wizard-cat]');
        if (catBtn) {
          var cat = catBtn.dataset.wizardCat;
          if (cat === 'leinwand') {
            showWizardStep(wizardStepCanvas);
          } else if (cat === 'digital') {
            showWizardStep(wizardStepDigital);
          } else if (cat === 'papier') {
            completeWizard('Papierarbeit');
          } else if (cat === 'objekt') {
            completeWizard('Objektrahmung');
          }
          return;
        }

        // Step 2: Type choice click
        var choiceBtn = e.target.closest('[data-wizard-type]');
        if (choiceBtn) {
          var siblings = choiceBtn.parentElement.querySelectorAll('.fc-wizard__choice');
          for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('fc-wizard__choice--selected');
          choiceBtn.classList.add('fc-wizard__choice--selected');
          var typeName = choiceBtn.dataset.wizardType;
          var descEl = choiceBtn.closest('.fc-wizard__step').querySelector('.fc-wizard__desc');
          if (descEl) descEl.textContent = WIZARD_DESCS[typeName] || '';
          setTimeout(function () { completeWizard(typeName); }, 600);
          return;
        }
      });

      // Back buttons
      var backCanvas = document.getElementById('fc-wizard-back-canvas');
      var backDigital = document.getElementById('fc-wizard-back-digital');
      if (backCanvas) backCanvas.addEventListener('click', function () { showWizardStep(wizardStep1); });
      if (backDigital) backDigital.addEventListener('click', function () { showWizardStep(wizardStep1); });

      // Mismatch buttons
      var mismatchBack = document.getElementById('fc-wizard-mismatch-back');
      var mismatchSwitch = document.getElementById('fc-wizard-mismatch-switch');
      if (mismatchBack) {
        mismatchBack.addEventListener('click', function () {
          _wizardPendingType = null;
          _wizardPendingHandle = null;
          showWizardStep(wizardStep1);
        });
      }
      if (mismatchSwitch) {
        mismatchSwitch.addEventListener('click', function () {
          if (!_wizardPendingHandle) return;
          var pendingType = _wizardPendingType;
          var pendingHandle = _wizardPendingHandle;
          _wizardPendingType = null;
          _wizardPendingHandle = null;
          // Set frameType URL param so the new product picks up the type
          var url = new URL(window.location.href);
          url.searchParams.set('frameType', pendingType);
          window.history.replaceState(null, '', url.toString());
          // Switch product (client-side)
          switchProduct(pendingHandle);
          _wizardCompleted = true;
          try { sessionStorage.setItem('fc-frameType', pendingType); } catch (e) { /* ignore */ }
          updateBildartDisplay();
          // Type matches → if image exists, close popup; otherwise switch to upload view
          if (state.imageUrl || state.localBlobUrl) {
            showPopupUploadContent();
            closeUploadPopup(false);
          } else {
            showPopupUploadContent();
          }
        });
      }
    }

    /* --- SCHWEBEND PP-TYPE: nur auf -high Rahmen verfügbar --- */

    var _ppMismatchPendingHandle = null;

    /**
     * Öffne den PP-Mismatch-Dialog (Schwebend) im Wizard-Popup.
     * opts.mode: 'switch-to-high' (single target) oder 'pick-alternative' (Liste)
     * opts.targetHandle, opts.targetTitle, opts.alternatives
     */
    function openSchwebendMismatch(opts) {
      var headingEl = document.getElementById('fc-wizard-mismatch-pp-heading');
      var descEl = document.getElementById('fc-wizard-mismatch-pp-desc');
      var actionsEl = document.getElementById('fc-wizard-mismatch-pp-actions');
      var altsEl = document.getElementById('fc-wizard-mismatch-pp-alternatives');
      var primaryBtn = document.getElementById('fc-wizard-mismatch-pp-switch');
      if (!wizardStepMismatchPP || !headingEl || !descEl || !actionsEl || !altsEl) return;

      if (opts.mode === 'switch-to-high') {
        headingEl.textContent = 'Schwebend nur in der High-Variante verfügbar';
        descEl.textContent = 'Wir wechseln dich auf die hochwertigere High-Variante dieses Rahmens. Möchtest du fortfahren?';
        actionsEl.style.display = '';
        altsEl.style.display = 'none';
        altsEl.innerHTML = '';
        if (primaryBtn) primaryBtn.textContent = 'Ja, auf High wechseln';
        _ppMismatchPendingHandle = opts.targetHandle || null;
      } else {
        headingEl.textContent = 'Schwebend nur in der High-Variante verfügbar';
        descEl.textContent = 'Dieser Rahmen hat keine High-Variante. Wähle einen Rahmen, der Schwebend unterstützt:';
        actionsEl.style.display = 'none';
        altsEl.style.display = '';
        var html = '';
        var altList = opts.alternatives || [];
        for (var ai = 0; ai < altList.length; ai++) {
          var p = altList[ai];
          var imgUrl = p.featured_image || (p.images && p.images[0]) || '';
          var title = (p.title || p.handle || '').replace(/"/g, '&quot;');
          html += '<button type="button" class="fc-wizard__mismatch-alt-btn" data-pp-alt-handle="' + p.handle + '">';
          if (imgUrl) html += '<img src="' + imgUrl + '" alt="" loading="lazy">';
          html += '<span class="fc-wizard__mismatch-alt-btn-label">' + title + '</span>';
          html += '</button>';
        }
        altsEl.innerHTML = html;
        _ppMismatchPendingHandle = null;
      }

      // Wizard-Wrapper im Popup einblenden, Upload-Inhalt verstecken, Schritt zeigen.
      var popup = getUploadPopup();
      if (!popup) return;
      if (wizardWrapper) wizardWrapper.style.display = '';
      if (popupContent) popupContent.style.display = 'none';
      showWizardStep(wizardStepMismatchPP);
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    /** Dialog ohne Switch schließen (vorheriger ppType bleibt aktiv). */
    function closeSchwebendMismatch() {
      _ppMismatchPendingHandle = null;
      var popup = getUploadPopup();
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('fcup-popup--locked');
      document.body.style.overflow = '';
      // Wizard-Step zurücksetzen, falls Popup später regulär geöffnet wird.
      showWizardStep(wizardStep1);
      showPopupUploadContent();
    }

    /** Auf Ziel-Rahmen wechseln und ppType auf 'schwebend' setzen. */
    function commitSchwebendSwitch(handle) {
      if (!handle) return;
      // Wenn Ziel-Produkt das aktuelle ist (z.B. bereits -high), keinen Switch nötig.
      if (handle !== productData.handle) {
        switchProduct(handle);
      }
      // ppType optimistisch auf 'schwebend' setzen. lookupVariant fällt bei
      // fehlender Variante automatisch auf 'ohne' zurück; bei truncated Produkten
      // lädt der lazyFetch-Callback in switchProduct() die fehlenden Daten nach
      // und triggert ein erneutes update().
      state.ppType = 'schwebend';
      syncPPForFrameType();
      syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
      togglePPOptions();
      update();
      closeSchwebendMismatch();
    }

    /* --- Schwebend Mismatch Buttons --- */

    var mismatchPPBack = document.getElementById('fc-wizard-mismatch-pp-back');
    var mismatchPPSwitch = document.getElementById('fc-wizard-mismatch-pp-switch');
    var mismatchPPAlternatives = document.getElementById('fc-wizard-mismatch-pp-alternatives');
    if (mismatchPPBack) {
      mismatchPPBack.addEventListener('click', function () { closeSchwebendMismatch(); });
    }
    if (mismatchPPSwitch) {
      mismatchPPSwitch.addEventListener('click', function () {
        if (!_ppMismatchPendingHandle) return;
        var handle = _ppMismatchPendingHandle;
        _ppMismatchPendingHandle = null;
        commitSchwebendSwitch(handle);
      });
    }
    if (mismatchPPAlternatives) {
      mismatchPPAlternatives.addEventListener('click', function (e) {
        var altBtn = e.target.closest('[data-pp-alt-handle]');
        if (!altBtn) return;
        var handle = altBtn.getAttribute('data-pp-alt-handle');
        if (!handle) return;
        commitSchwebendSwitch(handle);
      });
    }

    /* --- EVENT HANDLERS (registered BEFORE first update) --- */

    ppTypeOptions.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-type]');
      if (!btn) return;

      // Inverse: User klickt auf Ohne/Normal/Freigestellt, während aktuell -high+Schwebend.
      // -high-Produkte haben oft nur Schwebend-Varianten → wir wechseln direkt zum
      // Standard-Pendant (kein Dialog) und setzen den gewünschten ppType.
      if (btn.dataset.ppType !== 'schwebend' && state.ppType === 'schwebend' &&
          /-high$/.test(productData.handle || '')) {
        var standardHandle = productData.handle.replace(/-high$/, '');
        var hasStandard = false;
        for (var siHandle = 0; siHandle < productsList.length; siHandle++) {
          if (productsList[siHandle].handle === standardHandle) { hasStandard = true; break; }
        }
        if (hasStandard) {
          var requestedPP = btn.dataset.ppType;
          switchProduct(standardHandle);
          state.ppType = requestedPP;
          syncPPForFrameType();
          syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
          togglePPOptions();
          update();
          return;
        }
      }

      // Sonderfall Schwebend: nur auf -high Rahmen verfügbar.
      if (btn.dataset.ppType === 'schwebend') {
        var currentHandle = productData.handle || '';
        var isHighFrame = /-high$/.test(currentHandle);

        if (isHighFrame) {
          // Direkt setzen (kein Dialog).
          setActiveButton(ppTypeOptions, btn);
          state.ppType = 'schwebend';
          if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
          togglePPOptions();
          update();
          return;
        }

        // Existiert <handle>-high?
        var highHandle = currentHandle + '-high';
        var hasHighVariant = false;
        for (var pi = 0; pi < productsList.length; pi++) {
          if (productsList[pi].handle === highHandle) { hasHighVariant = true; break; }
        }

        if (hasHighVariant) {
          openSchwebendMismatch({ mode: 'switch-to-high', targetHandle: highHandle });
        } else {
          // Liste alternativer -high Rahmen anbieten.
          var altHighFrames = [];
          for (var ai = 0; ai < productsList.length; ai++) {
            if (/-high$/.test(productsList[ai].handle)) altHighFrames.push(productsList[ai]);
          }
          if (altHighFrames.length > 0) {
            openSchwebendMismatch({ mode: 'pick-alternative', alternatives: altHighFrames });
          } else {
            console.warn('[FrameConfigurator] No -high frames available for Schwebend.');
          }
        }
        return;
      }

      setActiveButton(ppTypeOptions, btn);
      state.ppType = btn.dataset.ppType;
      track('mat_select', { nach: state.ppType, breite: state.matWidth, farbe: state.matColor });
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      togglePPOptions();
      update();
    });

    /* --- Passepartout Info Panel --- */
    (function () {
      var infoBtn = document.getElementById('fc-pp-type-info-btn');
      var infoPanel = document.getElementById('fc-pp-type-info-panel');
      var infoOverlay = document.getElementById('fc-pp-type-info-overlay');
      var infoClose = document.getElementById('fc-pp-type-info-close');
      if (!infoBtn || !infoPanel) return;

      function openPanel() {
        infoPanel.classList.add('is-open');
        infoPanel.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closePanel() {
        infoPanel.classList.remove('is-open');
        infoPanel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      infoBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel();
      });
      if (infoClose) infoClose.addEventListener('click', closePanel);
      if (infoOverlay) infoOverlay.addEventListener('click', closePanel);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && infoPanel.classList.contains('is-open')) closePanel();
      });
    })();

    ppWidthOptions.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-width]');
      if (!btn) return;
      setActiveButton(ppWidthOptions, btn);
      state.matWidth = btn.dataset.ppWidth;
      toggleIndividualInputs();
      update();
    });

    ppColorGrid.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-mat-color]');
      if (!swatch) return;
      setActiveSwatch(ppColorGrid, swatch);
      state.matColor = swatch.dataset.matColor;
      ppColorHint.textContent = swatch.dataset.matDisplayName || '';
      update();
    });

    // Color swatch "show all" toggle
    var ppColorToggle = document.getElementById('fc-pp-color-toggle');
    var ppColorFilterLabel = document.querySelector('.fc-pp-color-filter');
    if (ppColorToggle && ppColorGrid) {
      ppColorToggle.addEventListener('click', function () {
        var isCollapsed = ppColorGrid.classList.contains('fc-color-grid--collapsed');
        ppColorGrid.classList.toggle('fc-color-grid--collapsed');
        if (isCollapsed) {
          ppColorToggle.innerHTML = '\u2190 Weniger anzeigen';
          if (ppColorFilterLabel) ppColorFilterLabel.textContent = '';
        } else {
          var total = ppColorGrid.querySelectorAll('.fc-swatch').length;
          ppColorToggle.innerHTML = '\u2192 Alle ' + total + ' Farben anzeigen';
          if (ppColorFilterLabel) ppColorFilterLabel.textContent = '';
        }
        // Recalc accordion height
        var ppContent = document.querySelector('#fc-step-pp .fc-step__content');
        if (ppContent && document.querySelector('#fc-step-pp').classList.contains('fc-step--open')) {
          ppContent.style.maxHeight = 'none';
        }
      });
    }

    if (typeCardsContainer) {
      typeCardsContainer.addEventListener('click', function (e) {
        var card = e.target.closest('.fc-type-card');
        if (!card || !card.dataset.typeValue) return;
        toggleStep('size');
        handleTypeSwitch(card.dataset.typeValue);
      });

      // Keyboard support: arrow keys for radiogroup pattern
      typeCardsContainer.addEventListener('keydown', function (e) {
        var cards = typeCardsContainer.querySelectorAll('.fc-type-card');
        if (!cards.length) return;
        var currentIndex = -1;
        for (var ci = 0; ci < cards.length; ci++) {
          if (cards[ci].classList.contains('fc-type-card--selected')) {
            currentIndex = ci;
            break;
          }
        }
        var newIndex = currentIndex;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          newIndex = (currentIndex + 1) % cards.length;
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = (currentIndex - 1 + cards.length) % cards.length;
        }
        if (newIndex !== currentIndex && cards[newIndex]) {
          cards[newIndex].focus();
          handleTypeSwitch(cards[newIndex].dataset.typeValue);
        }
      });
    }

    // Cross-link trigger: toggle expand/collapse
    if (crossLinkTrigger) {
      crossLinkTrigger.addEventListener('click', function () {
        var isOpen = crossLinkCards.style.display !== 'none';
        crossLinkCards.style.display = isOpen ? 'none' : '';
        crossLinkTrigger.classList.toggle('fc-cross-link__trigger--open', !isOpen);
      });
    }

    // Cross-link card click: navigate to counterpart product
    if (crossLinkCards) {
      crossLinkCards.addEventListener('click', function (e) {
        var card = e.target.closest('[data-cross-type]');
        if (!card) return;
        var targetHandle = card.dataset.crossHandle;
        var targetType = card.dataset.crossType;
        if (isProductPage || isConfiguratorPage) {
          // Set frameType in URL so switchProduct picks it up
          var params = new URLSearchParams(window.location.search);
          params.set('frameType', targetType);
          params.delete('variant');
          if (isProductPage) {
            params.delete('product');
            window.history.pushState({ fcHandle: targetHandle }, '', '/products/' + targetHandle + '?' + params.toString());
          } else {
            params.set('product', targetHandle);
            window.history.pushState({ fcHandle: targetHandle }, '', window.location.pathname + '?' + params.toString());
          }
          switchProduct(targetHandle);
        }
      });
    }

    if (productCardsEl) {
      // Swatch click → switch product
      productCardsEl.addEventListener('click', function (e) {
        var swatch = e.target.closest('.fc-frame-swatch');
        if (swatch && swatch.dataset.handle) {
          track('frame_select', { von: productData.handle, nach: swatch.dataset.handle });
          switchProduct(swatch.dataset.handle);
          return;
        }
        // Filter tab click
        var tab = e.target.closest('.fc-frame-tab');
        if (tab && tab.dataset.filter) {
          _activeFilterTab = tab.dataset.filter;
          // Update tab active states
          var tabs = productCardsEl.querySelectorAll('.fc-frame-tab');
          for (var i = 0; i < tabs.length; i++) {
            tabs[i].classList.toggle('fc-frame-tab--active', tabs[i].dataset.filter === _activeFilterTab);
          }
          // Filter swatches
          var swatches = productCardsEl.querySelectorAll('.fc-frame-swatch');
          for (var i = 0; i < swatches.length; i++) {
            var s = swatches[i];
            var colors = (s.dataset.colors || '').split(',');
            if (_activeFilterTab === 'Alle' || colors.indexOf(_activeFilterTab) !== -1) {
              s.classList.remove('fc-frame-swatch--hidden');
            } else {
              s.classList.add('fc-frame-swatch--hidden');
            }
          }
        }
      });
      // Swatch hover → show tooltip with frame name
      productCardsEl.addEventListener('mouseover', function (e) {
        var swatch = e.target.closest('.fc-frame-swatch');
        if (swatch && swatch.dataset.title) {
          swatch.title = swatch.dataset.title;
        }
      });
    }

    var debouncedUpdate = debounce(update, 200);

    widthInput.addEventListener('input', function () {
      state.imageWidth = parseFloat(widthInput.value) || 10;
      _sizeEntered.w = parseFloat(widthInput.value) > 0;
      if (sizeSliderInput) sizeSliderInput.value = state.imageWidth;
      _sizeTouched = true;
      // Auto-calculate height from aspect ratio
      if (state.imageAspectRatio && isAutoAspectType()) {
        var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
        autoH = Math.max(10, Math.min(110, autoH));
        state.imageHeight = autoH;
        if (heightInput) heightInput.value = autoH;
      }
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      debouncedUpdate();
    });

    heightInput.addEventListener('input', function () {
      state.imageHeight = parseFloat(heightInput.value) || 10;
      _sizeEntered.h = parseFloat(heightInput.value) > 0;
      _sizeTouched = true;
      // Auto-calculate width from aspect ratio
      if (state.imageAspectRatio && isAutoAspectType()) {
        var autoW = Math.round(state.imageHeight * state.imageAspectRatio);
        autoW = Math.max(10, Math.min(110, autoW));
        state.imageWidth = autoW;
        if (widthInput) widthInput.value = autoW;
        if (sizeSliderInput) sizeSliderInput.value = autoW;
      }
      if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
      debouncedUpdate();
    });

    // Klick/Fokus ins Breite- oder Höhe-Feld → kompletten Wert markieren,
    // damit die neue Zahl den alten Wert ersetzt statt sich anzuhängen.
    [widthInput, heightInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;        // Touch/Pen: nativer Fokus + focus-Handler reichen
        if (document.activeElement === input) return; // schon fokussiert → Caret setzen erlauben
        e.preventDefault();                           // unterdrückt mousedown/mouseup, die die Auswahl sofort aufheben würden
        input.focus();
      });
      input.addEventListener('focus', function () {
        setTimeout(function () {
          try { input.select(); } catch (e) { /* number inputs in älteren Browsern */ }
        }, 0);
      });
    });

    // Size slider — drives width (+ auto-height) for digital types
    if (sizeSliderInput) {
      sizeSliderInput.addEventListener('input', function () {
        var maxW = getSliderMaxWidth(state.imageAspectRatio);
        var val = Math.min(parseFloat(sizeSliderInput.value) || 30, maxW);
        state.imageWidth = val;
        _sizeTouched = true;
        if (widthInput) widthInput.value = val;
        if (state.imageAspectRatio && isAutoAspectType()) {
          var autoH = Math.round(val / state.imageAspectRatio);
          autoH = Math.max(10, Math.min(110, autoH));
          state.imageHeight = autoH;
          if (heightInput) heightInput.value = autoH;
        }
        if (!_userHasConfigured) { _userHasConfigured = true; reorderDesktopGallerySlides(); reorderMobileGallerySlides(); refreshGalleryAfterReorder(true); }
        debouncedUpdate();
      });
    }

    var matTopInput = document.getElementById('fc-mat-top');
    var matBottomInput = document.getElementById('fc-mat-bottom');
    var matSidesInput = document.getElementById('fc-mat-sides');

    [matTopInput, matBottomInput, matSidesInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        state.individualSizes = {
          top: parseFloat(matTopInput.value) || 2,
          bottom: parseFloat(matBottomInput.value) || 2,
          leftRight: parseFloat(matSidesInput.value) || 2
        };
        debouncedUpdate();
      });
    });

    /* --- UPLOAD EVENT HANDLERS --- */

    if (uploadDropzone && uploadInput) {
      // Click on dropzone opens file dialog
      uploadDropzone.addEventListener('click', function (e) {
        // Don't open dialog when clicking action buttons
        if (e.target.closest('.fc-upload__action-btn')) return;
        uploadInput.click();
      });

      // File input change
      uploadInput.addEventListener('change', function () {
        var file = uploadInput.files && uploadInput.files[0];
        if (file) uploadFile(file);
      });

      // Drag & Drop
      uploadDropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.add('fc-upload__dropzone--dragover');
      });

      uploadDropzone.addEventListener('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.remove('fc-upload__dropzone--dragover');
      });

      uploadDropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadDropzone.classList.remove('fc-upload__dropzone--dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) uploadFile(file);
      });

      // Change button — re-opens file dialog
      if (uploadChangeBtn) {
        uploadChangeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          uploadInput.click();
        });
      }

      // Remove button — clears image and resets upload UI
      if (uploadRemoveBtn) {
        uploadRemoveBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          state.imageUrl = null;
          state.isPlaceholder = false;
          try { sessionStorage.removeItem('fc-placeholder-url'); } catch (err) { /* ignore */ }
          try { sessionStorage.removeItem('fc-placeholder-ratio'); } catch (err) { /* ignore */ }
          resetUploadUI();
          // Restore original image order (1st product image back to front)
          reorderDesktopGallerySlides();
          reorderMobileGallerySlides();
          refreshGalleryAfterReorder();
          update();
          if (typeof updateUploadStepStatus === 'function') updateUploadStepStatus();
          // Re-open popup for fresh choice (if on rahmen-product template)
          _popupEvaluated = false;
          openUploadPopup();
        });
      }

      // Rotate button — rotates image 90° clockwise via canvas
      if (uploadRotateBtn) {
        uploadRotateBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          // Prefer localBlobUrl (CORS-safe) over Firebase HTTPS URL
          var srcUrl = state.localBlobUrl || state.imageUrl;
          if (!srcUrl) return;
          var img = new Image();
          // Only set crossOrigin for HTTP URLs, not for blob: URLs
          if (srcUrl.indexOf('blob:') !== 0) {
            img.crossOrigin = 'anonymous';
          }
          img.onerror = function () {
            showUploadError('Bild konnte nicht gedreht werden.');
          };
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = img.naturalHeight;
            canvas.height = img.naturalWidth;
            var ctx = canvas.getContext('2d');
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(Math.PI / 2);
            ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
            try {
              canvas.toBlob(function (blob) {
                if (!blob) { showUploadError('Drehen fehlgeschlagen.'); return; }
                var rotatedFile = new File([blob], 'rotated.jpg', { type: 'image/jpeg' });
                if (state.imageAspectRatio) {
                  state.imageAspectRatio = 1 / state.imageAspectRatio;
                }
                uploadFile(rotatedFile);
              }, 'image/jpeg', 0.92);
            } catch (err) {
              showUploadError('Drehen fehlgeschlagen.');
            }
          };
          img.src = srcUrl;
        });
      }

      // Crop button — opens crop overlay modal
      if (uploadCropBtn) {
        uploadCropBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          // Prefer localBlobUrl (CORS-safe) over Firebase HTTPS URL
          var srcUrl = state.localBlobUrl || state.imageUrl;
          if (!srcUrl) return;
          openCropOverlay(srcUrl);
        });
      }
    }

    /* --- UPLOAD BUTTON HANDLER --- */
    if (uploadBtn && uploadInput) {
      uploadBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        uploadInput.click();
      });
    }

    /* --- VIEW TOGGLE HANDLER (scroll ↔ grid) --- */
    if (viewToggle && productCardsEl) {
      viewToggle.addEventListener('click', function () {
        var isScroll = productCardsEl.classList.contains('fc-product-cards--scroll');
        productCardsEl.classList.toggle('fc-product-cards--scroll', !isScroll);
        productCardsEl.classList.toggle('fc-product-cards--grid', isScroll);
        setTimeout(updateScrollArrows, 50);
      });
    }

    /* --- SCROLL ARROWS FOR PRODUCT CARDS --- */
    var arrowPrev = document.getElementById('fc-cards-arrow-prev');
    var arrowNext = document.getElementById('fc-cards-arrow-next');

    function updateScrollArrows() {
      if (!productCardsEl || !arrowPrev || !arrowNext) return;
      var isScrollMode = productCardsEl.classList.contains('fc-product-cards--scroll');
      if (!isScrollMode) {
        arrowPrev.hidden = true;
        arrowNext.hidden = true;
        return;
      }
      var scrollLeft = productCardsEl.scrollLeft;
      var maxScroll = productCardsEl.scrollWidth - productCardsEl.clientWidth;
      arrowPrev.hidden = scrollLeft <= 2;
      arrowNext.hidden = maxScroll <= 2 || scrollLeft >= maxScroll - 2;
    }

    if (productCardsEl && arrowPrev && arrowNext) {
      productCardsEl.addEventListener('scroll', debounce(updateScrollArrows, 100));
      window.addEventListener('resize', debounce(updateScrollArrows, 200));

      arrowPrev.addEventListener('click', function () {
        productCardsEl.scrollBy({ left: -220, behavior: 'smooth' });
      });
      arrowNext.addEventListener('click', function () {
        productCardsEl.scrollBy({ left: 220, behavior: 'smooth' });
      });

      // Observe size changes so arrows update when cards render or images load
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(debounce(updateScrollArrows, 50)).observe(productCardsEl);
      }
    }

    /* --- SUSPENSION EVENT HANDLERS --- */
    /**
     * Updatet den dedizierten Aufhängungs-Slide (#fc-suspension-image / -thumbnail)
     * mit dem im Button hinterlegten data-suspension-image. Wenn der Slide nicht
     * existiert (= keine Section-Bilder konfiguriert), passiert nichts.
     * @param {HTMLElement} btn  Aktiver Suspension-Button
     * @param {boolean} jumpTo   Wenn true, springt die Galerie zum Aufhängungs-Slide
     */
    function applySuspensionImage(btn, jumpTo) {
      var slideImg = document.getElementById('fc-suspension-image');
      var thumbImg = document.getElementById('fc-suspension-thumbnail');
      var mobileSusImg = document.getElementById('fc-mobile-suspension-image');
      var newImg = btn ? (btn.getAttribute('data-suspension-image') || '') : '';
      if (newImg) {
        if (slideImg) slideImg.setAttribute('src', newImg);
        if (thumbImg) thumbImg.setAttribute('src', newImg);
        if (mobileSusImg) mobileSusImg.setAttribute('src', newImg);
      }

      if (jumpTo) {
        // Desktop: jump to suspension slide via media-gallery API
        if (slideImg) {
          var slideEl = slideImg.closest('[data-media-id]');
          if (slideEl && !slideEl.classList.contains('is-active')) {
            var mediaId = slideEl.getAttribute('data-media-id');
            var gallery = slideEl.closest('media-gallery');
            if (gallery && typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(mediaId, false, true);
            }
          }
        }
        // Mobile: scroll the mobile preview carousel to the suspension slide
        if (mobileSusImg && mobilePreviewSlider) {
          var susSlide = mobileSusImg.closest('.fc-mobile-preview__slide');
          if (susSlide) {
            susSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        }
      }
    }

    if (suspensionOptions) {
      suspensionOptions.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-suspension]');
        if (!btn || btn.disabled) return;
        setActiveButton(suspensionOptions, btn);
        state.suspension = btn.dataset.suspension;
        if (suspensionHint) {
          suspensionHint.textContent = SUSPENSION_INFO[state.suspension] || '';
        }
        applySuspensionImage(btn, true);
        updateStepSubtitles();
      });

      // Initial: aktive Auswahl ins Slide übernehmen, ohne dorthin zu springen
      var _initActive = suspensionOptions.querySelector('.fc-option-btn--active[data-suspension]');
      if (_initActive) applySuspensionImage(_initActive, false);
    }

    atcButton.addEventListener('click', addToCart);

    /* --- MOBILE STICKY ELEMENTS SETUP --- */

    // Measure header height and set CSS variable for split-screen layout
    function setHeaderHeight() {
      var header = document.querySelector('sticky-header');
      var h = header ? header.offsetHeight : 68;
      document.documentElement.style.setProperty('--fc-header-height', h + 'px');
    }
    setHeaderHeight();
    if (isMobileQuery.matches) {
      // Also trigger initial mobile preview sync
      updateMobilePreview();
    }
    window.addEventListener('resize', debounce(setHeaderHeight, 200));

    // Keep header always visible on configurator page (disable hide-on-scroll)
    (function () {
      var stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      // Remove the scroll handler that hides/shows the header
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
      }
      // Ensure header stays in sticky-visible state
      stickyHeader.classList.remove('shopify-section-header-hidden');
      stickyHeader.classList.add('shopify-section-header-sticky');
      // Prevent future hide calls
      stickyHeader.hide = function () {};
    })();

    /* --- ADD TO CART --- */

    function addToCart() {
      if (!state.currentVariant) return;

      // Check required upload
      if (isUploadRequired() && !state.imageUrl) {
        atcError.textContent = 'Bitte lade zuerst dein Bild hoch.';
        atcError.style.display = '';
        if (uploadGroup) {
          uploadGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          uploadGroup.classList.add('fc-upload--missing');
        }
        return;
      }

      var variant = state.currentVariant;
      atcButton.disabled = true;
      atcButton.querySelector('.fc-atc__text').style.display = 'none';
      atcButton.querySelector('.fc-atc__loading').style.display = '';
      atcError.style.display = 'none';

      var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

      var susLabel = state.suspension === 'wallbuddies' ? 'Wall Buddies' : (state.suspension.charAt(0).toUpperCase() + state.suspension.slice(1));

      var properties = {
        'Bildgr\u00f6\u00dfe': state.imageWidth + ' \u00D7 ' + state.imageHeight + ' cm',
        'Aufh\u00e4ngung': susLabel
      };

      if (state.ppType !== 'ohne') {
        properties['Passepartout-Farbe'] = matColorOption ? matColorOption.displayName : state.matColor;
        properties['Passepartout-Breite'] = state.matWidth === 'individual'
          ? state.individualSizes.top + ' / ' + state.individualSizes.bottom + ' / ' + state.individualSizes.leftRight + ' cm'
          : getMatPresetDescription(state.matWidth);
      }

      // Hidden properties for cart SVG rendering (prefixed with _ to hide from checkout)
      if (state.imageUrl) {
        properties['_imageUrl'] = state.imageUrl;
      }

      // SVG render data for cart preview (compact JSON, no mat_color_options to stay under 5000 char limit)
      var svgRenderPayload = {
        customer_image_url: state.imageUrl || null,
        frame_product_id: productData.productId,
        frame_name: productData.title,
        mat_color: state.matColor,
        mat_width: state.matWidth,
        rotation: 0,
        dimensions: { width: state.imageWidth, height: state.imageHeight },
        frame_texture_lr: productData.frameImageLR,
        frame_texture_tb: productData.frameImageTB,
        frame_width_mm: productData.frameBreiteMM,
        passepartout_type: state.ppType
      };
      if (matColorOption) {
        svgRenderPayload.mat_color_url = {
          url: matColorOption.imageUrl,
          color_key: matColorOption.color,
          display_name: matColorOption.displayName
        };
      }
      properties['_SVG-Render-Data'] = JSON.stringify(svgRenderPayload);

      var body = {
        items: [{
          id: variant.id,
          quantity: 1,
          properties: properties
        }]
      };

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || err.message || 'Fehler beim Hinzuf\u00fcgen');
          });
        }
        return response.json();
      })
      .then(function (data) {
        /* GA4-Form: currency/value/items werden vom Tag direkt durchgereicht.
           Die framelin-Dimensionen daneben sind unsere eigenen. */
        track('add_to_cart', {
          value: variant.price,
          items: [{
            item_id: productData.handle,
            item_name: productData.title,
            item_variant: variant.id,
            price: variant.price,
            quantity: 1
          }],
          leiste: productData.handle,
          rahmentyp: state.frameType,
          passepartout: state.ppType,
          breite_cm: state.imageWidth,
          hoehe_cm: state.imageHeight,
          mit_bild: !!state.imageUrl,
          quelle: 'frame-configurator'
        });

        // Generate SVG markup for cart preview (same logic as renderPreview)
        var cartSvgMarkup = null;
        if (typeof window.generateFramePreviewSvg === 'function') {
          var cartMatType = 'none';
          if (state.ppType === 'einfach') cartMatType = 'standard';
          if (state.ppType === 'freigestellt') cartMatType = 'inner';
          var cartIndividualSizes = null;
          if (state.matWidth === 'individual') {
            cartIndividualSizes = {
              top: state.individualSizes.top,
              bottom: state.individualSizes.bottom,
              left: state.individualSizes.leftRight,
              right: state.individualSizes.leftRight
            };
          }
          try {
            cartSvgMarkup = window.generateFramePreviewSvg({
              imageUrl: state.imageUrl || '',
              frameConfig: {
                productId: productData.productId,
                frameImageLR: productData.frameImageLR || '',
                frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
                frameWidth: productData.frameBreiteMM || 24
              },
              matConfig: {
                type: cartMatType,
                width: state.matWidth,
                color: state.matColor,
                colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
                individualSizes: cartIndividualSizes
              },
              dimensions: { width: state.imageWidth, height: state.imageHeight },
              rotation: 0
            });
          } catch (svgErr) {
            console.warn('[FrameConfigurator] Could not generate cart SVG:', svgErr);
          }
        }

        // Persist cart SVG render data
        var lineItemKey = String(variant.id) + '-' + Date.now();
        persistCartSvgRenderData(lineItemKey, {
          customer_image_url: state.imageUrl || null,
          frame_product_id: productData.productId,
          frame_name: productData.title,
          mat_color: state.matColor,
          mat_width: state.matWidth,
          rotation: 0,
          dimensions: { width: state.imageWidth, height: state.imageHeight },
          frame_texture_lr: productData.frameImageLR,
          frame_texture_tb: productData.frameImageTB,
          frame_width_mm: productData.frameBreiteMM,
          mat_color_url: matColorOption
            ? { url: matColorOption.imageUrl, color_key: matColorOption.color, display_name: matColorOption.displayName }
            : { url: '', color_key: state.matColor, display_name: state.matColor },
          mat_color_options: SHARED_MAT_COLOR_OPTIONS,
          svg_html: null,
          svg_markup: cartSvgMarkup,
          passepartout_type: state.ppType
        });

        // Publish cart update for theme mini-cart (pubsub.js)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'frame-configurator',
            productVariantId: variant.id,
            cartData: data
          });
        }

        // Open mini-cart or redirect
        var miniCart = document.querySelector('mini-cart') || document.querySelector('cart-drawer');
        if (miniCart && miniCart.renderContents) {
          fetch(window.location.pathname + '?sections=mini-cart,cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) { miniCart.renderContents({ sections: sections }); })
            .catch(function () { window.location.href = root + 'cart'; });
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (err) {
        atcError.textContent = err.message || 'Ein Fehler ist aufgetreten.';
        atcError.style.display = '';
      })
      .finally(function () {
        atcButton.disabled = false;
        atcButton.querySelector('.fc-atc__text').style.display = '';
        atcButton.querySelector('.fc-atc__loading').style.display = 'none';
      });
    }

    /* --- INITIALIZATION (single path, no double update) --- */

    // 1. Render product switcher, type cards + mat color swatches
    renderProductSwitcher();
    // Ensure frame info box is populated even when product switcher is hidden (single product)
    updateFrameInfoBox(productData);
    renderTypeCards();
    renderMatColorSwatches();

    // 2. Read URL params and set state
    var params = new URLSearchParams(window.location.search);
    if (params.get('frameType')) {
      // Normalized match: "Leinwand nicht aufgespannt" matches "Leinwand (nicht aufgespannt)" etc.
      var urlTypeNorm = normalizeTypeKey(params.get('frameType'));
      var matchedType = null;
      for (var fti = 0; fti < frameTypeValues.length; fti++) {
        if (normalizeTypeKey(frameTypeValues[fti]) === urlTypeNorm) {
          matchedType = frameTypeValues[fti];
          break;
        }
      }
      if (matchedType) state.frameType = matchedType;
    }
    if (params.get('ppType')) state.ppType = params.get('ppType');
    if (params.get('matWidth')) state.matWidth = params.get('matWidth');
    if (params.get('matColor')) state.matColor = params.get('matColor');
    /* Masse aus der URL zaehlen nur bei einem Einsende-Typ und masse=1 als
       eingetragen — sonst sind es Voreinstellungen (Digital, verlinkte Kacheln). */
    var _urlSendIn = params.get('frameType') !== null && params.get('masse') === '1' && isSendInType();
    if (params.get('width')) { state.imageWidth = parseFloat(params.get('width')) || 30; _sizeEntered.w = _urlSendIn; }
    if (params.get('height')) { state.imageHeight = parseFloat(params.get('height')) || 40; _sizeEntered.h = _urlSendIn; }
    // Individual PP sizes from URL params (set during product switch)
    if (params.get('matTop')) {
      state.individualSizes.top = parseFloat(params.get('matTop')) || 5.5;
      state.individualSizes.bottom = parseFloat(params.get('matBottom')) || 6;
      state.individualSizes.leftRight = parseFloat(params.get('matSides')) || 5.5;
    }

    // 2b. Restore uploaded image from sessionStorage (set by switchProduct before navigation)
    try {
      var transferredImageUrl = sessionStorage.getItem('fc-transfer-imageUrl');
      if (transferredImageUrl) {
        sessionStorage.removeItem('fc-transfer-imageUrl');
        state.imageUrl = transferredImageUrl;
      }
    } catch (e) { /* sessionStorage not available */ }

    // 2c. Re-render type cards so the URL-param frameType is visually selected
    renderTypeCards();

    // 2d. Restore frameType from session (persisted across product page navigations)
    var _hasTypeFromUrl = params.get('frameType') !== null;
    if (_hasTypeFromUrl) {
      _wizardCompleted = true; // type already chosen via URL
    } else {
      try {
        var savedFrameType = sessionStorage.getItem('fc-frameType');
        if (savedFrameType) {
          // Match against available types on this product
          var savedNorm = normalizeTypeKey(savedFrameType);
          for (var sti = 0; sti < frameTypeValues.length; sti++) {
            if (normalizeTypeKey(frameTypeValues[sti]) === savedNorm) {
              state.frameType = frameTypeValues[sti];
              _wizardCompleted = true;
              break;
            }
          }
        }
      } catch (e) { /* ignore */ }
    }
    toggleStep('upload');

    // Show Bildart display if type was restored from session/URL
    updateBildartDisplay();

    // Open wizard popup immediately if multi-type product and no type pre-selected.
    // This must happen BEFORE the IDB callback so the wizard is the very first thing shown.
    if (wizardNeeded()) {
      openWizardPopup();
    }

    // 3. Sync UI to state
    syncButtonState(ppTypeOptions, 'data-pp-type', state.ppType);
    syncButtonState(ppWidthOptions, 'data-pp-width', state.matWidth);
    syncPPForFrameType();
    togglePPOptions();
    toggleIndividualInputs();
    widthInput.value = state.imageWidth;
    heightInput.value = state.imageHeight;
    // Sync individual PP size inputs
    if (params.get('matTop')) {
      if (matTopInput) matTopInput.value = state.individualSizes.top;
      if (matBottomInput) matBottomInput.value = state.individualSizes.bottom;
      if (matSidesInput) matSidesInput.value = state.individualSizes.leftRight;
    }
    // Restore upload preview from sessionStorage or IndexedDB
    // sessionStorage is set during product switch OR favorites "Konfigurieren" click
    var _imageFromSessionStorage = false;
    if (state.imageUrl) {
      _userHasConfigured = true;
      _imageFromSessionStorage = true;
      showUploadPreview(state.imageUrl);
      // Reorder gallery for restored upload and scroll to SVG preview
      reorderDesktopGallerySlides();
      reorderMobileGallerySlides();
      refreshGalleryAfterReorder(true);
    }
    loadImageFromIDB(function (data) {
      // Restore Firebase URL from IndexedDB if not already set via sessionStorage
      if (!state.imageUrl && data.firebaseUrl) {
        _userHasConfigured = true;
        state.imageUrl = data.firebaseUrl;
        showUploadPreview(state.imageUrl);
        reorderDesktopGallerySlides();
        reorderMobileGallerySlides();
        refreshGalleryAfterReorder(true);
      }
      // Restore blob for CORS-safe rotate/crop
      if (data.blob) {
        if (state.localBlobUrl) URL.revokeObjectURL(state.localBlobUrl);
        state.localBlobUrl = URL.createObjectURL(data.blob);
        // If state.imageUrl is still empty, use blob URL for SVG rendering
        if (!state.imageUrl) {
          _userHasConfigured = true;
          state.imageUrl = state.localBlobUrl;
          reorderDesktopGallerySlides();
          reorderMobileGallerySlides();
          refreshGalleryAfterReorder(true);
        }
        // Only update thumbnail to IndexedDB blob if no image was passed via sessionStorage
        // (sessionStorage image = favorite's specific image, should not be overwritten)
        if (!_imageFromSessionStorage) {
          showUploadPreview(state.localBlobUrl);
        }
      }
      // Recalculate aspect ratio and re-render preview with restored image
      if (state.imageUrl || state.localBlobUrl) {
        var restoredImg = new Image();
        restoredImg.onload = function () {
          if (restoredImg.naturalWidth && restoredImg.naturalHeight) {
            state.imageAspectRatio = restoredImg.naturalWidth / restoredImg.naturalHeight;
            syncSizeSlider();
            if (isAutoAspectType()) {
              var maxW = getSliderMaxWidth(state.imageAspectRatio);
              if (state.imageWidth > maxW) state.imageWidth = maxW;
              if (widthInput) widthInput.value = state.imageWidth;
              var autoH = Math.round(state.imageWidth / state.imageAspectRatio);
              autoH = Math.max(10, Math.min(110, autoH));
              state.imageHeight = autoH;
              if (heightInput) heightInput.value = autoH;
            }
          }
          // Always re-render after image restore (update() ran before IDB callback)
          update();
        };
        restoredImg.crossOrigin = 'anonymous';
        restoredImg.src = state.localBlobUrl || state.imageUrl;
      }

      // Popup evaluation — after all restore paths completed.
      // Only trigger once per init; the popup DOM may not exist on other templates.
      // Skip if wizard popup is already open (wizard handles the transition to upload).
      if (!_popupEvaluated && _wizardCompleted) {
        _popupEvaluated = true;
        if (!state.imageUrl && !state.localBlobUrl) {
          var phUrl = null, phRatio = null;
          try {
            phUrl = sessionStorage.getItem('fc-placeholder-url');
            phRatio = parseFloat(sessionStorage.getItem('fc-placeholder-ratio')) || null;
          } catch (e) { /* sessionStorage unavailable */ }
          if (phUrl) {
            // Restore previously selected placeholder silently (no popup)
            selectPlaceholder(phUrl, phRatio);
          } else {
            openUploadPopup();
          }
        }
      }
      // Update upload step indicator (check icon + subtitle) after restore
      if (typeof updateUploadStepStatus === 'function') updateUploadStepStatus();
    });

    var activeSwatch = ppColorGrid.querySelector('[data-mat-color="' + state.matColor + '"]');
    if (activeSwatch) {
      setActiveSwatch(ppColorGrid, activeSwatch);
      ppColorHint.textContent = activeSwatch.dataset.matDisplayName || '';
    }

    // 4. Single initial update (triggers variant lookup + price + SVG preview)
    update();
    bindUploadPopup();
    _initialized = true;

    // 4a. Proactive variant loading for initial product if truncated
    if (productIsTruncated && storefrontConfig.token && !allProductVariantIndexes[productData.handle + '__full']) {
      priceEl.textContent = 'Lade Preise\u2026';
      if (mobileInfoPrice) mobileInfoPrice.textContent = 'Lade\u2026';
      atcButton.disabled = true;
      var initHandle = productData.handle;
      lazyFetchVariants(initHandle, productData.productId, function (newIndex) {
        if (productData.handle !== initHandle) return;
        variantIndex = newIndex;
        productIsTruncated = false;
        update();
      });
    }

    // 4b. Populate mobile preview gallery with product images
    populateMobileGallery(productData.images);

    // 4c. Bind gallery thumbnails with user-click tracking
    reBindGalleryThumbnails();

    // 4d. On configurator page: if URL has ?product=handle different from current,
    //     switch to that product immediately (client-side, no flash)
    if (isConfiguratorPage && params.get('product') && params.get('product') !== productData.handle) {
      switchProduct(params.get('product'));
    }

    // 4e. On product page: update URL with current state params (for browser back/forward)
    if (isProductPage) {
      var initParams = buildStateParams(productData.handle, null);
      initParams.delete('product');
      window.history.replaceState({ fcHandle: productData.handle }, '', window.location.pathname + '?' + initParams.toString());
    }

    // 4f. Handle browser back/forward for client-side product switches
    if (isProductPage || isConfiguratorPage) {
      window.addEventListener('popstate', function (e) {
        var targetHandle = null;
        if (e.state && e.state.fcHandle) {
          targetHandle = e.state.fcHandle;
        } else if (isProductPage) {
          // Extract handle from URL path: /products/<handle>
          var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
          if (pathMatch) targetHandle = pathMatch[1];
        } else {
          // Configurator page: read from ?product= param
          var params = new URLSearchParams(window.location.search);
          targetHandle = params.get('product');
        }
        if (targetHandle && targetHandle !== productData.handle) {
          // Temporarily treat as configurator to avoid infinite pushState loop
          var _origHandle = productData.handle;
          // Direct call to switch without pushState (popstate already changed URL)
          var targetProduct = null;
          for (var i = 0; i < productsList.length; i++) {
            if (productsList[i].handle === targetHandle) {
              targetProduct = productsList[i];
              break;
            }
          }
          if (targetProduct) {
            // Perform the switch inline (same as switchProduct but skip pushState)
            productData.frameImageLR = targetProduct.frameImageLR;
            productData.frameImageTB = targetProduct.frameImageTB || targetProduct.frameImageLR;
            productData.frameBreiteMM = targetProduct.frameBreiteMM;
            productData.frameHoeheMM = targetProduct.frameHoeheMM;
            productData.title = targetProduct.title;
            productData.handle = targetHandle;
            productData.productId = targetProduct.productId;
            productData.url = targetProduct.url;
            productData.priceMin = targetProduct.priceMin;
            productData.options = targetProduct.options;
            variantIndex = allProductVariantIndexes[targetHandle] || variantIndex;

            var newTypeKeys = [];
            if (targetProduct.options && Array.isArray(targetProduct.options)) {
              for (var oi = 0; oi < targetProduct.options.length; oi++) {
                var optName = (targetProduct.options[oi].name || '').toLowerCase();
                if (optName === 'typ' || optName === 'type' || optName === 'rahmentyp') {
                  newTypeKeys = targetProduct.options[oi].values || [];
                  break;
                }
              }
            }
            if (newTypeKeys.length === 0) newTypeKeys = Object.keys(variantIndex);
            var switchTruncated = isProductTruncated(targetProduct.options, variantIndex);
            productIsTruncated = switchTruncated;
            if (switchTruncated && storefrontConfig.token) {
              newTypeKeys = sortTypeValues(newTypeKeys);
            } else {
              newTypeKeys = sortTypeValues(newTypeKeys.filter(function (tv) {
                return tv === '_default' || variantIndex[tv];
              }));
            }
            if (newTypeKeys.length > 0 && newTypeKeys[0] !== '_default') {
              frameTypeValues = newTypeKeys;
              allTypeValues = newTypeKeys.slice();
              if (frameTypeValues.indexOf(state.frameType) === -1) {
                state.frameType = frameTypeValues[0];
              }
              renderTypeCards();
            }
            update();
            if (switchTruncated && storefrontConfig.token && !allProductVariantIndexes[targetHandle + '__full']) {
              var fetchHandle = targetHandle;
              lazyFetchVariants(fetchHandle, targetProduct.productId, function (newIndex) {
                if (productData.handle !== fetchHandle) return;
                variantIndex = newIndex;
                productIsTruncated = false;
                update();
              });
            }
            updateFrameInfoBox(targetProduct);
            updatePageInfo(targetProduct);
            populateMobileGallery(targetProduct.images);
            if (mobilePreviewSlider) mobilePreviewSlider.scrollTo({ left: 0, behavior: 'instant' });
            _userClickedThumbnail = false;
            if (!state.imageUrl) {
              var firstImgSlide = document.querySelector('.fc-page-product-image');
              if (firstImgSlide) {
                var mediaGallery = document.querySelector('media-gallery');
                if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
                  mediaGallery.setActiveMedia(firstImgSlide.dataset.mediaId, false, false);
                }
              }
            } else {
              scrollGalleryToPreview();
            }
            refreshGalleryAfterReorder();
            // Re-render product switcher to update active swatch
            renderProductSwitcher();
          }
        }
      });
    }

    // 5. Start on first product image (SVG preview is last slide,
    //    shown automatically when user uploads or configures)

    // 6. Gallery dots — horizontal scroll indicators (retry until slider is ready)
    (function tryInitDots(attempts) {
      if (attempts > 10) return;
      var slider = document.querySelector('.product__media-list');
      if (slider && slider.querySelectorAll('.product__media-item').length > 1) {
        initGalleryDots();
      } else {
        setTimeout(function () { tryInitDots(attempts + 1); }, 500);
      }
    })(0);

    /* ===================================================================
     * FAVORITES — Heart button integration (inside init scope for state access)
     * =================================================================== */

    /**
     * Build the current frameSpec object for favorites storage.
     * Same structure as used in renderPreview().
     */
    function getCurrentFrameSpec() {
      var matColorOption = SHARED_MAT_COLOR_OPTIONS.find(function (c) { return c.color === state.matColor; });

      var matType = 'none';
      if (state.ppType === 'einfach') matType = 'standard';
      if (state.ppType === 'freigestellt') matType = 'inner';

      var individualSizesForSpec = null;
      if (state.matWidth === 'individual') {
        individualSizesForSpec = {
          top: state.individualSizes.top,
          bottom: state.individualSizes.bottom,
          left: state.individualSizes.leftRight,
          right: state.individualSizes.leftRight
        };
      }

      return {
        imageUrl: state.imageUrl || '',
        frameConfig: {
          productId: productData.productId,
          frameImageLR: productData.frameImageLR || '',
          frameImageTB: productData.frameImageTB || productData.frameImageLR || '',
          frameWidth: productData.frameBreiteMM || 24
        },
        matConfig: {
          type: matType,
          width: state.matWidth,
          color: state.matColor,
          colorImageUrl: matColorOption ? matColorOption.imageUrl : null,
          individualSizes: individualSizesForSpec
        },
        dimensions: { width: state.imageWidth, height: state.imageHeight },
        rotation: 0
      };
    }

    function buildConfigUrl() {
      var params = buildStateParams(productData.handle, state.currentVariant ? state.currentVariant.id : null);
      return '/products/' + productData.handle + '?' + params.toString();
    }

    function handleFavoriteClick(btn) {
      if (typeof window.FramelinFavorites === 'undefined') {
        console.warn('[FrameConfigurator] FramelinFavorites not loaded');
        return;
      }

      btn.classList.add('fc-favorite-btn--saving');
      btn.disabled = true;

      // Build frameSpec, then resolve persistent image URL before saving
      var frameSpec = getCurrentFrameSpec();
      var imageUrl = frameSpec.imageUrl;

      // If imageUrl is a blob: URL, try to get the Firebase URL from IndexedDB instead
      function saveWithUrl(persistentUrl) {
        frameSpec.imageUrl = persistentUrl;

        var favoriteData = {
          productHandle: productData.handle,
          productTitle: productData.title,
          configUrl: buildConfigUrl(),
          frameSpec: frameSpec
        };

        window.FramelinFavorites.saveFavorite(favoriteData)
          .then(function () {
            setFavoriteButtonState(true);
            showFavoriteToast('Zu Favoriten hinzugef\u00fcgt!');
          })
          .catch(function (err) {
            if (err.message === 'duplicate') {
              showFavoriteToast('Bereits in deinen Favoriten.');
            } else {
              showFavoriteToast('Fehler beim Speichern. Bitte erneut versuchen.');
              console.warn('[FrameConfigurator] Save favorite error:', err);
            }
          })
          .finally(function () {
            btn.classList.remove('fc-favorite-btn--saving');
            btn.disabled = false;
          });
      }

      if (imageUrl && imageUrl.indexOf('blob:') === 0) {
        // Blob URL won't persist — try to get Firebase URL from IndexedDB
        loadImageFromIDB(function (data) {
          saveWithUrl(data.firebaseUrl || imageUrl);
        });
      } else {
        saveWithUrl(imageUrl);
      }
    }

    function setFavoriteButtonState(isFavorited) {
      var btns = document.querySelectorAll('.fc-favorite-btn');
      btns.forEach(function (btn) {
        if (isFavorited) {
          btn.classList.add('fc-favorite-btn--active');
          btn.setAttribute('aria-label', 'Aus Favoriten entfernen');
        } else {
          btn.classList.remove('fc-favorite-btn--active');
          btn.setAttribute('aria-label', 'Zu Favoriten hinzuf\u00fcgen');
        }
      });
    }

    function showFavoriteToast(message) {
      var existing = document.querySelector('.fc-favorite-toast');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.className = 'fc-favorite-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      toast.offsetHeight;
      toast.classList.add('fc-favorite-toast--visible');
      setTimeout(function () {
        toast.classList.remove('fc-favorite-toast--visible');
        setTimeout(function () { toast.remove(); }, 300);
      }, 2500);
    }

    function initFavoriteButton() {
      var btns = document.querySelectorAll('.fc-favorite-btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleFavoriteClick(btn);
        });
      });

      if (btns.length > 0 && typeof window.FramelinFavorites !== 'undefined') {
        var configUrl = buildConfigUrl();
        window.FramelinFavorites.isFavorited(configUrl)
          .then(function (favorited) {
            if (favorited) setFavoriteButtonState(true);
          })
          .catch(function () { /* silently ignore */ });
      }
    }

    // Expose for external use
    window.getFrameConfiguratorState = function () {
      return {
        frameSpec: getCurrentFrameSpec(),
        configUrl: buildConfigUrl(),
        productHandle: productData.handle,
        productTitle: productData.title
      };
    };

    // 7. Favorites — heart button integration
    initFavoriteButton();

    track('configurator_open', {
      leiste: productData.handle,
      produkt_id: productData.productId,
      rahmentyp: state.frameType,
      modus: fcMode
    });

    console.log('[FrameConfigurator] Initialized successfully.');
  }

  /* ===================================================================
   * BOOTSTRAP
   * =================================================================== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
